import * as Yup from 'yup';
import { DayOfWeek } from './types/SupportHours.js';
import { VehicleType } from './types/VehicleTypes.js';
import { getEnvVar } from './utils/internalUtils.js';

//  APP CONFIGS  //
const appDevConfig = {
    apiKey: 'AIzaSyBV8mADtM3r4SXEcB482mcSqYzTOaIGvTk',
    apiKeyBackend: 'AIzaSyAcUSpWKa_Ft4H1d9EM47P3PuWbNSnXT3s',
    authDomain: 'airdealer67669.firebaseapp.com',
    projectId: 'airdealer67669',
    storageBucket: 'airdealer67669.appspot.com',
    messagingSenderId: '484047561988',
    serviceAccountId: 'firebaseadminsdkdj19c@airdealer67669.iam.gserviceaccount.com',
};
const appStagingConfig = {
    apiKey: 'AIzaSyCwjVnFf7VD1_tskB5GqToM43xD3wW3auA',
    apiKeyBackend: 'AIzaSyBhg2la37LEyByeFmE1Dgtzv5eqfk9gRmY',
    authDomain: 'edstaging.firebaseapp.com',
    projectId: 'edstaging',
    storageBucket: 'edstaging.appspot.com',
    messagingSenderId: '705378449535',
    serviceAccountId: 'firebaseadminsdk96vr8@edstaging.iam.gserviceaccount.com',
};
const appJanusConfig = {
    apiKey: 'AIzaSyDDUmuZ2X_wvLB1j4WfVlMIu8BG9MWlKJE',
    apiKeyBackend: 'AIzaSyAypStZl3xCh1MfYSqStAZxvS4IyQ1AQHY',
    authDomain: 'janusproda3c47.firebaseapp.com',
    projectId: 'janusproda3c47',
    storageBucket: 'janusproda3c47.appspot.com',
    messagingSenderId: '233808214945',
    serviceAccountId: 'firebaseadminsdk3sur8@janusproda3c47.iam.gserviceaccount.com',
};
const appE2etestoemConfig = {
    apiKey: 'AIzaSyC1ErKhx0c_yQ4_yaKsRvS2F4F_eLsH6xM',
    apiKeyBackend: 'AIzaSyDKdzuft9uZ7CsivQfyTWUoUBt7o2TXI1s',
    authDomain: 'e2etestoemprod.firebaseapp.com',
    projectId: 'e2etestoemprod',
    storageBucket: 'e2etestoemprod.appspot.com',
    messagingSenderId: '67737516161',
    serviceAccountId: 'firebaseadminsdkr4o7r@e2etestoemprod.iam.gserviceaccount.com',
};
// MAP OF THE FIREBASE PROJECT APP CONFIGS
const appConfigMap = {
    // PRODUCTION CONFIGS
    e2etestoem: appE2etestoemConfig,
    janus: appJanusConfig,
    // DEVELOPMENT / STAGING CONFIGS
    staging: appStagingConfig,
    development: appDevConfig,
};
// CORS
// Cors options to only allow requests coming from these specific whitelisted domains
const localWhitelist = [
    'http://localhost:3000',
    'http://localhost:3001',
    'http://localhost:3002',
    'http://localhost:8080',
    'https://edtesting6.myshopify.com',
    'https://ekhodealerdemostore1.myshopify.com',
    'https://ed-testing-dev.myshopify.com',
    'https://testing-download-link.myshopify.com',
    'https://testingforekhodealer.blog',
];
// MAKE SURE THERE ARE NO TRAILING SLASHES ON THESE URLS
const whitelistOEMSites = [
    'https://janusmotorcycles.com',
    'https://janus-testing.com',
    'https://mokeinternational.com',
    'https://moke1stg.wpenginepowered.com',
    'https://landmoto.io',
    'https://livebyland.myshopify.com',
    'https://land-moto-sandbox.myshopify.com',
    'https://www.thepickman.com',
    'https://maeving.com',
    'https://us.maeving.com',
    'https://maeving-usa.myshopify.com',
    'https://my.janus-testing.com',
    'https://starkfuture.com',
    'https://api.starkfuture.com',
    'https://pplusev.com',
    'https://619295-76.myshopify.com', // TODO use correct Shopify site
    'https://www.naxeontech.com',
    'https://infinitemachine.com', // TODO add more once we learn about their e-commerce setup
    'https://www.dustmoto.com',
    'https://bakcou.com',
    'https://bakcouebikes.myshopify.com',
    'https://www.niu.com',
    'https://www.global.niu.com',
    'https://www.shop.niu.com',
    'https://zeromotorcycles.com',
    'https://pavemotors.com',
    'https://www.livewire.com',
    'https://www.massimomotor.com',
    'https://sandboxacs.massimomotor.com',
    'https://ridebonnell.com',
    'https://chargedcycleworks.com',
    'https://munroemotors.com',
    'https://www.nortonmotorcycles.com',
    'https://nortonmotorcycles.com',
    'https://www.royalenfield.com',
    'https://starev.com',
    'https://massimomotor.myshopify.com/',
    'https://www.evinmotorsnc.com',
    'https://www.evinmotorsmiami.com',
    'https://www.rideeurocycle.com',
    'https://www.cartsincva.com/',
    'https://www.usedbikesdirect.com',
    'https://www.friendlypowersports.com',
    'https://www.friendlyyamaha.com',
    'https://www.mcgrathpowersports.com',
    'https://www.socalmotorcycles.com',
    'https://www.ducatinyc.com',
    'https://motoworkschicago.com',
    'https://www.motoworkschicago.com',
];
const whitelistRetool = ['https://*.retool.com', 'https://admin.ekhodealer.com'];
const whitelistZapier = ['https://zapier.com', 'https://hooks.zapier.com'];
const whitelistHubSpot = [
    'https://app.hubspot.com',
    'https://app-na2.hubspot.com',
    'https://*.hubspot.com',
];
// Env
const ENV = {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production',
    LOCAL: 'local',
    DEMO: 'demo',
};
// Ops Portal URLs
const OPS_PORTAL_URLS = {
    LOCAL: 'http://localhost:3005',
    DEVELOPMENT: 'https://dev-ops.ekho.com',
    PRODUCTION: 'https://ops.ekho.com',
    STAGING: 'https://staging-ops.ekho.com',
    DEMO: 'https://ops.demo.ekho.com',
};
// API Key for Smarty APIs
// - address validation and autocomplete
const SMARTY_API_KEY = '241521918353131372';
// Max instances of an individual cloud function
const MAX_INSTANCES = 1000;
// Default values for fees
// export const DEFAULT_ORDER_FEE = 500.0; // USD
// const DEFAULT_DELIVERY_FEE = 900.0; // USD
// const BASE_VITU_FEE = 160.0; // USD  165 estimate taken from VITU pricing sheet, mailing fee + vitu fee
const OdometerValidity = {
    Actual: 'Actual',
    ExceedsMechanicalLimits: 'ExceedsMechanicalLimits',
    NotActual: 'NotActual',
};
// Financing
const DECISION_LENDER_CREDIT_APP_SUBMIT_URL = 'https://decisionlender.solutions/tci/api/portal/dl4/submit';
const FREEDOMROAD_FINANCIAL_MINIMUM_LOAN_AMOUNT = 2500;
const MAX_WEEKS_BEFORE_READY = 100;
const FINANCING_STAGE_MAP = {
    financingChoicePage: 'Choosing Financing or Cash Option',
    financingInfoCollect: 'Filling out Credit App',
    confirmNativeFinancingDetailsPage: 'Confirming Credit App Details',
    creditAppRejected: 'Reviewing rejected credit app',
    creditAppMoreInfoNeeded: 'Reviewing cred app needs more info',
    nativeFinancingChoiceCollect: 'Configuring Loan to Apply For',
    nativeFinancingOfferDecisionCollect: 'Reviewing Offered Loan',
    nativeFinancingCompletedPage: 'Completed Financing Flow',
    nativeFinancingSignatures: 'Signing Financing Docs',
    financingDownPaymentInfoWrapper: 'Paying Financing Downpayment',
    laterCashPaymentCompletedPage: 'Opted to Pay in Cash Later',
    nativeFinancingInfoCollectionCompletedPage: 'Completed Information Input, Waiting for Lender Decision',
    fullPaymentACHCompletedPage: 'Completed Full Cash Payment',
    downPaymentACHCompletedPage: 'Completed Additional Downpayment',
    bankManualVerificationPage: 'Manually Verifying Bank Account for ACH',
    'Has yet to review decision': 'Has yet to review decision',
};
const NOTARY_FORM_TYPE = {
    NONE: 'NONE',
    NA: 'NA',
    ENOTARY: 'ENOTARY',
    PHYSICAL: 'PHYSICAL',
};
const SIG_WORKFLOW_TYPE = {
    ESIGN: 'ESIGN',
    WET: 'WET',
    HYBRID: 'HYBRID',
};
const SIG_FORM_TYPE_ENUM = {
    ESIGN: 'ESIGN',
    WET: 'WET',
    ROBOTIC: 'ROBOTIC',
    ENOTARY: 'ENOTARY',
};
const NOTARY_WORKFLOW_TYPE = {
    ENOTARY: 'ENOTARY',
    PHYSICAL: 'PHYSICAL',
    NONE: 'NONE',
};
const CHRIS_TESTING_EMAIL = 'chris@ekhodealer.com';
const DOCUMENT_PACKET_TYPES = {
    BUYER_PACKET: 'BUYER_PACKET',
    DEALER_PACKET: 'DEALER_PACKET',
    DEALER_RETURN_PACKET: 'DEALER_RETURN_PACKET',
    SEND_MCO_PACKET: 'SEND_MCO_PACKET',
    SELF_TAR_PACKET: 'SELF_TAR_PACKET',
};
const DOCUMENT_PACKET_NAMES = {
    BUYER_PACKET: 'buyerPacket.pdf',
    VOS_PACKET: 'vosPacket.pdf',
};
/**
 * Direction of an ad-hoc UPS Ground shipping label generated from the Admin
 * portal "Generate -> Shipping label" action. "Ekho" is the Ekho NYC HQ shipper
 * address; "buyer" is the buyer's mailing address on the order.
 */
const SHIPPING_LABEL_DIRECTIONS = {
    /** Ekho HQ ships to the buyer's mailing address (forward shipment). */
    FROM_EKHO_TO_BUYER: 'from_ekho_to_buyer',
    /** Buyer ships to Ekho HQ (UPS return label). */
    FROM_BUYER_TO_EKHO: 'from_buyer_to_ekho',
};
const TAR_PREREQ_TO_FULFILL_ENUM = {
    NOT_REQUIRED: 'NOT_REQUIRED',
    TO_BE_DETERMINED: 'TO_BE_DETERMINED',
    REQUIRED: 'REQUIRED',
};
const TRADE_IN_OPTIONS = {
    HAVE_TRADE_IN: 'HAVE_TRADE_IN',
    NO_TRADE_IN: 'NO_TRADE_IN',
};
const AUTH_CLASSES = {
    BUYER: 'buyer',
    EKHO_ADMIN: 'ekhoAdmin',
    OEM_ADMIN: 'oemAdmin',
    SERVICES_PROVIDER: 'servicesProvider',
};
// Esigs
const PANDADOC_MAX_RETRIES = 5;
const ARBITRATION_FEE = 250;
const CRA = 'Experian';
const DUMMY_LENDER_INFO = {
    name: 'FRF',
    address: {
        street: 'PO BOX 18218',
        city: 'RENO',
        state: 'NV',
        zipCode: '89511',
        addressLineOne: 'PO BOX 18218',
        addressLineTwo: '',
        zip: '89511',
    },
    lenderStateId: '1234567890',
};
const allSignaturePageNames = [
    'documentsSignatures',
    'nativeFinancingSignatures',
    'tarSignatures',
    'purchaseAgreementSignatures',
    'financingContractSignatures',
];
const PAYMENT_RECEIPT_STATUS_TYPES = {
    CANCELED: 'canceled',
    FAILED: 'failed',
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
};
const CLERQ_PAYMENT_STATUS_TYPES = {
    PROCESSING: 'PROCESSING',
    SUBMITTED: 'SUBMITTED',
    COMPLETED: 'COMPLETED',
    HOLD: 'HOLD',
    SETTLED: 'SETTLED',
    FAILED: 'FAILED',
};
const PAYMENT_RECEIPT_DISPUTE_STATUS = {
    ONGOING: 'ONGOING',
    WON: 'WON',
    LOST: 'LOST',
};
const DEFAULT_TRANSFER_ID = 'temp-transfer-id';
const PRECHECKOUT_PAYMENT_ID = 'precheckout-payment-id';
const CHECKOUT_CART_LINK_TYPES = {
    SINGLE_USE: 'SINGLE_USE',
    MULTI_USE: 'MULTI_USE',
};
const REFUND_TYPES = {
    FULL_REFUND: 'FULL_REFUND',
    PARTIAL_REFUND: 'PARTIAL_REFUND',
};
const PAYMENT_SCHEDULE_FREQUENCIES = {
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    ANNUALLY: 'annually',
    BI_ANNUALLY: 'bi-annually',
};
const REENGAGEMENT_MEDIUMS = {
    EMAIL: 'EMAIL',
    ALL: 'ALL',
};
/**
 * Which revision of the FCRA consent text a buyer agreed to.
 *
 * Bump this whenever the consent copy changes on either surface. Shared so
 * checkout and Express report the same version for the same text: a consent
 * record that cannot say what was consented to is not a record, and two
 * surfaces disagreeing about the version makes it worse than none.
 */
const FCRA_DISCLOSURE_VERSION = '2026-08-01';
const PREQUAL_OUTCOMES = {
    NO_APPLICATION: 'NOT_STARTED',
    APPROVED: 'APPROVED',
    DENIED: 'DENIED',
};
/**
 * How long a pre-qualification decision stands, in milliseconds. The stored
 * `expiresAt` on the submission and the one every surface caches locally are
 * the same window, so a buyer is never asked again on one surface while another
 * still shows them approved.
 */
const PREQUAL_EXPIRY_MS = 30 * 24 * 60 * 60 * 1000;
const DELIVERY_CHOICES = {
    SHIP: 'SHIP',
    PICK_UP: 'PICK_UP',
};
const FALLBACK_PRODUCTION_TIME = 21;
const FALLBACK_DELIVERY_TIME = 7;
const signaturePageMetadata = {
    documentsSignatures: {
        documentName: 'Sale Documents',
        pageName: 'documentsSignatures',
        folderId: 'hwCrv8E7GT4WxUSadJ6UHT',
        templateId: '9afqZK8YXBsNtQTwrmAHTm',
        contentPlaceHolderBlockId: 'content_placeholder_1',
    },
    nativeFinancingSignatures: {
        documentName: 'Financing Documents',
        pageName: 'nativeFinancingSignatures',
        folderId: 'ShPtbFVwJvM4Cc7rMKMYfX',
        templateId: '9afqZK8YXBsNtQTwrmAHTm',
        contentPlaceHolderBlockId: 'content_placeholder_1',
    },
    tarSignatures: {
        documentName: 'Registration_Documents',
        pageName: 'tarSignatures',
        folderId: 'ShPtbFVwJvM4Cc7rMKMYfX', // TODO - change this to the correct folder ID
    },
    purchaseAgreementSignatures: {
        documentName: 'Purchase Agreement',
        pageName: 'purchaseAgreementSignatures',
        folderId: 'ShPtbFVwJvM4Cc7rMKMYfX', // TODO - change this to the correct folder ID
        templateId: '9afqZK8YXBsNtQTwrmAHTm',
        contentPlaceHolderBlockId: 'content_placeholder_1',
    },
    financingContractSignatures: {
        documentName: 'Financing Contract',
        pageName: 'financingContractSignatures',
        folderId: 'ShPtbFVwJvM4Cc7rMKMYfX', // TODO - change this to the correct folder ID
        templateId: '9afqZK8YXBsNtQTwrmAHTm',
        contentPlaceHolderBlockId: 'content_placeholder_1',
    },
    // The buyer's coverage (F&I) contracts signed as their own packet, for orders
    // whose financing contract is signed off-platform. The content is the
    // provider-minted contract PDFs, so there is no template/content-placeholder.
    coverageContractSignatures: {
        documentName: 'Coverage Contracts',
        pageName: 'coverageContractSignatures',
    },
    // Wholesale Bill of Sale between the originating dealer (seller) and Ekho Dealer LLC
    // (buyer) for used-vehicle Ekho Go deals. The document content is the generated
    // wholesale BoS PDF uploaded to PandaDoc with signature field tags, so there is no
    // template/content-placeholder; the dealer signs first, Ekho counter-signs.
    wholesaleBosSignatures: {
        documentName: 'Wholesale Bill of Sale',
        pageName: 'wholesaleBosSignatures',
    },
    // NOTE: NOT A SIGNATURE PAGE
    ekhoWetSigDocs: {
        documentName: 'Ekho_Wet_Sig_TAR_documents',
        pageName: 'ekhoWetSigDocs',
        folderId: 'noCfNTdDdnk8ALcGA9X5V3',
        templateId: '9afqZK8YXBsNtQTwrmAHTm',
        contentPlaceHolderBlockId: 'content_placeholder_1',
    },
    // NOTE: NOT A SIGNATURE PAGE -- this is a reference used to get the PandaDoc link for the documents the dealer must sign
    dealerTARDocs: {
        documentName: 'Dealer_TAR_documents',
        pageName: 'dealerTARDocs',
        folderId: 'ShPtbFVwJvM4Cc7rMKMYfX',
        templateId: '9afqZK8YXBsNtQTwrmAHTm',
        contentPlaceHolderBlockId: 'content_placeholder_1',
    },
};
/**
 * The vendor-neutral `packetType` a signing doc set carries into the
 * SigningService, mapped from its doc-set page name. The packet type is a
 * segment of the deterministic signing key, so the send path (which stamps the
 * key) and every read path (which reconstructs it to look the request up) MUST
 * derive it here — a divergent mapping produces a key the lookup can never find.
 * Pages with no dedicated packet type fall back to their own page name.
 */
function packetTypeForSigningPage(pageName) {
    switch (pageName) {
        case signaturePageMetadata.documentsSignatures.pageName:
            return 'bill-of-sale';
        case signaturePageMetadata.purchaseAgreementSignatures.pageName:
            return 'purchase-agreement';
        case signaturePageMetadata.financingContractSignatures.pageName:
            return 'financing-contract';
        case signaturePageMetadata.coverageContractSignatures.pageName:
            return 'coverage-contract';
        default:
            return pageName;
    }
}
const EKHO_SUPPORT_EMAIL = 'support@ekho.com';
const EKHO_SUPPORT_PHONE = '+13025400294';
const defaultEkhoContact = {
    name: 'Ekho',
    email: EKHO_SUPPORT_EMAIL,
    phone: EKHO_SUPPORT_PHONE,
};
const EKHO_SUPPORT_SCHEDULE = {
    [DayOfWeek.MONDAY]: {
        open: '08:30',
        close: '19:00',
        day: DayOfWeek.MONDAY,
    },
    [DayOfWeek.TUESDAY]: {
        open: '08:30',
        close: '19:00',
        day: DayOfWeek.TUESDAY,
    },
    [DayOfWeek.WEDNESDAY]: {
        open: '08:30',
        close: '19:00',
        day: DayOfWeek.WEDNESDAY,
    },
    [DayOfWeek.THURSDAY]: {
        open: '08:30',
        close: '19:00',
        day: DayOfWeek.THURSDAY,
    },
    [DayOfWeek.FRIDAY]: {
        open: '08:30',
        close: '19:00',
        day: DayOfWeek.FRIDAY,
    },
};
const defaultSupportTopic = {
    contact: defaultEkhoContact,
    supportSchedule: EKHO_SUPPORT_SCHEDULE,
    commsOwnedByEkho: true,
};
const SUPPORT_TOPICS = {
    PAYMENT: {
        key: 'PAYMENT',
        title: 'Payment & financing',
        description: 'Questions about payment options, financing, terms, etc.',
        ...defaultSupportTopic,
    },
    VEHICLE: {
        key: 'VEHICLE',
        title: 'Vehicle details',
        description: "Questions about the vehicle you're purchasing, it's specs, condition, configuration, etc.",
        ...defaultSupportTopic,
    },
    INSURANCE: {
        key: 'INSURANCE',
        title: 'Insurance',
        description: 'Questions about insurance, state requirements, your options, etc.',
        ...defaultSupportTopic,
    },
    REGISTRATION: {
        key: 'REGISTRATION',
        title: 'Registration & titling',
        description: "Questions about registration, titling, the process, what's required, street legal vs off-road, etc.",
        ...defaultSupportTopic,
    },
    DELIVERY: {
        key: 'DELIVERY',
        title: 'Delivery',
        description: 'Questions about the delivery process, timing, etc.',
        ...defaultSupportTopic,
    },
    PICK_UP: {
        key: 'PICK_UP',
        title: 'Pick up',
        description: 'Questions about the pick up process, timing, etc.',
        ...defaultSupportTopic,
    },
    TECHNICAL: {
        key: 'TECHNICAL',
        title: 'Technical issues',
        description: 'Questions about the checkout process, errors, bugs, etc.',
        ...defaultSupportTopic,
    },
    OTHER: {
        key: 'OTHER',
        title: 'Other',
        description: 'Questions about Ekho, our services, or anything else.',
        ...defaultSupportTopic,
    },
};
// To do: update once we finish version two
const BUYER_PORTAL_SECTIONS = {
    SIGN_OFF: 'signOff',
    FINANCING: 'financing',
    // DELIVERY_DETAILS: 'deliveryDetails',
    INSURANCE: 'insurance',
    REGISTRATION_AND_TITLING: 'registrationAndTitling',
    IDENTITY_VERIFICATION: 'identityVerification',
    DOCUMENTS_AND_SIGNATURES: 'documentsAndSignatures',
    PAYMENT: 'payment',
};
const BUYER_PORTAL_SECTION_NAMES = {
    [BUYER_PORTAL_SECTIONS.SIGN_OFF]: 'Sign Off',
    [BUYER_PORTAL_SECTIONS.FINANCING]: 'Financing',
    [BUYER_PORTAL_SECTIONS.REGISTRATION_AND_TITLING]: 'Identification',
    [BUYER_PORTAL_SECTIONS.INSURANCE]: 'Insurance',
    [BUYER_PORTAL_SECTIONS.IDENTITY_VERIFICATION]: 'ID Verification',
    [BUYER_PORTAL_SECTIONS.PAYMENT]: 'Payment',
    [BUYER_PORTAL_SECTIONS.DOCUMENTS_AND_SIGNATURES]: 'Paperwork',
};
const BUYER_PORTAL_STATUSES = {
    NOT_STARTED: 'NOT STARTED',
    NOT_APPLICABLE: 'N/A',
    BLOCKED: 'BLOCKED',
    IN_PROGRESS: 'IN PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED',
    // T&R specific statuses
    AWAITING_IDENTITY_VERIFICATION: 'ID VERIFICATION',
    // Insurance specific statuses
    VALIDATING_INSURANCE: 'VALIDATING INSURANCE',
    SKIPPED_INSURANCE: 'SKIPPED INSURANCE',
    // Payment specific statuses
    BALANCE_DUE: 'BALANCE DUE',
    AWAITING_FUNDS: 'AWAITING FUNDS',
    FULLY_PAID: 'FULLY PAID',
    // Financing specific statuses
    SUBMITTING_APP: 'SUBMITTING APP',
    AWAITING_LENDER_DECISION: 'AWAITING LENDER DECISION',
    LOAN_OFFERED: 'LOAN OFFERED',
    LENDER_REJECTED_AND_CANCELED: 'CANCELED ORDER',
    LENDER_REJECTED_AND_PAYING_CASH: 'PAYING CASH',
    LENDER_REJECTED_AND_AWAITING_DECISION: 'AWAITING BUYER DECISION',
    BUYER_DECLINED_AND_CANCELED: 'CANCELED ORDER',
    BUYER_DECLINED_AND_PAYING_CASH: 'PAYING CASH',
    BUYER_DECLINED_AND_AWAITING_DECISION: 'AWAITING BUYER DECISION',
    AWAITING_DOWN_PAYMENT: 'AWAITING DOWN PAYMENT',
    // Used in both financing and paperwork sections
    AWAITING_SIGNATURES: 'AWAITING SIGNATURES',
};
const FORM_THIRD_PARTY_SIGNER_ENUM = {
    VERIFIER: 'VERIFIER',
    DOCTOR: 'DOCTOR',
    MILITARY: 'MILITARY',
    NA: 'NA',
    NONE: 'NONE',
};
const EKHO_WET_SIG_TAR_DOCS_KEY = 'ekhoWetSigDocs';
const DEALER_TAR_DOCS_KEY = 'dealerTARDocs';
// StateForms key for the Ekho-generated MCO (Manufacturer's Certificate of Origin)
// included in the VOS packet as a robotic-signed document for states that require it.
// Sourced from EKHO and rendered from the stored msoTemplate.pdf rather than a vendor
// or PandaDoc template.
const EKHO_MCO_SIG = 'EKHO_MCO_SIG';
const AVERAGE_LOAN_TERM = 48;
const STATE_FORMS_SOURCE_TYPES = {
    VITU: 'VITU',
    CG: 'CG',
    BUYER: 'BUYER',
    EKHO: 'EKHO',
    OEM: 'OEM',
};
const CRAMetadata = {
    Experian: {
        name: 'Experian',
        addressLineOne: 'TODO',
        city: 'TODO',
        state: 'TODO',
        zip: 'TODO',
        phone: 'TODO',
        website: 'TODO',
    },
};
const TRANSACTION_STATUS_ENUM = {
    Started: 'Started',
    Draft: 'Draft',
    Completed: 'Completed',
    PreAuditInProgress: 'PreAuditInProgress',
    PreAuditErrorsFound: 'PreAuditErrorsFound',
    PreAuditCompleted: 'PreAuditCompleted',
    SentToService: 'SentToService',
    Received: 'Received',
    ErrorsFound: 'ErrorsFound',
    SentToState: 'SentToState',
    ReturnedFromState: 'ReturnedFromState',
    StateProcessed: 'StateProcessed',
    StateCompleted: 'StateCompleted',
    Inactive: 'Inactive',
    CompletedManually: 'CompletedManually',
    Canceled: 'Canceled',
    Failed: 'Failed',
    // custom internal statuses (i.e. not from VITU) are below
    CreationFailed: 'CreationFailed',
    CreationStarted: 'CreationStarted',
};
const DELIVERY_METHOD_ENUM = {
    DrivenOffLot: 'DrivenOffLot',
    VehicleShipped: 'VehicleShipped',
};
const TRANSACTION_STATUSES_AFTER_PREAUDIT_INITIATED = [
    TRANSACTION_STATUS_ENUM.PreAuditInProgress,
    TRANSACTION_STATUS_ENUM.PreAuditErrorsFound,
    TRANSACTION_STATUS_ENUM.PreAuditCompleted,
    TRANSACTION_STATUS_ENUM.SentToService,
    TRANSACTION_STATUS_ENUM.Received,
    TRANSACTION_STATUS_ENUM.SentToState,
    TRANSACTION_STATUS_ENUM.ReturnedFromState,
    TRANSACTION_STATUS_ENUM.StateProcessed,
    TRANSACTION_STATUS_ENUM.StateCompleted,
];
const DOCUMENT_STEPS_ENUM = {
    FINALIZED_BUYER_PACKET: 'FINALIZED_BUYER_PACKET',
    BUYER_SENT_DOCUMENTS: 'BUYER_SENT_DOCUMENTS',
    OEM_SENT_DOCUMENTS: 'OEM_SENT_DOCUMENTS',
    LIENHOLDER_SENT_DOCUMENTS: 'LIENHOLDER_SENT_DOCUMENTS',
    SELLER_RECEIVED_ALL_DOCUMENTS: 'SELLER_RECEIVED_ALL_DOCUMENTS',
    SELLER_RECEIVED_BUYER_DOCUMENTS: 'SELLER_RECEIVED_BUYER_DOCUMENTS',
    SELLER_RECEIVED_OEM_DOCUMENTS: 'SELLER_RECEIVED_OEM_DOCUMENTS',
    SELLER_RECEIVED_LIENHOLDER_DOCUMENTS: 'SELLER_RECEIVED_LIENHOLDER_DOCUMENTS',
    SELLER_SENT_DOCUMENTS: 'SELLER_SENT_DOCUMENTS',
    SELLER_SENT_TEMP_TAG: 'SELLER_SENT_TEMP_TAG',
};
// Every other step gates seller-side or titling work and is owned by backend
// pipelines, so a buyer request carrying one is rejected rather than trusted.
const BUYER_WRITABLE_DOCUMENT_STEPS = [DOCUMENT_STEPS_ENUM.BUYER_SENT_DOCUMENTS];
const DEFAULT_PREORDER_LINK_NAME = 'Convert Preorder Link';
const INSPECTION_TYPE_ENUM = {
    NONE: 'NONE',
    YES: 'YES',
    AFTER_DELIVERY: 'AFTER_DELIVERY',
};
const FUNDING_PACKET_STATUS_ENUM = {
    UNABLE_TO_FUND: 'UNABLE_TO_FUND',
    SUBMITTED: 'SUBMITTED',
    FUNDED: 'FUNDED',
};
const REQUESTED_TITLE_TYPE_ENUM = {
    ELECTRONIC_TITLE: 'ElectronicTitle',
    PAPER_TITLE: 'PaperTitle',
};
// Insurance
const INSURANCE_VALID_DAYS_BUFFER = 15;
const INSURANCE_EFFECTIVE_DAYS_BUFFER = 30;
const MAX_VERIFICATION_ATTEMPTS = 3;
const canopyConnectAddressTypes = {
    MAILING: 'MAILING',
    PHYSICAL: 'PHYSICAL',
    LIENHOLDER: 'LIENHOLDER',
    MORTGAGEE: 'MORTGAGEE',
};
const VehicleCoverageCodes = {
    SINGLE_LIMIT_LIABILITY: 'SINGLE_LIMIT_LIABILITY',
    BODILY_INJURY_LIABILITY: 'BODILY_INJURY_LIABILITY',
    PROPERTY_DAMAGE_LIABILITY: 'PROPERTY_DAMAGE_LIABILITY',
    SUPPLEMENTAL_SPOUSAL_LIABILITY: 'SUPPLEMENTAL_SPOUSAL_LIABILITY',
    PERSONAL_INJURY_PROTECTION: 'PERSONAL_INJURY_PROTECTION',
    COMPREHENSIVE: 'COMPREHENSIVE',
    FULL_GLASS: 'FULL_GLASS',
    COLLISION_DEDUCTIBLE_WAIVER: 'COLLISION_DEDUCTIBLE_WAIVER',
    COLLISION: 'COLLISION',
    UNINSURED_MOTORISTS: 'UNINSURED_MOTORISTS',
    UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY',
    UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY',
    UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY: 'UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY',
    UNDERINSURED_MOTORISTS: 'UNDERINSURED_MOTORISTS',
    UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY',
    UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY',
    UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY: 'UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY',
    UNINSURED_AND_UNDERINSURED_MOTORISTS: 'UNINSURED_AND_UNDERINSURED_MOTORISTS',
    UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY',
    UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY',
    UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY: 'UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY',
    TOWING_AND_LABOR: 'TOWING_AND_LABOR',
    LOAN_OR_LEASE_ASSISTANCE: 'LOAN_OR_LEASE_ASSISTANCE',
    RIDESHARE_GAP_PROTECTION: 'RIDESHARE_GAP_PROTECTION',
    MEDICAL_PAYMENTS: 'MEDICAL_PAYMENTS',
    ADDITIONAL_LIVING_EXPENSE: 'ADDITIONAL_LIVING_EXPENSE',
    FAMILY_LIABILITY_PROTECTION: 'FAMILY_LIABILITY_PROTECTION',
    BUILDING_CODES: 'BUILDING_CODES',
    EMERGENCY_ROAD_SERVICE: 'EMERGENCY_ROAD_SERVICE',
    RENTAL_REIMBURSEMENT: 'RENTAL_REIMBURSEMENT',
    CAR_RENTAL_AND_TRAVEL_EXPENSES: 'CAR_RENTAL_AND_TRAVEL_EXPENSES',
    MECHANICAL_BREAKDOWN: 'MECHANICAL_BREAKDOWN',
    SUPPLEMENTAL_UNINSURED_AND_UNDERINSURED_MOTORISTS: 'SUPPLEMENTAL_UNINSURED_AND_UNDERINSURED_MOTORISTS',
    EMERGENCY_EXPENSE: 'EMERGENCY_EXPENSE',
    REPLACEMENT_COST_PERSONAL_EFFECTS: 'REPLACEMENT_COST_PERSONAL_EFFECTS',
    VACATION_LIABILITY_COVERAGE: 'VACATION_LIABILITY_COVERAGE',
    RV_MEDICAL: 'RV_MEDICAL',
    EXTENDED_BENEFITS: 'EXTENDED_BENEFITS',
    WAGE_EARNER_DISABILITY_BENEFITS: 'WAGE_EARNER_DISABILITY_BENEFITS',
    ESSENTIAL_SERVICES_DISABILITY_BENEFITS: 'ESSENTIAL_SERVICES_DISABILITY_BENEFITS',
    DEATH_BENEFIT: 'DEATH_BENEFIT',
    CAR_REPLACEMENT_ASSISTANCE: 'CAR_REPLACEMENT_ASSISTANCE',
    FULL_TORT: 'FULL_TORT',
    LIMITED_TORT: 'LIMITED_TORT',
    COMBINED_SINGLE_LIMIT: 'COMBINED_SINGLE_LIMIT',
    LIABILITY_FOR_DEATH: 'LIABILITY_FOR_DEATH',
};
// This is a map of vehicle coverage code to any codes that are equivalent to it. It generally just covers the uninsured/underinsured motorist codes
const EquivalentVehicleCoverageCodes = {
    [VehicleCoverageCodes.UNINSURED_MOTORISTS]: [
        `${VehicleCoverageCodes.UNDERINSURED_MOTORISTS}`,
        `${VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS}`,
    ],
    [VehicleCoverageCodes.UNDERINSURED_MOTORISTS]: [
        `${VehicleCoverageCodes.UNINSURED_MOTORISTS}`,
        `${VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS}`,
    ],
    [VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS]: [
        `${VehicleCoverageCodes.UNINSURED_MOTORISTS}`,
        `${VehicleCoverageCodes.UNDERINSURED_MOTORISTS}`,
    ],
    // Uninsured Motorist Bodily Injury Liability
    [VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY]: [
        VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
        VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
    ],
    // Underinsured Motorist Bodily Injury Liability
    [VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY]: [
        VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
        VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
    ],
    // Uninsured and Underinsured Motorist Bodily Injury Liability
    [VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY]: [
        VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
        VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
    ],
    // Uninsured Motorist Property Damage Liability
    [VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY]: [
        VehicleCoverageCodes.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
        VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
    ],
    // Underinsured Motorist Property Damage Liability
    [VehicleCoverageCodes.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY]: [
        VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
        VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
    ],
    // Uninsured and Underinsured Motorist Property Damage Liability
    [VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY]: [
        VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
        VehicleCoverageCodes.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
    ],
    // Uninsured Motorist Bodily Injury and Property Damage Liability
    [VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY]: [
        VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
        VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
    ],
    // Underinsured Motorist Bodily Injury and Property Damage Liability
    [VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY]: [
        VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
        VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
    ],
    // Uninsured and Underinsured Motorist Bodily Injury and Property Damage Liability
    [VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY]: [
        VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
        VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
    ],
};
const VehicleCoverageFriendlyNames = {
    SINGLE_LIMIT_LIABILITY: 'Single Limit Liability',
    BODILY_INJURY_LIABILITY: 'Bodily Injury Liability',
    PROPERTY_DAMAGE_LIABILITY: 'Property Damage Liability',
    SUPPLEMENTAL_SPOUSAL_LIABILITY: 'Supplemental Spousal Liability',
    PERSONAL_INJURY_PROTECTION: 'Personal Injury Protection',
    COMPREHENSIVE: 'Comprehensive',
    FULL_GLASS: 'Full Glass',
    COLLISION_DEDUCTIBLE_WAIVER: 'Collision Deductible Waiver',
    COLLISION: 'Collision',
    UNINSURED_MOTORISTS: 'Uninsured Motorists',
    UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'Uninsured Motorist Bodily Injury Liability',
    UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'Uninsured Motorist Property Damage Liability',
    UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY: 'Uninsured Motorist Bodily Injury & Property Damage Liability',
    UNDERINSURED_MOTORISTS: 'Underinsured Motorists',
    UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'Underinsured Motorist Bodily Injury Liability',
    UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'Underinsured Motorist Property Damage Liability',
    UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY: 'Underinsured Motorist Bodily Injury & Property Damage Liability',
    UNINSURED_AND_UNDERINSURED_MOTORISTS: 'Uninsured / Underinsured Motorists',
    UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'Uninsured / Underinsured Motorist Bodily Injury Liability',
    UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'Uninsured / Underinsured Motorist Property Damage Liability',
    UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY: 'Uninsured / Underinsured Motorist Bodily Injury & Property Damage Liability',
    TOWING_AND_LABOR: 'Towing and Labor',
    LOAN_OR_LEASE_ASSISTANCE: 'Loan or Lease Assistance',
    RIDESHARE_GAP_PROTECTION: 'Rideshare Gap Protection',
    MEDICAL_PAYMENTS: 'Medical Payments',
    ADDITIONAL_LIVING_EXPENSE: 'Additional Living Expense',
    FAMILY_LIABILITY_PROTECTION: 'Family Liability Protection',
    BUILDING_CODES: 'Building Codes',
    EMERGENCY_ROAD_SERVICE: 'Emergency Road Service',
    RENTAL_REIMBURSEMENT: 'Rental Reimbursement',
    CAR_RENTAL_AND_TRAVEL_EXPENSES: 'Car Rental and Travel Expenses',
    MECHANICAL_BREAKDOWN: 'Mechanical Breakdown',
    SUPPLEMENTAL_UNINSURED_AND_UNDERINSURED_MOTORISTS: 'Supplemental Uninsured / Underinsured Motorists',
    EMERGENCY_EXPENSE: 'Emergency Expense',
    REPLACEMENT_COST_PERSONAL_EFFECTS: 'Replacement Cost Personal Effects',
    VACATION_LIABILITY_COVERAGE: 'Vacation Liability Coverage',
    RV_MEDICAL: 'RV Medical',
    EXTENDED_BENEFITS: 'Extended Benefits',
    WAGE_EARNER_DISABILITY_BENEFITS: 'Wage Earner Disability Benefits',
    ESSENTIAL_SERVICES_DISABILITY_BENEFITS: 'Essential Services Disability Benefits',
    DEATH_BENEFIT: 'Death Benefit',
    CAR_REPLACEMENT_ASSISTANCE: 'Car Replacement Assistance',
    FULL_TORT: 'Full Tort',
    LIMITED_TORT: 'Limited Tort',
    COMBINED_SINGLE_LIMIT: 'Combined Single Limit',
    LIABILITY_FOR_DEATH: 'Liability for Death',
};
const MAX_RETRIES = 5;
// NOTE: I've lower-cased all of these enum options. Make sure to toLowerCase() whatever you're checking it against.
const ValidInsuranceTypesBasedOnVehicleType = {
    passenger: ['AUTO', 'CLASSIC_CAR', 'UMBRELLA', 'MOTORCYCLE'],
    motorcycle: ['AUTO', 'MOTORCYCLE', 'UMBRELLA'],
    truck: ['UMBRELLA', 'AUTO'],
    commercial: ['COMMERCIAL_AUTO', 'COMMERCIAL_UMBRELLA'],
    trailer: ['AUTO', 'TRAILER', 'RECREATIONAL_VEHICLE'],
    moped: ['OFFROAD_VEHICLE', 'AUTO', 'MOTORCYCLE'],
    ohv: ['OFFROAD_VEHICLE', 'RECREATIONAL_VEHICLE', 'SNOWMOBILE', 'MOTORCYCLE'],
    vessel: ['BOAT'],
};
const DocumentTypesToDownload = [
    // 'INSURANCE_APPLICATION',
    'INSURANCE_BINDER',
    'DECLARATIONS',
    // 'ENDORSEMENT',
    'INSURANCE_ID_CARD',
    'VERIFICATION_OF_INSURANCE',
];
const insuranceMinimumLevelTypesEnum = {
    PER_PERSON_LIMIT: 'per_person_limit_cents',
    PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT: 'per_incident_limit_cents',
    DEDUCTIBLE: 'deductible_cents',
    ACTUAL_CASH_VALUE: 'actual_cash_value',
    PER_DAY_LIMIT: 'per_day_limit_cents', // comes with max_days by default?
};
// Make sure this returns an array in the same form as what we list in minimumLevels within the stateData objects in stateData.js
const insuranceMinimumLevels = (lender, vehicleTotalPrice) => [
    // Canopy Connect doesn't widely support actual_cash_value just yet. In the actual checking of policies, we can safely assume for now that a policy will meet this threshold
    {
        code: VehicleCoverageCodes.COLLISION,
        name: VehicleCoverageFriendlyNames.COLLISION,
        type: insuranceMinimumLevelTypesEnum.ACTUAL_CASH_VALUE,
        amount: vehicleTotalPrice,
    },
    // A lender that has not stated a maximum deductible sets no deductible minimum.
    ...(lender.maxDeductible === undefined
        ? []
        : [
            {
                code: VehicleCoverageCodes.COLLISION,
                name: VehicleCoverageFriendlyNames.COLLISION,
                type: insuranceMinimumLevelTypesEnum.DEDUCTIBLE,
                amount: lender.maxDeductible,
            },
        ]),
    {
        code: VehicleCoverageCodes.COMPREHENSIVE,
        name: VehicleCoverageFriendlyNames.COMPREHENSIVE,
        type: insuranceMinimumLevelTypesEnum.ACTUAL_CASH_VALUE,
        amount: vehicleTotalPrice,
    },
    ...(lender.maxDeductible === undefined
        ? []
        : [
            {
                code: VehicleCoverageCodes.COMPREHENSIVE,
                name: VehicleCoverageFriendlyNames.COMPREHENSIVE,
                type: insuranceMinimumLevelTypesEnum.DEDUCTIBLE,
                amount: lender.maxDeductible,
            },
        ]),
];
const DocumentTypesToDownloadMap = {
    // INSURANCE_APPLICATION: 'INSURANCE_APPLICATION',
    INSURANCE_BINDER: 'INSURANCE_BINDER',
    DECLARATIONS: 'DECLARATIONS',
    // ENDORSEMENT: 'ENDORSEMENT',
    INSURANCE_ID_CARD: 'INSURANCE_ID_CARD',
    VERIFICATION_OF_INSURANCE: 'VERIFICATION_OF_INSURANCE',
};
const RIC_NOTIFICATION_EXPIRATION_HOURS = 23;
// Inspection
const inspectionTypesEnum = {
    YES: 'YES',
    NONE: 'NONE',
};
const OWNER_TYPES = {
    INDIVIDUAL: 'Individual',
    BUSINESS: 'Business',
};
const TYPE_OF_ORDER_ENUM = {
    PREORDER: 'preorder',
    BUILD_TO_ORDER: 'buildToOrder',
    INVENTORY_ORDER: 'inventoryOrder',
};
// Should live in the const file
const STRIPE_METADATA_FIELD_TYPES = {
    processing_fee_inc: Boolean,
    env: String,
    payment_type: String,
    oem_key: String,
    purchased_vehicle_id: String,
    order_id: String,
    buyer_id: String,
    buyer_email: String,
    buyer_name: String,
    additional_dues_id: String,
    processing_fee_inc_amount: Number, // STORED IN DOLLARS AND CENTS!
    oem_id: String,
    eng: String,
    program_owner_id: String,
};
const PAYMENT_PLATFORM_TYPES = {
    BREX: 'brex',
    STRIPE: 'stripe',
    CLERQ: 'clerq',
};
const PAYMENT_SOURCES = {
    BUYER: 'buyer',
    LENDER: 'lender',
};
const PAYMENT_METHOD_TYPES = {
    CARD: 'card',
    US_BANK_ACCOUNT: 'us_bank_account', // SAME AS ACH
    WIRE: 'wire',
    KLARNA: 'klarna',
    CRYPTO: 'crypto',
    APPLE_PAY: 'apple_pay',
};
const BREX_TRANSFER_DIRECTION = {
    INCOMING: 'INCOMING',
    OUTGOING: 'OUTGOING',
};
const PAYMENT_INTENT_STATUS_TYPES = {
    // STRIPE PAYMENT INTENT STATUSES
    // https://stripe.com/docs/payments/payment-intents/status
    SUCCEEDED: 'succeeded',
    REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
    REQUIRES_CONFIRMATION: 'requires_confirmation',
    PROCESSING: 'processing',
    CANCELED: 'canceled',
    REQUIRES_CAPTURE: 'requires_capture',
    REQUIRES_ACTION: 'requires_action',
};
const CLERQ_AUTHORIZATION_CODES = {
    AUTHORIZED: 'AUTHORIZED',
    AUTHORIZED_WITH_HOLD: 'AUTHORIZED_WITH_HOLD',
    DECLINED: 'DECLINED',
};
const CHECKOUT_SECTIONS = {
    CONFIGURATOR: 'CONFIGURATOR', // NOT USED YET => CONFIGURATOR IS CURRENTLY IN ORDER_DETAILS SECTION
    ORDER_DETAILS: 'ORDER_DETAILS',
    CREDIT_APP: 'CREDIT_APP',
};
const LOG_SEVERITY_ENUM = {
    CRITICAL: 'CRITICAL',
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO',
    DEBUG: 'DEBUG',
};
const LENDER_DECISION_REASONS = {
    CREDIT_APP_CRITERIA_MISS: 'CREDIT_APP_CRITERIA_MISS',
    AUTO_REJECTED: 'AUTO_REJECTED',
    REVIEWED_AND_REJECTED: 'REVIEWED_AND_REJECTED',
    MANUALLY_REJECTED: 'MANUALLY_MARKED_REJECTED',
    WITHDRAWN: 'WITHDRAWN',
    AUTO_ACCEPTED: 'AUTO_ACCEPTED',
    REVIEWED_AND_ACCEPTED: 'REVIEWED_AND_ACCEPTED',
    MANUALLY_ACCEPTED: 'MANUALLY_MARKED_ACCEPTED',
    STIPS_CLEARED_AND_ACCEPTED: 'STIPS_CLEARED_AND_ACCEPTED',
};
/** Human-readable lender decision status shown across the admin portal. */
const LENDER_DECISION_STATUS = {
    APPROVED: 'Approved',
    CONDITIONALLY_APPROVED: 'Conditionally approved',
    REJECTED: 'Rejected',
};
const LENDER_DECISION_STATUSES = Object.values(LENDER_DECISION_STATUS);
/** A status string the admin portal shows for a lender's decision. */
const isLenderDecisionStatus = (status) => LENDER_DECISION_STATUSES.includes(status);
const CREDIT_APP_REJECTION_REASONS = {
    IRREGULAR_HIT: 'IRREGULAR_HIT',
    NO_HIT: 'NO_HIT',
    INVALID_SSN: 'INVALID_SSN',
    LTV_THRESHOLD: 'LTV_THRESHOLD',
    FICO_SCORE_BAND: 'FICO_SCORE_BAND',
    FICO_SCORE_UNAVAILABLE: 'FICO_SCORE_UNAVAILABLE',
    LENDER_DISABLED: 'LENDER_DISABLED',
    LENDER_EXCLUDED_FOR_PROGRAM_OWNER: 'LENDER_EXCLUDED_FOR_PROGRAM_OWNER',
    LENDER_TURNED_OFF: 'LENDER_TURNED_OFF',
    NO_FINANCING_PROGRAM: 'NO_FINANCING_PROGRAM',
    USED_VEHICLES_NOT_SUPPORTED: 'USED_VEHICLES_NOT_SUPPORTED',
    BELOW_MINIMUM_LOAN_AMOUNT: 'BELOW_MINIMUM_LOAN_AMOUNT',
    UNDERAGE: 'UNDERAGE',
};
/** Short, seller-facing label for each buy box rejection reason. */
const CREDIT_APP_REJECTION_REASON_LABELS = {
    IRREGULAR_HIT: 'irregular credit file',
    NO_HIT: 'no credit file',
    INVALID_SSN: 'invalid SSN',
    LTV_THRESHOLD: 'loan-to-value too high',
    FICO_SCORE_BAND: 'credit score outside range',
    FICO_SCORE_UNAVAILABLE: 'no credit score',
    LENDER_DISABLED: 'lender not available for this vehicle',
    LENDER_EXCLUDED_FOR_PROGRAM_OWNER: 'lender does not take this client',
    LENDER_TURNED_OFF: 'lender turned off for every client',
    NO_FINANCING_PROGRAM: 'no financing program for this vehicle',
    USED_VEHICLES_NOT_SUPPORTED: 'used vehicles not financed',
    BELOW_MINIMUM_LOAN_AMOUNT: 'loan amount below minimum',
    UNDERAGE: 'buyer under 18',
};
const REJECTION_REASON_LABELS_BY_KEY = CREDIT_APP_REJECTION_REASON_LABELS;
/** The seller-facing label for a buy box reason key. Undefined for a key with no label. */
const creditAppRejectionReasonLabel = (key) => REJECTION_REASON_LABELS_BY_KEY[key];
const FICO_SCORE_UNAVAILABLE_REASONS = {
    DATA_UNAVAILABLE: 'DATA_UNAVAILABLE',
    CREDIT_FREEZE: 'CREDIT_FREEZE',
    NO_SCORE_FOUND: 'NO_SCORE_FOUND',
    SCORE_NOT_RETURNED: 'SCORE_NOT_RETURNED',
};
/**
 * Reasons that disqualify a lender. The others are diagnostic: the bureau
 * answered and simply had no score to give, which lenders decide on themselves.
 */
const DISQUALIFYING_FICO_SCORE_UNAVAILABLE_REASONS = [
    FICO_SCORE_UNAVAILABLE_REASONS.DATA_UNAVAILABLE,
    FICO_SCORE_UNAVAILABLE_REASONS.CREDIT_FREEZE,
];
const isDisqualifyingFicoScoreUnavailableReason = (reason) => reason != null && DISQUALIFYING_FICO_SCORE_UNAVAILABLE_REASONS.includes(reason);
const INTERNAL_CREDIT_FILE_HIT_TYPES = {
    NO_HIT: 'NO_HIT',
    IRREGULAR_HIT: 'IRREGULAR_HIT',
    REGULAR_HIT: 'REGULAR_HIT',
};
const MAILGUN_API_USERNAME = 'api';
const PLACED_ORDER_EVENT_CODES = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
};
// -- Don't change these two values unless you talk with Chris -- //
const RIC_VALID_LENGTH = 35; // in days - assumes 45 days until first payment!
const DEFAULT_DAYS_UNTIL_FIRST_PAYMENT = 45;
const BREX_LLC_ACCOUNT_ID = 'dpacc_clgfzgo9x00aq0pib3weo0fuu';
const CG_BREXVENDOR_DETAILS = {
    VENDOR_ID: 'pdcont_clxd9wg0a03jd0k8s4sw07gsf',
    PAYMENT_INSTRUMENT_ID: 'pdinstl_clxd9wgau21rs0g8amhf1gt6i',
};
// Position enum for relocation and modal queue objects
const QUEUE_POSITION_ENUM = {
    FRONT: 'FRONT',
    BACK: 'BACK',
};
// Action enum for relocation and modal queue objects
const QUEUE_OBJECT_ACTION_ENUM = {
    CREATE: 'CREATE',
    DELETE: 'DELETE',
};
// TAR
const DUMMY_TAR_INSURANCE_DATA = {
    companyName: 'Dummy Insurance Company',
    policyNumber: '123456789',
    insuranceCode: '12345',
    agentBrokerName: 'Dummy Agent',
};
const TAX_CONSTS = {
    COsellerSalesTaxAccountNumber: '', // TODO replace with correct number
    COsellerCitySalesTaxAccountNumber: '', // TODO replace with correct number
};
const RegistrationConstants = {
    saleType: 'Purchase',
    vehicleSoldAs: 'New',
};
const HTTP_FIREBASE_ERROR_NAMES = {
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss',
    UNAUTHENTICATED: 'unauthenticated',
};
// =============== TAR ENUMS ================ //
const AK_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    TRUCKPICKUP: 'TruckPickup',
    ATV: 'ATV',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
    MOTORHOME: 'Motorhome',
};
const DC_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    COMMERCIAL: 'Commercial',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRAILER: 'Trailer',
    AUTOCYCLE: 'Autocycle',
    LOW_SPEED: 'LowSpeed',
    MOTORHOME: 'Motorhome',
};
const RI_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    MOTORSCOOTER: 'Motorscooter',
    TRAILER: 'Trailer',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
};
// VITU NhVehicleTypeEnum wire names, per the VITU National API v2 public schema.
// VITU has no off-highway value for NH; any other value is rejected with a 400.
const NH_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
};
// VITU MeVehicleTypeEnum wire names, per the VITU National API v2 public schema.
// VITU has no off-highway value for ME; any other value is rejected with a 400.
const ME_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
};
// VITU WvVehicleTypeEnum wire names. VITU's published schema still lists
// off-highway values for WV, but its live API rejects them with a 400,
// so they are left out.
const WV_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    TRUCK: 'Truck',
    GOLFCART: 'Golfcart',
    LOW_SPEED: 'LowSpeed',
    VESSEL: 'Vessel',
};
const VT_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRAILER: 'Trailer',
    TRUCK: 'Truck',
    ATV: 'ATV',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const SD_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    LOW_SPEED: 'LowSpeed',
    MOTORHOME: 'Motorhome',
    OHV: 'OHV',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
// VITU NeVehicleTypeEnum wire names. VITU's published schema still lists
// off-highway values for NE, but its live API rejects them with a 400,
// so they are left out.
const NE_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    MINIBIKE: 'Minibike',
    MOTORSCOOTER: 'Motorscooter',
    TRUCK: 'Truck',
    MINI_TRUCK: 'MiniTruck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const AL_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    PICKUP: 'Pickup',
    SUV: 'SUV',
    ATV: 'ATV',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
    UTV: 'UTV',
    VAN: 'Van',
    VESSEL: 'Vessel',
};
const IA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOPED: 'Moped',
    ATV: 'ATV',
    LOW_SPEED: 'Lowspeed',
    OHV: 'OHV',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
    Snowmobile: 'Snowmobile',
    VESSEL: 'Vessel',
};
// VITU KyVehicleTypeEnum wire names, per the VITU National API v2 public schema.
// VITU has no off-highway value for KY; any other value is rejected with a 400.
const KY_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
};
const MA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    COMMERCIAL: 'Commercial',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    AUTOHOME: 'AutoHome',
    TAXI: 'Taxi',
    ATV: 'ATV',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const CT_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    ATV: 'ATV',
    SNOWMOBILE: 'Snowmobile',
    CARGO_SHUTTLE_VAN: 'CargoShuttleVan',
    MOTORHOME: 'Motorhome',
    VESSEL: 'Vessel',
};
const NJ_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    PICKUP: 'Pickup',
    TRAILER: 'Trailer',
    ATV: 'ATV',
    AUTOCYCLE: 'Autocycle',
    FARM_TRUCK: 'FarmTruck',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const MD_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    ATV: 'ATV',
    UTV: 'UTV',
    SNOWMOBILE: 'Snowmobile',
    AUTOCYCLE: 'Autocycle',
    LIMITED_SPEED_VEHICLE: 'LimitedSpeedVehicle',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    MOTORSCOOTER: 'Motorscooter',
    VESSEL: 'Vessel',
};
// VITU UtVehicleTypeEnum wire names. VITU's published schema still lists
// off-highway values for UT, but its live API rejects them with a 400,
// so they are left out.
const UT_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    AUTOCYCLE: 'Autocycle',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
    VESSEL: 'Vessel',
};
// VITU IlVehicleTypeEnum wire names, per the VITU National API v2.80.0 schema.
// VITU has no off-highway value for IL; any other value is rejected with a 400.
const IL_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
};
const MS_VEHICLE_TYPE_ENUM = {
    // Passenger, Motorcycle, Moped, Truck, Trailer, Motorhome, Vessel
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    VESSEL: 'Vessel',
};
const AR_VEHICLE_TYPE_ENUM = {
    // Passenger, Motorcycle, Trailer, Motorhome, Truck, ATV, LowSpeed, Vessel
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    TRUCK: 'Truck',
    ATV: 'ATV',
    LOW_SPEED: 'LowSpeed',
    VESSEL: 'Vessel',
};
const CA_VEHICLE_TYPE_ENUM = {
    // Passenger, Motorcycle, Moped, Truck, Commercial, Trailer, Motorhome, OHV, Vessel
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    COMMERCIAL: 'Commercial',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    OHV: 'OHV',
    VESSEL: 'Vessel',
};
const DE_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    COMMERCIAL: 'Commercial',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    FARM_TRUCK: 'FarmTruck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
};
const TX_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRAILER: 'Trailer',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
    PASSENGER_TRUCK: 'PassengerTruck',
};
const WI_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    TRUCK: 'Truck',
    FARM_TRUCK: 'FarmTruck',
    TRAILER: 'Trailer',
    MOTORHOME: 'MotorHome',
    ATV: 'ATV',
    AUTOCYCLE: 'Autocycle',
    SNOWMOBILE: 'Snowmobile',
    UTV: 'UTV',
    VESSEL: 'Vessel',
};
const OR_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    ATV: 'ATV',
    GOLF_CART: 'GolfCart',
    LOW_SPEED: 'LowSpeed',
    MEDIUM_SPEED: 'MediumSpeed',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
// VITU MnVehicleTypeEnum wire names, per the VITU National API v2 public schema.
// VITU has no off-highway value for MN; any other value is rejected with a 400.
const MN_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
};
const MO_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    ATV: 'ATV',
    AUTOCYCLE: 'Autocycle',
    LOW_SPEED: 'LowSpeedVehicle',
    MOTORHOME: 'Motorhome',
    TRICYCLE: 'Tricycle',
    TRAILER: 'Trailer',
    VESSEL: 'Vessel',
};
const OK_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    TRUCK: 'Truck',
    MOPED: 'Moped',
};
const MT_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    SUV: 'SUV',
    CARGO_SHUTTLE_VAN: 'CargoShuttleVan',
    ATV: 'ATV',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
// VITU LaVehicleTypeEnum wire names, per the VITU National API v2 schema on stage.
// VITU has no off-highway value for LA; any other value is rejected with a 400.
const LA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
};
const NM_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    ATV: 'ATV',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const MI_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    COMMERCIAL_TRUCK: 'CommercialTruck',
    ATV: 'ATV',
    FARM_TRUCK: 'FarmTruck',
    MOTORHOME: 'Motorhome',
    OHV: 'OHV',
    SNOWMOBILE: 'Snowmobile',
    TRUCK_TRACTOR: 'TruckTractor',
    CARGO_SHUTTLE_VAN: 'CargoShuttleVan',
    VESSEL: 'Vessel',
};
// VITU CoVehicleTypeEnum wire names, per the VITU National API v2.80.0 public schema
// (proxy-www-developer.vitu.com/national-public-api/v2/schema.yaml). VITU has no
// off-highway or Moped value for CO; any other value is rejected with a 400.
const CO_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
};
const FL_VEHICLE_TYPE_ENUM = {
    AUTO: 'Auto',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    OHV: 'OHV',
    ATV: 'ATV',
    GOLFCART: 'Golfcart',
    VESSEL: 'Vessel',
};
const NY_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    PICKUP: 'Pickup',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    OHV: 'OHV',
    ATV: 'ATV',
    VESSEL: 'Vessel',
};
const KS_VEHICLE_TYPE_ENUM = {
    // Passenger, Motorcycle, Moped, Truck, MiniTruck, Trailer, Motorhome, ATV, OHV, ORV, Vessel
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    MINI_TRUCK: 'MiniTruck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    ATV: 'ATV',
    OHV: 'OHV',
    ORV: 'ORV',
    VESSEL: 'Vessel',
};
const TN_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    GOLF_CART: 'GolfCart',
    LOW_SPEED: 'LowSpeed',
    MEDIUM_SPEED: 'MediumSpeed',
    OHV: 'OHV',
    SNOWMOBILE: 'Snowmobile',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    VESSEL: 'Vessel',
};
// VITU AzVehicleTypeEnum wire names, per the VITU National API v2 schema on stage.
// VITU has no off-highway or Moped value for AZ; any other value is rejected with a 400.
const AZ_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
};
const GA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
    SNOWMOBILE: 'Snowmobile',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
};
// VITU ScVehicleTypeEnum wire names, per the VITU National API v2 public schema.
// VITU has no off-highway value for SC; any other value is rejected with a 400.
const SC_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
};
const NC_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    FARMTRUCK: 'FarmTruck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    LOW_SPEED: 'LowSpeed',
    VESSEL: 'Vessel',
};
const OH_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    FARM_TRUCK: 'FarmTruck',
    FARM_TRACTOR: 'FarmTractor',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
    MINI_TRUCK: 'MiniTruck',
    GOLFCART: 'Golfcart',
    UTV: 'UTV',
    MOTORSCOOTER: 'Motorscooter',
    ATV: 'ATV',
};
const VA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    PICKUP_TRUCK: 'PickupTruck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    ATV: 'ATV',
    AUTOCYCLE: 'Autocycle',
    VESSEL: 'Vessel',
};
// VITU PaVehicleTypeEnum wire names, per the VITU National API v2 public schema.
// VITU has no off-highway value for PA; any other value is rejected with a 400.
const PA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOTORHOME: 'MotorHome',
    TRAILER: 'Trailer',
};
const WA_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    GOLFCART: 'GolfCart',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
    OHV: 'OHV',
    SNOWBIKE: 'SnowBike',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
// VITU NvVehicleTypeEnum wire names, verified on VITU stage /v2/fees on 2026-10-13.
// VITU has no off-highway value for NV; any other value is rejected with a 400.
const NV_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
};
const ID_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    MOPED: 'Moped',
    MOTORHOME: 'Motorhome',
    TRAILER: 'Trailer',
    AUTOCYCLE: 'Autocycle',
    ATV: 'ATV',
    UTV: 'UTV',
    SNOWMOBILE: 'Snowmobile',
    OHV: 'OHV',
    VESSEL: 'Vessel',
};
const IN_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRUCK: 'Truck',
    TRACTOR: 'Tractor',
    MINITRUCK: 'Minitruck',
    MOPED: 'Moped',
    MOTORDRIVENCYCLE: 'MotorDrivenCycle',
    MOTORSCOOTER: 'Motorscooter',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    ORV: 'ORV',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const ND_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    MOPED: 'Moped',
    TRUCK: 'Truck',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
    OHV: 'OHV',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const WY_VEHICLE_TYPE_ENUM = {
    PASSENGER: 'Passenger',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    MOTORHOME: 'Motorhome',
    TRUCK: 'Truck',
    ATV: 'ATV',
    GOLF_CART: 'Golfcart',
    SNOWMOBILE: 'Snowmobile',
    VESSEL: 'Vessel',
};
const ND_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    PLUG_IN_HYBRID: 'PlugInHybrid',
    OTHER: 'Other',
};
const DC_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    OTHER: 'Other',
};
const RI_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    FLEX: 'Flex',
    CNG: 'CNG',
    PROPANE: 'Propane',
    HYBRID: 'Hybrid',
};
const NH_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    PLUG_IN_HYBRID: 'PlugInHybrid',
    OTHER: 'Other',
};
const ME_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    FLEX: 'Flex',
    CNG: 'CNG',
    PROPANE: 'Propane',
    NONE: 'None',
};
const WV_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    BATTERY_ELECTRIC_VEHICLE: 'BatteryElectricVehicle',
    PLUG_IN_HYBRID_ELECTRIC_VEHICLE: 'PlugInHybridElectricVehicle',
    FUEL_CELL_VEHICLE: 'FuelCellVehicle',
    OTHER: 'Other',
    HYBRID: 'Hybrid',
};
const VT_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    PROPANE: 'Propane',
    OTHER: 'Other',
};
const SD_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    FLEX: 'Flex',
    CNG: 'CNG',
    PROPANE: 'Propane',
    NONE: 'None',
};
const NE_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
};
const IA_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    OTHER: 'Other',
};
const AL_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    OTHER: 'Other',
};
const KY_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
};
const MA_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    PROPANE: 'Propane',
    OTHER: 'Other',
};
const CT_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
};
const NJ_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    NATURAL_GAS_POWERED: 'NaturalGasPowered',
    PLUG_IN: 'PlugIn',
    OTHER: 'Other',
};
// VITU has no map for WI so we are creating our own as we learn about different fuel types from doing sampel T&R transactions
const WI_FUEL_TYPE_ENUM = {
    // Gas, Electric
    GAS: 'Gas',
    ELECTRIC: 'Electric',
};
const WY_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    OTHER: 'Other',
};
const CA_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    NATURAL_GAS_POWERED: 'NaturalGasPowered',
    ELECTRIC: 'Electric',
    FLEX_FUEL: 'FlexFuel',
    HYBRID_DIESEL_ELECTRIC: 'HybridDieselElectric',
    HYBRID_GASOLINE_ELECTRIC: 'HybridGasolineElectric',
    HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
    BUTANE: 'Butane',
    METHANOL: 'Methanol',
    PROPANE: 'Propane',
};
const DE_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    PLUG_IN: 'PlugIn',
    OTHER: 'Other',
};
const KS_FUEL_TYPE_ENUM = {
    // Gasoline, Diesel, Electric, HybridElectricPlugIn, Other
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID_ELECTRIC_PLUG_IN: 'HybridElectricPlugIn',
    OTHER: 'Other',
};
const MS_FUEL_TYPE_ENUM = {
    // Gasoline, Diesel, Electric, Hybrid, Other
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    OTHER: 'Other',
};
const AR_FUEL_TYPE_ENUM = {
    // Gas, Diesel, Hybrid, Electric, HydrogenatedOil, FlexFuel
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    HYDROGENATED_OIL: 'HydrogenatedOil',
    FLEX_FUEL: 'FlexFuel',
};
const TX_FUEL_TYPE_ENUM = {
    // Gas, NaturalGas, Diesel, Hybrid, FullHybrid, Electric, Hydrogen, Other
    GAS: 'Gas',
    NATURAL_GAS: 'NaturalGas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    FULL_HYBRID: 'FullHybrid',
    ELECTRIC: 'Electric',
    HYDROGEN: 'Hydrogen',
    OTHER: 'Other',
};
const OR_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    FLEX_FUEL: 'FlexFuel',
    PLUG_IN_HYBRID: 'PlugInHybrid',
    OTHER: 'Other',
};
const MN_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID_DIESEL: 'HybridDiesel',
    HYBRID_GASOLINE: 'HybridGasoline',
    ELECTRIC: 'Electric',
    OTHER: 'Other',
    UNKNOWN: 'Unknown',
};
const OK_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    PLUG_IN_HYBRID: 'PlugInHybrid',
    HYBRID: 'Hybrid',
    OTHER: 'Other',
};
const MT_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    LIQUID_PETROLEUM: 'LiquidPetroleum',
    PROPANE: 'Propane',
    OTHER: 'Other',
};
const MO_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
    LIQUID_NATURAL_GAS: 'LiquidNaturalGas',
    HYDROGEN: 'Hydrogen',
    PROPANE: 'Propane',
    SOLAR: 'Solar',
    PLUG_IN_HYBRID: 'PlugInHybrid',
    OTHER: 'Other',
};
const IL_FUEL_TYPE_ENUM = {
    // Gas, Diesel, Hybrid, Electric
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
};
const WA_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    PLUG_IN: 'PlugIn',
    ELECTRIC: 'Electric',
    OTHER: 'Other',
};
const NM_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
};
const MI_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    OTHER: 'Other',
};
const OH_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    HYDROGEN: 'Hybrid',
    ELECTRIC_OR_HYBRID: 'ElectricOrPlugInHybrid',
};
const CO_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    PLUG_IN: 'PlugIn',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    FLEX_FUEL: 'FlexFuel',
    OTHER: 'Other',
};
const FL_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
    LIQUIFIED_NATURAL_GAS: 'LiquifiedNaturalGas',
    LIQUIFIED_PETROLEUM_GAS: 'LiquifiedPetroleumGas',
    COMBINATION_CLEAN_FUEL: 'CombinationCleanFuel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    HYDROGEN: 'Hydrogen',
    METHANE: 'Methane',
    SOLAR_POWERED: 'SolarPowered',
};
const NY_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    FLEX: 'Flex',
    CNG: 'CNG',
    PROPANE: 'Propane',
    NONE: 'None',
};
const AZ_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    HYDROGEN: 'Hydrogen',
    SOLAR: 'Solar',
    OTHER: 'Other',
};
const GA_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    HYDROGEN: 'Hydrogen',
    SOLAR: 'Solar',
    OTHER: 'Other',
    FLEX_FUEL: 'FlexFuel',
    COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
    LIQUIFIED_NATURAL_GAS: 'LiquefiedNaturalGas',
    PROPANE: 'Propane',
};
const VA_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    LIQUIFIED_NATURAL_GAS: 'LiquifiedNaturalGas',
    OTHER: 'Other',
};
const PA_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    PROPANE: 'Propane',
    HYBRID: 'Hybrid',
    CONVERTIBLE: 'Convertible',
    FLEXIBLE: 'Flexible',
    ETHANOL: 'Ethanol',
    COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
    LIQUID_NATURAL_GAS: 'LiquidNaturalGas',
    METHANOL: 'Methanol',
    HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
    OTHER: 'Other',
    UNKNOWN: 'Unknown',
};
const NV_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    OTHER: 'Other',
};
const UT_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID_ELECTRIC: 'HybridElectric',
    PLUG_IN_HYBRID_ELECTRIC: 'PlugInHybridElectric',
    OTHER: 'Other',
};
const MD_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    FUEL_CELL: 'FuelCell',
};
const IN_FUEL_TYPE_ENUM = {
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    CNG: 'CNG',
    PROPANE: 'Propane',
};
const DEFAULT_FUEL_TYPE_ENUM = {
    // states using this enum [TN, SC, NC]
    GAS: 'Gas',
    DIESEL: 'Diesel',
    HYBRID: 'Hybrid',
    ELECTRIC: 'Electric',
    OTHER: 'Other',
};
const INTERNAL_COLOR_ENUM = {
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    DARKBLUE: 'DarkBlue',
    LIGHTBLUE: 'LightBlue',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    CHROMESTEEL: 'ChromeSteel',
    COPPER: 'Copper',
    CREAMIVORY: 'CreamIvory',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    DARKGREEN: 'DarkGreen',
    LIGHTGREEN: 'LightGreen',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROONBURGUNDY: 'MaroonBurgundy',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVERALUMINUM: 'SilverAluminum',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const MA_COLOR_ENUM = {
    BLACK: 'Black',
    BLUE: 'Blue',
    BROWN: 'Brown',
    RED: 'Red',
    YELLOW: 'Yellow',
    GREEN: 'Green',
    WHITE: 'White',
    GRAY: 'Gray',
    PURPLE: 'Purple',
    ORANGE: 'Orange',
    SILVER: 'Silver',
    GOLD: 'Gold',
};
const ME_COLOR_ENUM = {
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    BLUEDARK: 'BlueDark',
    BLUELIGHT: 'BlueLight',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    CHROMESTEEL: 'ChromeSteel',
    COPPER: 'Copper',
    CREAMIVORY: 'CreamIvory',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    GREENLIGHT: 'GreenLight',
    GREENDARK: 'GreenDark',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROONBURGUNDY: 'MaroonBurgundy',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVERALUMINUM: 'SilverAluminum',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const IL_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const KS_COLOR_ENUM = {
    // Beige, Black, Blue, DarkBlue, LightBlue, Brown, Bronze, ChromeSteel, Copper, CreamIvory, Gold, Gray, Green, DarkGreen, LightGreen, Ivory, Lavender, MaroonBurgundy, Orange, Pink, Purple, Red, SilverAluminum, Tan, Turquoise, White, Yellow
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    DARKBLUE: 'DarkBlue',
    LIGHTBLUE: 'LightBlue',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    CHROMESTEEL: 'ChromeSteel',
    COPPER: 'Copper',
    CREAMIVORY: 'CreamIvory',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    DARKGREEN: 'DarkGreen',
    LIGHTGREEN: 'LightGreen',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROONBURGUNDY: 'MaroonBurgundy',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVERALUMINUM: 'SilverAluminum',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const TX_COLOR_ENUM = {
    // Beige, Black, Blue, DarkBlue, LightBlue, Brown, Bronze, ChromeSteel, Copper, CreamIvory, Gold, Gray, Green, DarkGreen, LightGreen, Ivory, Lavender, MaroonBurgundy, Orange, Pink, Purple, Red, SilverAluminum, Tan, Turquoise, White, Yellow
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    DARKBLUE: 'DarkBlue',
    LIGHTBLUE: 'LightBlue',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    CHROMESTEEL: 'ChromeSteel',
    COPPER: 'Copper',
    CREAMIVORY: 'CreamIvory',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    DARKGREEN: 'DarkGreen',
    LIGHTGREEN: 'LightGreen',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROONBURGUNDY: 'MaroonBurgundy',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVERALUMINUM: 'SilverAluminum',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const WI_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const MN_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const OK_COLOR_ENUM = {
    BLACK: 'Black',
    BLUE: 'Blue',
    BRONZE: 'Bronze',
    BROWN: 'Brown',
    COPPER: 'Copper',
    CREAM: 'Cream',
    DARKBLUE: 'DarkBlue',
    DARKGREEN: 'DarkGreen',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    LAVENDER: 'Lavender',
    LIGHTBLUE: 'LightBlue',
    LIGHTGREEN: 'LightGreen',
    MAROON: 'Maroon',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVER: 'Silver',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const MT_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const WA_COLOR_ENUM = {
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    DARKBLUE: 'DarkBlue',
    LIGHTBLUE: 'LightBlue',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    CHROMESTEEL: 'ChromeSteel',
    COPPER: 'Copper',
    CREAMIVORY: 'CreamIvory',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    DARKGREEN: 'DarkGreen',
    LIGHTGREEN: 'LightGreen',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROONBURGUNDY: 'MaroonBurgundy',
    MULTICOLOR: 'Multicolor',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVERALUMINUM: 'SilverAluminum',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const LA_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const NM_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const OH_COLOR_ENUM = {
    LIGHTBLUE: 'LightBlue',
    TURQUOISE: 'Turquoise',
    DARKBLUE: 'DarkBlue',
    BLUE: 'Blue',
    AMETHYST: 'Amethyst',
    PURPLE: 'Purple',
    LAVENDER: 'Lavender',
    MAUVE: 'Mauve',
    PINK: 'Pink',
    RED: 'Red',
    MAROON: 'Maroon',
    ORANGE: 'Orange',
    COPPER: 'Copper',
    BRONZE: 'Bronze',
    TAN: 'Tan',
    GOLD: 'Gold',
    YELLOW: 'Yellow',
    LIGHTGREEN: 'LightGreen',
    GREEN: 'Green',
    DARKGREEN: 'DarkGreen',
    TEAL: 'Teal',
    BROWN: 'Brown',
    CREAM: 'Cream',
    BEIGE: 'Beige',
    TAUPE: 'Taupe',
    SILVER: 'Silver',
    CHROME: 'Chrome',
    GRAY: 'Gray',
    BLACK: 'Black',
    WHITE: 'White',
    CAMOUFLAGE: 'Camouflage',
    MULTICOLORED: 'MultiColored',
};
const CO_COLOR_ENUM = {
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    DARKBLUE: 'DarkBlue',
    LIGHTBLUE: 'LightBlue',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    BURGUNDY: 'Burgundy',
    CHROME: 'Chrome',
    COPPER: 'Copper',
    CREAM: 'Cream',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    DARKGREEN: 'DarkGreen',
    LIGHTGREEN: 'LightGreen',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROON: 'Maroon',
    MAUVEPURPLE: 'MauvePurple',
    MULTICOLORED: 'Multicolored',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PLATINUM: 'Platinum',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVER: 'Silver',
    STEEL: 'Steel',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const GA_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const NY_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const FL_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const MO_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const ID_COLOR_ENUM = INTERNAL_COLOR_ENUM;
const TN_COLOR_ENUM = {
    ALUMINUM: 'Aluminum',
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    BLUEDARK: 'BlueDark',
    BLUELIGHT: 'BlueLight',
    BRONZE: 'Bronze',
    BROWN: 'Brown',
    BURGUNDY: 'Burgundy',
    CAMOUFLAGE: 'Camouflage',
    CHROME: 'Chrome',
    COPPER: 'Copper',
    CREAM: 'Cream',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    GREENDARK: 'GreenDark',
    GREENLIGHT: 'GreenLight',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROON: 'Maroon',
    MAUVEPURPLE: 'MauvePurple',
    MULTICOLORED: 'Multicolored',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVER: 'Silver',
    STAINLESSSTEEL: 'StainlessSteel',
    TAN: 'Tan',
    TAUPEBROWN: 'TaupeBrown',
    TEALGREEN: 'TealGreen',
    TURQUOISEBLUE: 'TurquoiseBlue',
    WHITE: 'White',
    YELLOW: 'Yellow',
    UNDEFINED: 'Undefined',
};
const ND_COLOR_ENUM = {
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    BLUEDARK: 'BlueDark',
    BLUELIGHT: 'BlueLight',
    BROWN: 'Brown',
    BRONZE: 'Bronze',
    CHROMESTEEL: 'ChromeSteel',
    COPPER: 'Copper',
    CREAMIVORY: 'CreamIvory',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    GREENDARK: 'GreenDark',
    GREENLIGHT: 'GreenLight',
    IVORY: 'Ivory',
    LAVENDER: 'Lavender',
    MAROONBURGUNDY: 'MaroonBurgundy',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVERALUMINUM: 'SilverAluminum',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
const INTERNAL_BODY_TYPE_ENUM = {
    AMBULANCE: 'Ambulance',
    BUS: 'Bus',
    CABRIOLET: 'Cabriolet',
    CAMPER_TRAILER: 'CamperTrailer',
    CONVERTIBLE: 'Convertible',
    COUPE2D: 'Coupe2D',
    HATCHBACK3D: 'Hatchback3D',
    LIMOUSINE: 'Limousine',
    MANUFACTURED_HOME: 'ManufacturedHome',
    MOTORCYCLE: 'Motorcycle',
    MOTORHOME: 'MotorHome',
    MULTIPURPOSETRAILER: 'MultipurposeTrailer',
    PASSENGERVAN: 'PassengerVan',
    PICKUP: 'Pickup',
    ROADSTER: 'Roadster',
    SEDAN4D: 'Sedan4D',
    SPECIAL_MOBILE_MACHINERY: 'SpecialMobileMachinery',
    STATIONWAGON5D: 'StationWagon5D',
    TRACTOR: 'Tractor',
    TRAILER: 'Trailer',
    TRAILER_COACH: 'TrailerCoach',
    TRAILER_UTILITY: 'TrailerUtility',
    TRUCK: 'Truck',
    TRUCK_TRACTOR: 'TruckTractor',
    TRUCK_VAN: 'TruckVan',
    UTILITY_PASSENGER_SUV: 'UtilityPassengerSUV',
    UTILITY_TRUCK: 'UtilityTruck',
    TWODOOR: 'TwoDoor',
    FOURDOOR: 'FourDoor',
    GO_KART: 'Gokart',
    E_BIKE: 'E-Bike',
    BICYCLE: 'Bicycle',
    GOLF_CART: 'GolfCart',
    // Powersports
    ATV: 'ATV',
    SXS: 'SideBySide',
    UTV: 'UTV',
    SCOOTER: 'Scooter',
    MOPED: 'Moped',
    TRIKE: 'Trike',
    SNOWMOBILE: 'Snowmobile',
    DUAL_SPORT: 'DualSport',
    OFF_ROAD_MOTORCYCLE: 'OffRoadMotorcycle',
    // Boats / Watercraft
    PONTOON_BOAT: 'PontoonBoat',
    FISHING_BOAT: 'FishingBoat',
    BOWRIDER: 'Bowrider',
    CENTER_CONSOLE: 'CenterConsole',
    DECK_BOAT: 'DeckBoat',
    CABIN_CRUISER: 'CabinCruiser',
    SAILBOAT: 'Sailboat',
    JETSKI: 'Jetski',
    PERSONAL_WATERCRAFT: 'PersonalWatercraft',
    BOAT_OTHER: 'BoatOther',
};
// CA titles against a state-specific VehicleDTO whose bodyType is CaBodyTypeEnum,
// which uses CA DMV body-type-model tokens (e.g. 'Motorcycles_MC') rather than the
// generic 'Motorcycle'. The generic value is rejected as an invalid enum member.
const CA_BODY_TYPE_ENUM = {
    MOTORCYCLE: 'Motorcycles_MC',
    CABRIOLET: 'Convertible_CV', // CaBodyTypeEnum
};
const NJ_BODY_TYPE_ENUM = {
    TWODOOR: 'TwoDoor',
    FOURDOOR: 'FourDoor',
    PICKUPTRUCK: 'PickupTruck',
    TRUCK: 'Truck',
    VAN: 'Van',
    WAGON: 'Wagon',
    MOTORCYCLE: 'Motorcycle',
    TRAILER: 'Trailer',
    CONVERTIBLE: 'Convertible',
    TRACTOR: 'Tractor',
    MOTORHOME: 'Motorhome',
};
const NY_BODY_TYPE_ENUM = {
    TWODOOR: 'TwoDoor',
    FOURDOOR: 'FourDoor',
    CONVERTIBLE: 'Convertible',
    SUBURBANSUV: 'SuburbanSUV',
    PICKUP: 'PickUp',
    LIMO: 'Limo',
    MOTORCYCLE: 'Motorcycle',
    VAN: 'Van',
    TOW: 'Tow',
    TRAILER: 'Trailer',
    OTHER: 'Other',
};
const VA_BODY_TYPE_ENUM = {
    MOTORCYCLE: 'Motorcycle',
    CABRIOLET: 'Cabriolet', // CABRIOLET in VA Body Type Enum (not in swagger)
};
const MI_BODY_TYPE_ENUM = {
    TWODOOR: 'TwoDoor',
    FOURDOOR: 'FourDoor',
    AMBULANCE: 'Ambulance',
    BUS: 'Bus',
    CONVERTIBLE: 'Convertible',
    DUMP: 'Dump',
    HEARSE: 'Hearse',
    INCOMPLETE: 'Incomplete',
    LOWSPEEDVEHICLE: 'LowSpeedVehicle',
    MIXER: 'Mixer',
    MOTORHOME: 'Motorhome',
    MOTORCYCLE: 'Motorcycle',
    PANEL: 'Panel',
    PICKUP: 'Pickup',
    ROADSTER: 'Roadster',
    STAKE: 'Stake',
    STATIONWAGON: 'StationWagon',
    TANK: 'Tank',
    TRACTOR: 'Tractor',
    TRAILER: 'Trailer',
    TRAILERCOACH: 'TrailerCoach',
    UTILITY: 'Utility',
    VAN: 'Van',
    WRECKER: 'Wrecker',
};
const CO_BODY_TYPE_ENUM = {
    AMBULANCE: 'Ambulance',
    BUS: 'Bus',
    CAMPER_TRAILER: 'CamperTrailer',
    CONVERTIBLE: 'Convertible',
    COUPE2D: 'Coupe2D',
    HATCHBACK3D: 'Hatchback3D',
    LIMOUSINE: 'Limousine',
    MANUFACTURED_HOME: 'ManufacturedHome',
    MOTORCYCLE: 'Motorcycle',
    MOTORHOME: 'MotorHome',
    MULTIPURPOSETRAILER: 'MultipurposeTrailer',
    PASSENGERVAN: 'PassengerVan',
    PICKUP: 'Pickup',
    ROADSTER: 'Roadster',
    SEDAN4D: 'Sedan4D',
    SPECIAL_MOBILE_MACHINERY: 'SpecialMobileMachinery',
    STATIONWAGON5D: 'StationWagon5D',
    TRACTOR: 'Tractor',
    TRAILER: 'Trailer',
    TRAILER_COACH: 'TrailerCoach',
    TRAILER_UTILITY: 'TrailerUtility',
    TRUCK: 'Truck',
    TRUCK_TRACTOR: 'TruckTractor',
    TRUCK_VAN: 'TruckVan',
    UTILITY_PASSENGER_SUV: 'UtilityPassengerSUV',
    UTILITY_TRUCK: 'UtilityTruck',
};
const MT_BODY_TYPE_ENUM = {
    MOTORCYCLE: 'Motorcycle',
    SPORT_UTILITY_TRUCK: 'SportsUtilityTruck', // SPORT UTILITY TRUCK in MT Body Type Enum (not in swagger)
};
const DEFAULT_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 125,
    CABRIOLET: 43,
};
const NJ_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 6,
    FOURDOOR: 1,
};
const VA_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 105,
    CABRIOLET: 15, // CABRIOLET in VA Body Type Enum (not in swagger)
};
const TX_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 53,
    CONVERTIBLE: 22,
};
const OR_BODY_TYPE_ENUM = {
    MOTORCYCLE: 'MC_MOTORCYCLE_MC',
    CONVERTIBLE: 'CV_CONVERTIBLE_CV',
};
const OR_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 31,
    CONVERTIBLE: 489,
};
const NY_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 6,
    OTHER: 10,
};
const MI_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 11,
    FOURDOOR: 1, // 4 door in MI Body Type Enum
};
const PA_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 531,
    CABRIOLET: 519,
};
const CO_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 8,
    UTILITY_PASSENGER_SUV: 24,
    UTILITY_TRUCK: 25,
};
const MT_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 157,
    SPORT_UTILITY_TRUCK: 200, // SPORT UTILITY TRUCK in MT Body Type Enum (not in swagger)
};
const IL_BODY_TYPE_ID_ENUM = {
    MOTORCYCLE: 107,
    CABRIOLET: 20, // TODO
};
const INTERNAL_CYLINDER_TYPE_ENUM = {
    ZERO: 'Zero',
    ONE: 'One',
    TWO: 'Two',
    THREE: 'Three',
    FOUR: 'Four',
    FIVE: 'Five',
    SIX: 'Six',
    SEVEN: 'Seven',
    EIGHT: 'Eight',
    NINE: 'Nine',
    TEN: 'Ten',
    ELEVEN: 'Eleven',
    TWELVE: 'Twelve',
    ROTARY: 'Rotary',
};
const DEFAULT_CYLINDER_TYPE_ENUM = {
    ZERO: 'Zero',
    TWO: 'Two',
    FOUR: 'Four',
    SIX: 'Six',
    EIGHT: 'Eight',
};
const AR_CYLINDER_TYPE_ENUM = {
    // Zero, Two, Four, Five, Six, Eight
    ZERO: 'Zero',
    TWO: 'Two',
    FOUR: 'Four',
    FIVE: 'Five',
    SIX: 'Six',
    EIGHT: 'Eight',
};
const GA_CYLINDER_TYPE_ENUM = {
    ZERO: 'Zero',
    FOUR: 'Four',
    FIVE: 'Five',
    SIX: 'Six',
    EIGHT: 'Eight',
    TEN: 'Ten',
    ROTARY: 'Rotary',
};
// PLATE TYPE ENUMS
const NM_PLATE_TYPE_ENUM = {
    CENTENNIAL_PLATE: 'CentennialPlate',
};
const NC_PLATE_TYPE_ENUM = {
    AFGHANISTAN_VETERAN_PLATE: 'AfghanistanVeteranPlate',
    AIR_FORCE_ACADEMY_PLATE: 'AirForceAcademyPlate',
    AIR_FORCE_RESERVE_PLATE: 'AirForceReservePlate',
    AIR_MEDAL_RECIPIENT_PLATE: 'AirMedalRecipientPlate',
    AIRBORNE_MILITARY_PLATE: 'AirborneMilitaryPlate',
    ALPHA_KAPPA_ALPHA_PLATE: 'AlphaKappaAlphaPlate',
    ALPHA_PHI_ALPHA_PLATE: 'AlphaPhiAlphaPlate',
    AMATEUR_RADIO_PLATE: 'AmateurRadioPlate',
    AMERICAN_LEGION_PLATE: 'AmericanLegionPlate',
    ANIMAL_LOVERS_PLATE: 'AnimalLoversPlate',
    ARMY_RESERVE_PLATE: 'ArmyReservePlate',
    BATTLE_OF_KINGS_MOUNTAIN_PLATE: 'BattleOfKingsMountainPlate',
    BLUE_RIDGE_PARKWAY_FOUNDATION_PLATE: 'BlueRidgeParkwayFoundationPlate',
    BREAST_CANCER_AWARENESS_PLATE: 'BreastCancerAwarenessPlate',
    BRONZE_STAR_PLATE: 'BronzeStarPlate',
    BUDDY_PELLETIER_SURFING_FOUNDATION_PLATE: 'BuddyPelletierSurfingFoundationPlate',
    CAROLINA_PANTHERS_PLATE: 'CarolinaPanthersPlate',
    CHARLOTTE_HORNETS_PLATE: 'CharlotteHornetsPlate',
    CHOOSE_LIFE_FOUNDATION_PLATE: 'ChooseLifeFoundationPlate',
    COAST_GUARD_ACADEMY_PLATE: 'CoastGuardAcademyPlate',
    COAST_GUARD_AUXILIARY_PLATE: 'CoastGuardAuxiliaryPlate',
    COAST_GUARD_RESERVE_PLATE: 'CoastGuardReservePlate',
    COASTAL_LAND_TRUST_PLATE: 'CoastalLandTrustPlate',
    COLLEGIATE_INSIGNIA_PLATE: 'CollegiateInsigniaPlate',
    CONGRESSIONAL_MEDAL_OF_HONOR_PLATE: 'CongressionalMedalOfHonorPlate',
    DELTA_SIGMA_THETA_PLATE: 'DeltaSigmaThetaPlate',
    DESERT_STORM_VETERAN_PLATE: 'DesertStormVeteranPlate',
    DISABLED_PLATE: 'DisabledPlate',
    DISABLED_VETERAN_PLATE: 'DisabledVeteranPlate',
    DISTINGUISHED_FLYING_CROSS_PLATE: 'DistinguishedFlyingCrossPlate',
    DISTINGUISHED_SERVICE_CROSS_PLATE: 'DistinguishedServiceCrossPlate',
    DONATE_LIFE_PLATE: 'DonateLifePlate',
    DUCKS_UNLIMITED_PLATE: 'DucksUnlimitedPlate',
    FIRST_IN_FLIGHT_PLATE: 'FirstInFlightPlate',
    FIRST_IN_FLIGHT_PLATE_AIR_FORCE_RESERVE: 'FirstInFlightPlateAirForceReserve',
    FIRST_IN_FLIGHT_PLATE_ARMY_RESERVE: 'FirstInFlightPlateArmyReserve',
    FIRST_IN_FLIGHT_PLATE_COAST_GUARD_RESERVE: 'FirstInFlightPlateCoastGuardReserve',
    FIRST_IN_FLIGHT_PLATE_FIRE_DEPARTMENT: 'FirstInFlightPlateFireDepartment',
    FIRST_IN_FLIGHT_PLATE_FIRE_RESCUE_SQUAD: 'FirstInFlightPlateFireRescueSquad',
    FIRST_IN_FLIGHT_PLATE_MARINE_CORP_RESERVE: 'FirstInFlightPlateMarineCorpReserve',
    FIRST_IN_FLIGHT_PLATE_NAVY_RESERVE: 'FirstInFlightPlateNavyReserve',
    FIRST_IN_FLIGHT_PLATE_RESCUE_SQUAD: 'FirstInFlightPlateRescueSquad',
    FIRST_IN_FLIGHT_PLATE_RETIRED_AIR_FORCE: 'FirstInFlightPlateRetiredAirForce',
    FIRST_IN_FLIGHT_PLATE_RETIRED_ARMY: 'FirstInFlightPlateRetiredArmy',
    FIRST_IN_FLIGHT_PLATE_RETIRED_COAST_GUARD: 'FirstInFlightPlateRetiredCoastGuard',
    FIRST_IN_FLIGHT_PLATE_RETIRED_MARINE_CORP: 'FirstInFlightPlateRetiredMarineCorp',
    FIRST_IN_FLIGHT_PLATE_RETIRED_NAVY: 'FirstInFlightPlateRetiredNavy',
    FIRST_IN_FLIGHT_SHRINER_PLATE_AMRAN_TEMPLE: 'FirstInFlightShrinerPlateAmranTemple',
    FIRST_IN_FLIGHT_SHRINER_PLATE_OASIS_TEMPLE: 'FirstInFlightShrinerPlateOasisTemple',
    FIRST_IN_FLIGHT_SHRINER_PLATE_PRINCE_HALL: 'FirstInFlightShrinerPlatePrinceHall',
    FIRST_IN_FLIGHT_SHRINER_PLATE_SUDAN_TEMPLE: 'FirstInFlightShrinerPlateSudanTemple',
    FIRST_IN_FORESTRY_PLATE: 'FirstInForestryPlate',
    FIRST_IN_FREEDOM_PLATE: 'FirstInFreedomPlate',
    FIRST_IN_FREEDOM_PLATE_AIR_FORCE_RESERVE: 'FirstInFreedomPlateAirForceReserve',
    FIRST_IN_FREEDOM_PLATE_ARMY_RESERVE: 'FirstInFreedomPlateArmyReserve',
    FIRST_IN_FREEDOM_PLATE_COAST_GUARD_RESERVE: 'FirstInFreedomPlateCoastGuardReserve',
    FIRST_IN_FREEDOM_PLATE_FIRE_DEPARTMENT: 'FirstInFreedomPlateFireDepartment',
    FIRST_IN_FREEDOM_PLATE_FIRE_RESCUE_SQUAD: 'FirstInFreedomPlateFireRescueSquad',
    FIRST_IN_FREEDOM_PLATE_MARINE_CORP_RESERVE: 'FirstInFreedomPlateMarineCorpReserve',
    FIRST_IN_FREEDOM_PLATE_NAVY_RESERVE: 'FirstInFreedomPlateNavyReserve',
    FIRST_IN_FREEDOM_PLATE_RESCUE_SQUAD: 'FirstInFreedomPlateRescueSquad',
    FIRST_IN_FREEDOM_PLATE_RETIRED_AIR_FORCE: 'FirstInFreedomPlateRetiredAirForce',
    FIRST_IN_FREEDOM_PLATE_RETIRED_ARMY: 'FirstInFreedomPlateRetiredArmy',
    FIRST_IN_FREEDOM_PLATE_RETIRED_COAST_GUARD: 'FirstInFreedomPlateRetiredCoastGuard',
    FIRST_IN_FREEDOM_PLATE_RETIRED_MARINE_CORP: 'FirstInFreedomPlateRetiredMarineCorp',
    FIRST_IN_FREEDOM_PLATE_RETIRED_NAVY: 'FirstInFreedomPlateRetiredNavy',
    FIRST_IN_FREEDOM_SHRINER_PLATE_AMRAN_TEMPLE: 'FirstInFreedomShrinerPlateAmranTemple',
    FIRST_IN_FREEDOM_SHRINER_PLATE_OASIS_TEMPLE: 'FirstInFreedomShrinerPlateOasisTemple',
    FIRST_IN_FREEDOM_SHRINER_PLATE_PRINCE_HALL: 'FirstInFreedomShrinerPlatePrinceHall',
    FIRST_IN_FREEDOM_SHRINER_PLATE_SUDAN_TEMPLE: 'FirstInFreedomShrinerPlateSudanTemple',
    FRIENDS_OF_APPALACHIAN_TRAIL_PLATE: 'FriendsOfAppalachianTrailPlate',
    FRIENDS_OF_GREAT_SMOKEY_MOUNTAINS_NATIONAL_PARK_PLATE: 'FriendsOfGreatSmokeyMountainsNationalParkPlate',
    GOLD_STAR_LAPEL_PLATE: 'GoldStarLapelPlate',
    GUILDFORD_BATTLEGROUND_COMPANY_PLATE: 'GuildfordBattlegroundCompanyPlate',
    HOME_CARE_AND_HOSPICE_CARE_PLATE: 'HomeCareAndHospiceCarePlate',
    HOMES_4_NC_PLATE: 'Homes4NCPlate',
    IN_GOD_WE_TRUST_PLATE: 'InGodWeTrustPlate',
    INTERNATIONAL_ASSOCIATE_OF_FIREFIGHTERS_PLATE: 'InternationalAssociateOfFirefightersPlate',
    IRAQ_VETERAN_PLATE: 'IraqVeteranPlate',
    KAPPA_ALPHA_PSI_PLATE: 'KappaAlphaPsiPlate',
    KEEPING_LIGHTS_ON_PLATE: 'KeepingLightsOnPlate',
    KICK_CANCER_FOR_KIDS_PLATE: 'KickCancerForKidsPlate',
    KOREAN_CONFLICT_PLATE: 'KoreanConflictPlate',
    LEGION_OF_MERIT_PLATE: 'LegionOfMeritPlate',
    LEGION_OF_VALOR_PLATE: 'LegionOfValorPlate',
    LITTER_PREVENTION_PLATE: 'LitterPreventionPlate',
    MARINE_CORP_RESERVE_PLATE: 'MarineCorpReservePlate',
    MERCHANT_MARINE_ACADEMY_PLATE: 'MerchantMarineAcademyPlate',
    MILITARY_ACADEMY_PLATE: 'MilitaryAcademyPlate',
    MILITARY_AIR_FORCE_VETERAN_PLATE: 'MilitaryAirForceVeteranPlate',
    MILITARY_ARMY_VETERAN_PLATE: 'MilitaryArmyVeteranPlate',
    MILITARY_COAST_GUARD_PLATE: 'MilitaryCoastGuardPlate',
    MILITARY_MARINE_VETERAN_PLATE: 'MilitaryMarineVeteranPlate',
    MILITARY_NAVY_VETERAN_PLATE: 'MilitaryNavyVeteranPlate',
    MISSING_IN_ACTION_PLATE: 'MissingInActionPlate',
    MOUNTAINS_TO_SEA_TRAIL_PLATE: 'MountainsToSeaTrailPlate',
    NASCAR_PLATE_CHARLOTTE_MOTOR_SPEEDWAY: 'NascarPlateCharlotteMotorSpeedway',
    NASCAR_PLATE_CLINT_BOWYER: 'NascarPlateClintBowyer',
    NASCAR_PLATE_DALE_EARNHARDT_HALL_OF_FAME: 'NascarPlateDaleEarnhardtHallOfFame',
    NASCAR_PLATE_DALE_EARNHARDT_JR: 'NascarPlateDaleEarnhardtJr',
    NASCAR_PLATE_DANICA_PATRICK: 'NascarPlateDanicaPatrick',
    NASCAR_PLATE_DENNY_HAMLIN: 'NascarPlateDennyHamlin',
    NASCAR_PLATE_FORD_RACING: 'NascarPlateFordRacing',
    NASCAR_PLATE_HALL_OF_FAME: 'NascarPlateHallOfFame',
    NASCAR_PLATE_JIMMIE_JOHNSON: 'NascarPlateJimmieJohnson',
    NASCAR_PLATE_KASEY_KAHNE: 'NascarPlateKaseyKahne',
    NASCAR_PLATE_KEVIN_HARVICK: 'NascarPlateKevinHarvick',
    NASCAR_PLATE_KURT_BUSCH: 'NascarPlateKurtBusch',
    NASCAR_PLATE_KYLE_BUSCH: 'NascarPlateKyleBusch',
    NASCAR_PLATE_MARTIN_TRUEX: 'NascarPlateMartinTruex',
    NASCAR_PLATE_MATT_KENSETH: 'NascarPlateMattKenseth',
    NASCAR_PLATE_RACE_FAN: 'NascarPlateRaceFan',
    NASCAR_PLATE_RICHARD_PETTY_HISTORIC: 'NascarPlateRichardPettyHistoric',
    NASCAR_PLATE_RICKY_STENHOUSE_JR: 'NascarPlateRickyStenhouseJr',
    NASCAR_PLATE_STANDARD: 'NascarPlateStandard',
    NASCAR_PLATE_TREVOR_BAYNE: 'NascarPlateTrevorBayne',
    NATIONAL_MS_SOCIETY_PLATE: 'NationalMSSocietyPlate',
    NATIONAL_STATE_MOTTO_PLATE: 'NationalStateMottoPlate',
    NATIONAL_WILD_TURKEY_FEDERATION_PLATE: 'NationalWildTurkeyFederationPlate',
    NATIVE_BROOK_TROUT_PLATE: 'NativeBrookTroutPlate',
    NAVAL_ACADEMY_PLATE: 'NavalAcademyPlate',
    NAVY_RESERVE_PLATE: 'NavyReservePlate',
    NAVY_SUBMARINE_VETERAN_PLATE: 'NavySubmarineVeteranPlate',
    NC_ARTS_LICENSE_PLATE: 'NCArtsLicensePlate',
    NC_GOLF_ASSOCIATION_PLATE: 'NCGolfAssociationPlate',
    NC_SHERIFFS_ASSOCIATE_PLATE: 'NCSheriffsAssociatePlate',
    NC_TENNIS_FOUNDATION_PLATE: 'NCTennisFoundationPlate',
    NC_COASTAL_FEDERATION_PLATE: 'NCCoastalFederationPlate',
    NC_STATE_PARKS_PLATE: 'NCStateParksPlate',
    NC_TROUT_UNLIMITED_PLATE: 'NCTroutUnlimitedPlate',
    NC_WILDLIFE_HABITAT_FOUNDATION_PLATE: 'NCWildlifeHabitatFoundationPlate',
    NC_ZOOLOGICAL_SOCIETY_PLATE: 'NCZoologicalSocietyPlate',
    NURSES_PLATE: 'NursesPlate',
    OLYMPIC_GAMES_PLATE: 'OlympicGamesPlate',
    OMEGA_PSI_PHI_PLATE: 'OmegaPsiPhiPlate',
    PARTIALLY_DISABLED_VETERAN_PLATE: 'PartiallyDisabledVeteranPlate',
    PEARL_HARBOR_SURVIVOR_PLATE: 'PearlHarborSurvivorPlate',
    PERSONALIZED_DISABLED_PLATE: 'PersonalizedDisabledPlate',
    PHI_BETA_SIGMA_PLATE: 'PhiBetaSigmaPlate',
    PISGAH_CONSERVANCY_PLATE: 'PisgahConservancyPlate',
    PRISONER_OF_WAR_PLATE: 'PrisonerOfWarPlate',
    PROFESSIONAL_SPORTS_TEAM_PLATE: 'ProfessionalSportsTeamPlate',
    PURPLE_HEART_RECIPIENT_PLATE: 'PurpleHeartRecipientPlate',
    RETIRED_AIR_FORCE_PLATE: 'RetiredAirForcePlate',
    RETIRED_ARMY_PLATE: 'RetiredArmyPlate',
    RETIRED_COAST_GUARD_PLATE: 'RetiredCoastGuardPlate',
    RETIRED_HIGHWAY_PATROL_PLATE: 'RetiredHighwayPatrolPlate',
    RETRIED_LAW_ENFORCEMENT_PLATE: 'RetriedLawEnforcementPlate',
    RETIRED_MARINE_CORP_PLATE: 'RetiredMarineCorpPlate',
    RETIRED_NAVY_PLATE: 'RetiredNavyPlate',
    RONALD_MCDONALD_HOUSE_CHARATIES_PLATE: 'RonaldMcDonaldHouseCharatiesPlate',
    SAVE_HONEYBEE_PLATE: 'SaveHoneybeePlate',
    SAVE_SEA_TURTLES_PLATE: 'SaveSeaTurtlesPlate',
    SHARE_ROAD_PLATE: 'ShareRoadPlate',
    SHRINER_PLATE_AMRAN_TEMPLE: 'ShrinerPlateAmranTemple',
    SHRINER_PLATE_OASIS_TEMPLE: 'ShrinerPlateOasisTemple',
    SHRINER_PLATE_PRINCE_HALL: 'ShrinerPlatePrinceHall',
    SHRINER_PLATE_SUDAN_TEMPLE: 'ShrinerPlateSudanTemple',
    SILVER_STAR_DISABLED_VETERAN_PLATE: 'SilverStarDisabledVeteranPlate',
    SILVER_STAR_RECIPIENT_PLATE: 'SilverStarRecipientPlate',
    SOCIETY_OF_SURVEYORS_PLATE: 'SocietyOfSurveyorsPlate',
    SUPPORT_OUR_TROOPS_PLATE: 'SupportOurTroopsPlate',
    SUPPORT_SOCCER_PLATE: 'SupportSoccerPlate',
    TOBACCO_HERITAGE_PLATE: 'TobaccoHeritagePlate',
    VETERANS_OF_FOREIGN_AFFAIRS_PLATE: 'VeteransOfForeignAffairsPlate',
    VIETNAM_ERA_PLATE: 'VietnamEraPlate',
    VIETNAM_VETERAN_PLATE: 'VietnamVeteranPlate',
    WAR_ON_TERROR_PLATE: 'WarOnTerrorPlate',
    WATERMELON_PLATE: 'WatermelonPlate',
    WILDLIFE_PLATE: 'WildlifePlate',
    WORLD_WAR_II_PLATE: 'WorldWarllPlate',
    WRIGHTSVILLE_BEACH_PLATE: 'WrightsvilleBeachPlate',
    ZETA_PHI_BETA_PLATE: 'ZetaPhiBetaPlate',
};
const MI_PLATE_TYPE_ENUM = {
    PURE_MICHIGAN_PLATE: 'PureMichiganPlate',
};
const MS_PLATE_TYPE_ENUM = {
    REGULAR_PLATE: 'RegularPlate',
    HEARING_IMPAIRED_PLATE: 'HearingImpairedPlate',
    DIABETIC_PLATE: 'DiabeticPlate',
    BLACKOUT_PLATE: 'BlackoutPlate',
};
const IL_PLATE_TYPE_ENUM = {
    // DisabledVeteranPlate, StandardDisabledPlate, HearingImpairedPlate
    DISABLED_VETERAN_PLATE: 'DisabledVeteranPlate',
    STANDARD_DISABLED_PLATE: 'StandardDisabledPlate',
    HEARING_IMPAIRED_PLATE: 'HearingImpairedPlate',
};
const NV_PLATE_TYPE_ENUM = {
    PROFESSIONAL_FIREFIGHTER_PLATE: 'ProfessionalFirefighterPlate',
    PRISONER_OF_WAR_PLATE: 'PrisonerOfWarPlate',
    PURPLE_HEART_PLATE: 'PurpleHeartPlate',
    PEARL_HARBOR_VETERAN_PLATE: 'PearlHarborVeteranPlate',
    PEARL_HARBOR_SURVIVOR_PLATE: 'PearlHarborSurvivorPlate',
    CONGRESSIONAL_MEDAL_OF_HONOR_PLATE: 'CongressionalMedalOfHonorPlate',
    BRONZE_STAR_PLATE: 'BronzeStarPlate',
    SILVER_STAR_PLATE: 'SilverStarPlate',
    GOLD_STAR_PLATE: 'GoldStarPlate',
    AIR_FORCE_PLATE: 'AirForcePlate',
    AIR_NATIONAL_GUARD_PLATE: 'AirNationalGuardPlate',
    AIRBORNE_MILITARY_PLATE: 'AirborneMilitaryPlate',
    ARMY_NATIONAL_GUARD_PLATE: 'ArmyNationalGuardPlate',
    COAST_GUARD_PLATE: 'CoastGuardPlate',
    MARINE_CORPS_PLATE: 'MarineCorpsPlate',
    NAVY_LICENSE_PLATE: 'NavyLicensePlate',
    NAVY_SEABEES_PLATE: 'NavySeabeesPlate',
    DISABLED_VETERAN_PLATE: 'DisabledVeteranPlate',
    DISABLED_FEMALE_VETERAN_PLATE: 'DisabledFemaleVeteranPlate',
    AGRICULTURE_PLATE: 'AgriculturePlate',
    AMATEUR_RADIO_PLATE: 'AmateurRadioPlate',
    ANIMAL_APPRECIATION_PLATE: 'AnimalAppreciationPlate',
    AUTISM_AWARENESS_PLATE: 'AutismAwarenessPlate',
    CHILDHOOD_CANCER_AWARENESS_PLATE: 'ChildhoodCancerAwarenessPlate',
    CHILDREN_IN_THE_ARTS_PLATE: 'ChildrenInTheArtsPlate',
    CITIZENSHIP_PROJECT_PLATE: 'CitizenshipProjectPlate',
    CONSERVE_WILDLIFE_PLATE: 'ConserveWildlifePlate',
    DESERT_CONSERVATION_PLATE: 'DesertConservationPlate',
    GOLDEN_RULE_PLATE: 'GoldenRulePlate',
    HENDERSON_PLATE: 'HendersonPlate',
    HOOVER_DAM_PLATE: 'HooverDamPlate',
    HOT_AUGUST_NIGHTS_PLATE: 'HotAugustNightsPlate',
    LAKE_TAHOE_PLATE: 'LakeTahoePlate',
    LAS_VEGAS_CENTENNIAL_PLATE: 'LasVegasCentennialPlate',
    MISSING_EXPLOITED_CHILDREN_PLATE: 'MissingExploitedChildrenPlate',
    MOUNT_CHARLESTON_PLATE: 'MountCharlestonPlate',
    NEVADA_BIGHORNS_PLATE: 'NevadaBighornsPlate',
    NEVADA_FOREVER_STRONG_PLATE: 'NevadaForeverStrongPlate',
    NEVADA_HEALTH_CARE_PLATE: 'NevadaHealthCarePlate',
    NEVADA_TEST_SITE_PLATE: 'NevadaTestSitePlate',
    ORGAN_DONOR_PLATE: 'OrganDonorPlate',
    PYRAMID_LAKE_PLATE: 'PyramidLakePlate',
    RAIDERS_PLATE: 'RaidersPlate',
    RED_ROCK_CANYON_PLATE: 'RedRockCanyonPlate',
    RENO_AIR_RACES_PLATE: 'RenoAirRacesPlate',
    RODEO_PLATE: 'RodeoPlate',
    STEM_EDUCATION_PLATE: 'STEMEducationPlate',
    SUPPORT_WILDLIFE_PLATE: 'SupportWildlifePlate',
    UNITED_WE_STAND_PLATE: 'UnitedWeStandPlate',
    UNLV_COLLEGIATE_PLATE: 'UNLVCollegiatePlate',
    UNR_COLLEGIATE_PLATE: 'UNRCollegiatePlate',
    US_ARMY_PLATE: 'USArmyPlate',
    CIVIL_AIR_PATROL_PLATE: 'CivilAirPatrolPlate',
    EAGLE_SCOUT_OR_GIRL_SCOUT_PLATE: 'EagleScoutOrGirlScoutPlate',
    HONORARY_CONSUL_PLATE: 'HonoraryConsulPlate',
    MASONIC_LODGE_PLATE: 'MasonicLodgePlate',
    PRESS_PLATE: 'PressPlate',
    PEACE_OFFICER_PLATE: 'PeaceOfficerPlate',
    NATIONAL_GUARD_PLATE: 'NationalGuardPlate',
    FALLEN_MILITARY_PLATE: 'FallenMilitaryPlate',
    ELECTRIC_VEHICLE_PLATE: 'ElectricVehiclePlate',
    CIRCA_1982_REPLICA_PLATE: 'Circa1982ReplicaPlate',
    VEGAS_GOLDEN_KNIGHTS_PLATE: 'VegasGoldenKnightsPlate',
    VIRGINIA_AND_TRUCKEE_RAILROAD_PLATE: 'VirginiaAndTruckeeRailroadPlate',
    VOLUNTEER_FIRE_FIGHTER_PLATE: 'VolunteerFireFighterPlate',
    WOMENS_SUFFRAGE_PLATE: 'WomensSuffragePlate',
    WOMAN_VETERAN_PLATE: 'WomanVeteranPlate',
    DISABLED_PLATE: 'DisabledPlate',
    FRIENDS_OF_THE_METRO_PD: 'FriendsOfTheMetroPD',
    OPPORTUNITY_VILLAGE_PLATE: 'OpportunityVillagePlate',
    PUBLIC_EDUCATION_FOUNDATION_PLATE: 'PublicEducationFoundationPlate',
    LARGE_PLATE: 'LargePlate',
    SMALL_PLATE: 'SmallPlate',
    UNR_150_ANNIVERSARY_PLATE: 'UNR150AnniversaryPlate',
};
const UT_PLATE_TYPE_ENUM = {
    IN_GOD_WE_TRUST: 'InGodWeTrust',
    LIFE_ELEVATED_ARCHES: 'LifeElevatedArches',
    LIFE_ELEVATED_SKIER: 'LifeElevatedSkier',
};
const IN_PLATE_TYPE_ENUM = {
    DISABLED_PLATE: 'DisabledPlate',
    DISABLED_HOOSIER_VETERAN_PLATE: 'DisabledHoosierVeteranPlate',
    DISABLED_PURPLE_HEART_RECIPIENT_PLATE: 'DisabledPurpleHeartRecipientPlate',
    ARMED_FORCES_EXPEDITIONARY_MEDAL_PLATE: 'ArmedForcesExpeditionaryMedalPlate',
    GOLD_STAR_FAMILY_PLATE: 'GoldStarFamilyPlate',
    PURPLE_HEART_PLATE: 'PurpleHeartPlate',
    PRISONER_OF_WAR_PLATE: 'PrisonerOfWarPlate',
};
const ME_PLATE_TYPE_ENUM = {
    PLAIN_PLATE: 'PlainPlate',
};
const ID_PLATE_TYPE_ENUM = {
    Idaho4HPlate: 'Idaho4HPlate',
    ChooseLifePlate: 'ChooseLifePlate',
    MountainBikingLicensePlate: 'MountainBikingLicensePlate',
    SnowSkierLicensePlate: 'SnowSkierLicensePlate',
    WildlifePlate: 'WildlifePlate',
    PromoteAgricultureLicensePlate: 'PromoteAgricultureLicensePlate',
    IdahoAviationFoundationPlate: 'IdahoAviationFoundationPlate',
    PetLoversPlate: 'PetLoversPlate',
    SawtoothLicensePlate: 'SawtoothLicensePlate',
    SupportOurTroopsPlate: 'SupportOurTroopsPlate',
    AppaloosaLicensePlate: 'AppaloosaLicensePlate',
    FamousPotatoesPlate: 'FamousPotatoesPlate',
    IdahoRangelandLicensePlate: 'IdahoRangelandLicensePlate',
    PoliceOfficerMemorialLicensePlate: 'PoliceOfficerMemorialLicensePlate',
    SelwayBitterrootWildernessLicensePlate: 'SelwayBitterrootWildernessLicensePlate',
    TimberLicensePlate: 'TimberLicensePlate',
    CapitolCommissionLicensePlate: 'CapitolCommissionLicensePlate',
    FirefighterPlate: 'FirefighterPlate',
    LewisAndClarkLicensePlate: 'LewisAndClarkLicensePlate',
    SnowmobileLicensePlate: 'SnowmobileLicensePlate',
    WhiteWaterRaftingLicensePlate: 'WhiteWaterRaftingLicensePlate',
    YouthLicensePlate: 'YouthLicensePlate',
    StandardCentennialPlate: 'StandardCentennialPlate',
    MotorcyclePersonalizedPlate: 'MotorcyclePersonalizedPlate',
    StreetRodPlate: 'StreetRodPlate',
    PersonalizedStandardLicensePlate: 'PersonalizedStandardLicensePlate',
    VeteranPlate: 'VeteranPlate',
    NationalGuardLicensePlate: 'NationalGuardLicensePlate',
    MilitaryReserveLicensePlate: 'MilitaryReserveLicensePlate',
    GoldStarPlate: 'GoldStarPlate',
    PurpleHeartRecipientPlate: 'PurpleHeartRecipientPlate',
    AmateurRadioPlate: 'AmateurRadioPlate',
    PersonalizedDisabledLicensePlate: 'PersonalizedDisabledLicensePlate',
    StandardDisabilityPlate: 'StandardDisabilityPlate',
    DisabledVeteranRegistrationPlate: 'DisabledVeteranRegistrationPlate',
    DisabledVeteranPurpleHeartRecipientMedalPlate: 'DisabledVeteranPurpleHeartRecipientMedalPlate',
    BSUCollegiatePlate: 'BSUCollegiatePlate',
    BYUICollegiatePlate: 'BYUICollegiatePlate',
    CEICollegiatePlate: 'CEICollegiatePlate',
    CICollegiatePlate: 'CICollegiatePlate',
    CSICollegiatePlate: 'CSICollegiatePlate',
    ISUCollegiatePlate: 'ISUCollegiatePlate',
    LCSCCollegiatePlate: 'LCSCCollegiatePlate',
    NICCollegiatePlate: 'NICCollegiatePlate',
    NNUCollegiatePlate: 'NNUCollegiatePlate',
    UICollegiatePlate: 'UICollegiatePlate',
    CWICollegiatePlate: 'CWICollegiatePlate',
};
// REG PERIOD ENUMS
const VT_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    FIVE_YEARS: 'FiveYears',
};
const UT_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    SIX_MONTHS: 'SixMonths',
};
const OR_REG_PERIOD_TYPE_ENUM = {
    TWO_YEARS: 'TwoYears',
    FOUR_YEARS: 'FourYears',
    ONE_QUARTERS: 'OneQuarters',
    TWO_QUARTERS: 'TwoQuarters',
    THREE_QUARTERS: 'ThreeQuarters',
    FOUR_QUARTERS: 'FourQuarters',
};
const NJ_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    THREE_YEARS: 'ThreeYears',
    FOUR_YEARS: 'FourYears',
};
const VA_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    PERMANENT: 'Permanent',
};
const MT_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    PERMANENT: 'Permanent',
};
const MO_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    THREE_YEARS: 'ThreeYears',
    PERMANENT: 'Permanent',
};
const NM_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    PERMANENT: 'Permanent',
};
const PA_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    TWO_YEARS: 'TwoYears',
    FIVE_YEARS: 'FiveYears',
    PERMANENT: 'Permanent',
};
const NV_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
    THREE_YEARS: 'ThreeYears',
};
const OK_REG_PERIOD_TYPE_ENUM = {
    ONE_YEAR: 'OneYear',
};
const AR_PLATE_TYPE_ENUM = {
    // Standard, Disabled, Specialty
    STANDARD: 'Standard',
    DISABLED: 'Disabled',
    SPECIALTY: 'Specialty',
};
// Values are VITU's CoPlateTypeEnum wire names; VITU rejects any other string
// with a 400, which fails the fee quote and blocks checkout for CO buyers.
const CO_PLATE_TYPE_ENUM = {
    STANDARD: 'StandardPlate',
    DISABLED: 'DisabledPlate',
};
// FILING TYPE ENUMS
const WA_FILING_TYPE_ENUM = {
    TitleOnly: 'TitleOnly',
    TitleWithRegistration: 'TitleWithRegistration',
    Registration: 'Registration',
};
const FL_TITLE_TYPE_ENUM = {
    ELECTRONIC: 'ElectronicTitle',
    PAPER: 'PaperTitle',
};
// REG SERVICE TYPE ENUMS
const WA_REG_SERVICE_TYPE_ENUM = {
    ForTitleTransactions: 'ForTitleTransactions',
    TitleWithRegistration: 'TitleWithRegistration',
    AllOtherServices: 'AllOtherServices',
};
// USE TYPE ENUMS
const INTERNAL_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FOR_HIRE: 'ForHire',
    OFFHIGHWAY: 'Offhighway',
};
const DC_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const RI_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const ME_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const WV_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    OFFHIGHWAY: 'Offhighway',
};
const VT_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const SD_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM_PRODUCTION: 'FarmProduction',
    FOR_HIRE: 'ForHire',
};
const IA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const NE_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FOR_HIRE: 'ForHire',
};
const AL_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FOR_HIRE: 'ForHire',
};
const KY_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const ID_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM_PRODUCTION: 'OffHighway',
};
const MA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM_PRODUCTION: 'FarmProduction',
};
const CT_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    COMBINATION: 'Combination',
    CLASSIC: 'Classic',
    REGULAR: 'Regular',
    HEAVY_DUTY: 'HeavyDuty',
    SEASONAL: 'Seasonal',
    SEMITRAILER: 'SemiTrailer',
    FARM: 'Farm',
    SERVICE_BUS: 'ServiceBus',
    VANPOOL: 'Vanpool',
};
const NJ_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    RENTAL: 'Rental',
};
const MD_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    FARM_VEHICLE: 'FarmVehicle',
    ISLAND_VEHICLE: 'IslandVehicle',
    OFFHIGHWAY: 'OffHighway',
    CONSTRUCTION_VEHICLE: 'ConstructionVehicle',
};
const TX_USE_TYPE_ENUM = {
    // Personal, Commercial, OffHighway
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    OFFHIGHWAY: 'OffHighway',
};
const WI_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    DUAL_PURPOSE: 'DualPurpose',
};
const WY_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const OR_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const MN_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM_PRODUCTION: 'FarmProduction',
    FOR_HIRE: 'ForHire',
    RECREATIONAL: 'Recreational',
};
const OK_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM: 'Farm',
    FOREST: 'Forest',
};
const NC_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FOR_HIRE: 'ForHire',
};
const CO_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const SC_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const GA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FOR_HIRE: 'ForHire',
    COMMERCIAL_FARM: 'CommercialFarm',
};
const LA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const TN_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const MI_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM: 'Farm',
    FOR_HIRE: 'ForHire',
};
const NM_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
};
const MT_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    OFFHIGHWAY: 'OffHighway',
    COMMERCIAL: 'Commercial',
    PERSONALOFFHIGHWAY: 'PersonalOffHighway',
};
const NY_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM_VEHICLE: 'FarmVehicle',
    FOR_HIRE: 'ForHire',
};
const PA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FOR_HIRE: 'ForHire',
};
const VA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    FARM_PRODUCTION: 'FarmProduction',
    FOR_HIRE: 'ForHire',
};
const WA_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    OFFHIGHWAY: 'Offhighway',
    FARM_PRODUCTION: 'FarmProduction',
    GOVERNMENT: 'Government',
    EXEMPT: 'Exempt',
};
const NV_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    OFFHIGHWAY: 'OffHighway',
};
const UT_USE_TYPE_ENUM = {
    PERSONAL: 'Personal',
    COMMERCIAL: 'Commercial',
    FARM_VEHICLE: 'FarmVehicle',
    FOR_HIRE: 'ForHire',
    OFFHIGHWAY: 'OffHighway',
};
const INSURANCE_DOCUMENT_TYPE_ENUM = {
    DECLARATIONS_PAGE: 'DeclarationsPage',
    VERIFICATION_OF_INSURANCE: 'VerificationOfInsurance',
    INSURANCE_CARD: 'InsuranceCard',
    CERTIFICATE_OF_INSURANCE: 'CertificateOfInsurance',
    INSURANCE_BINDER: 'InsuranceBinder',
    INSURANCE_RECEIPT: 'InsuranceReceipt',
};
const INSURANCE_DOCUMENTS = {
    [INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE]: {
        name: 'Declarations page',
        description: 'Policy summary with coverages and limits',
        example_url: 'https://storage.googleapis.com/ad-backend-prod.appspot.com/assets/insuranceDocExamples/Insurance_Dec_Page.png',
    },
    [INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE]: {
        name: 'Verification of insurance',
        description: 'Proof you have active insurance coverage',
        example_url: 'https://storage.googleapis.com/ad-backend-prod.appspot.com/assets/insuranceDocExamples/Verification_Of_Insurance.png',
    },
    [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD]: {
        name: 'Insurance card',
        description: 'Wallet card with insurance policy details',
        example_url: 'https://storage.googleapis.com/ad-backend-prod.appspot.com/assets/insuranceDocExamples/Insurance_ID_Card.png',
    },
    [INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE]: {
        name: 'Certificate of insurance',
        description: 'Official proof of insurance for contracts',
        example_url: 'https://storage.googleapis.com/ad-backend-prod.appspot.com/assets/insuranceDocExamples/Certificate_Of_Insurance.png',
    },
    [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER]: {
        name: 'Insurance binder',
        description: 'Temporary proof of insurance coverage',
        example_url: 'https://storage.googleapis.com/ad-backend-prod.appspot.com/assets/insuranceDocExamples/Insurance_Binder.png',
    },
    [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_RECEIPT]: {
        name: 'Insurance receipt',
        description: 'Receipt confirming premium payment made',
    },
};
const INTERNAL_NUMBER_WHEELS_ENUM = {
    TWO: 2,
    THREE: 3,
};
// NUMBER OF MOTORCYCLE WHEELS ENUM
const MO_NUMBER_WHEELS_ENUM = {
    TWO: 'TwoWheel',
    THREE: 'ThreeWheel',
};
const SD_NUMBER_OF_WHEELS_ENUM = {
    ONE: 'OneWheel',
    TWO: 'TwoWheels',
    THREE: 'ThreeWheels',
    FOUR: 'FourWheels',
    FIVE: 'FiveWheels',
    SIX: 'SixWheels',
    SEVEN: 'SevenWheels',
    EIGHT: 'EightWheels',
};
const INTERNAL_ID_TYPE_ENUM = {
    MA_LICENSE_ID: 'MALicenseID',
    OUT_OF_STATE_LICENSE: 'OutOfStateLicense',
    OUT_OF_COUNTRY_LICENSE: 'OutOfCountryLicense',
    SOCIAL_SECURITY_NUMBER: 'SocialSecurityNumber',
    LAWFUL_PRESENCE: 'LawfulPresence',
    STATE_ID: 'StateID',
    DRIVER_LICENSE: 'DriverLicense',
    US_PASSPORT_PASSPORT_CARD: 'USPassport_PassportCard',
    VALID_US_MILITARY_ID: 'ValidUSMilitaryID',
    TRIBAL_IDENTIFICATION_CARD: 'TribalIdentificationCard',
    US_CITIZENSHIP_DOCUMENT: 'USCitizenshipDocument',
    VALID_FOREIGN_PASSPORT: 'ValidForeignPassport',
    CANADIAN_LICENSE_ID: 'CanadianLicenseID',
    MILITARY_ID: 'MilitaryID',
    PASSPORT: 'Passport',
    FOREIGN_ID: 'ForeignID',
};
const INTERNAL_DOORS_ENUM = {
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
};
const MA_DOORS_ENUM = {
    TWO: 'Two',
    THREE: 'Three',
    FOUR: 'Four',
    FIVE: 'Five',
};
const INTERNAL_TRANSMISSION_ENUM = {
    MANUAL: 'Manual',
    AUTOMATIC: 'Automatic',
};
const PAYMENT_TYPES = {
    // BUYER PAYMENTS
    STANDARD_RESERVATION: 'STANDARD_RESERVATION',
    LOAN_DOWNPAYMENT: 'LOAN_DOWNPAYMENT',
    CHECKOUT_FULL_PAYMENT: 'CHECKOUT_FULL_PAYMENT',
    KLARNA_CHECKOUT_FULL_PAYMENT: 'KLARNA_CHECKOUT_FULL_PAYMENT',
    CRYPTO_CHECKOUT_FULL_PAYMENT: 'CRYPTO_CHECKOUT_FULL_PAYMENT',
    ACH_CHECKOUT_FULL_PAYMENT: 'ACH_CHECKOUT_FULL_PAYMENT',
    IN_PERSON_PAYMENT: 'IN_PERSON_PAYMENT',
    EARLY_REMAINING_BALANCE: 'EARLY_REMAINING_BALANCE',
    LATE_REMAINING_BALANCE: 'LATE_REMAINING_BALANCE',
    LOAN_ADDITIONAL_DOWN: 'LOAN_ADDITIONAL_DOWN',
    // LENDER PAYMENTS
    LENDER_FULL_PAYMENT: 'LENDER_FULL_PAYMENT',
    // NON-EKHO PRECHECKOUT PAYMENTS
    PRECHECKOUT: 'PRECHECKOUT',
    // EKHO COLLECTED PREORDER PAYMENTS
    PREORDER_RESERVATION: 'PREORDER_RESERVATION',
    PREORDER_VIP_RESERVATION: 'PREORDER_VIP_RESERVATION',
};
// The payment intent types that originate from checkout
const CHECKOUT_PAYMENT_TYPES = [
    PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT,
    PAYMENT_TYPES.STANDARD_RESERVATION,
    PAYMENT_TYPES.LOAN_DOWNPAYMENT,
    PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT,
    PAYMENT_TYPES.CRYPTO_CHECKOUT_FULL_PAYMENT,
    PAYMENT_TYPES.ACH_CHECKOUT_FULL_PAYMENT,
    PAYMENT_TYPES.IN_PERSON_PAYMENT,
];
const PREORDER_PAYMENT_TYPES = [
    PAYMENT_TYPES.PREORDER_RESERVATION,
    PAYMENT_TYPES.PREORDER_VIP_RESERVATION,
];
const BUYER_PORTAL_PAYMENT_TYPES = [
    PAYMENT_TYPES.EARLY_REMAINING_BALANCE,
    PAYMENT_TYPES.LATE_REMAINING_BALANCE,
    PAYMENT_TYPES.LOAN_ADDITIONAL_DOWN,
];
/**
 * Which part of checkout a validation failure is attributed to, for reporting.
 *
 * Deliberately separate from the section label the buyer is shown: that label is
 * copy and may be reworded or absent (the inventory check has no on-page section
 * to name), while these identifiers have to stay stable for a year of dashboards.
 */
const CHECKOUT_ERROR_SECTIONS = {
    CONTACT: 'contact',
    REGISTRATION: 'registration',
    PAYMENT: 'payment',
    FULFILLMENT: 'fulfillment',
    TAXES: 'taxes',
    FEES: 'fees',
    INVENTORY: 'inventory',
};
/**
 * The pages of checkout a buyer moves between.
 *
 * Coarser than `CHECKOUT_ERROR_SECTIONS`, and for a different question: those
 * name which validator blocked an order, these name which screen the buyer was
 * looking at. The three carry very different meaning — leaving the configurator
 * is browsing, leaving a part-filled credit application is a lead worth
 * recovering — so both the navigation event and the abandonment events use this
 * one vocabulary rather than each naming the screens their own way.
 *
 * The app resolves these from its own `MODULES` and `CHECKOUT_SECTIONS` pair,
 * which together decide the rendered screen; the accessories step maps onto
 * `configurator` because the buyer experiences it as the same build flow.
 */
const CHECKOUT_PAGES = {
    CONFIGURATOR: 'configurator',
    GENERAL_CHECKOUT_INFO: 'general_checkout_info',
    CREDIT_APP: 'credit_app',
};
/**
 * Sections whose failures are Ekho's to fix rather than the buyer's. A blocked
 * order attributed only to these is an incident, not form friction, which is why
 * the two are reported as different failure classes.
 */
const CHECKOUT_SYSTEM_ERROR_SECTIONS = [
    CHECKOUT_ERROR_SECTIONS.TAXES,
    CHECKOUT_ERROR_SECTIONS.FEES,
];
/**
 * Stable identifier for each individual checkout validation failure.
 *
 * These exist so reporting never carries the rendered error copy. A message can be
 * reworded at will, and some are produced by a Formik schema rather than written
 * inline, so text is both unqueryable across releases and a standing risk of
 * interpolating buyer data into an analytics property. Two checks that mean the
 * same thing share one code even where the wording differs.
 */
const CHECKOUT_VALIDATION_ERROR_CODES = {
    PAYMENT_OPTION_MISSING: 'PAYMENT_OPTION_MISSING',
    PAYMENT_INITIALIZING: 'PAYMENT_INITIALIZING',
    PAYMENT_DETAILS_INCOMPLETE: 'PAYMENT_DETAILS_INCOMPLETE',
    BANK_ACCOUNT_NOT_CONNECTED: 'BANK_ACCOUNT_NOT_CONNECTED',
    BANK_ACCOUNT_NOT_AUTHORIZED: 'BANK_ACCOUNT_NOT_AUTHORIZED',
    BANK_ACCOUNT_NOT_APPROVED: 'BANK_ACCOUNT_NOT_APPROVED',
    TAXES_CALCULATING: 'TAXES_CALCULATING',
    TAXES_CALCULATION_FAILED: 'TAXES_CALCULATION_FAILED',
    FEES_CALCULATION_FAILED: 'FEES_CALCULATION_FAILED',
    SHIPPING_ADDRESS_MISSING: 'SHIPPING_ADDRESS_MISSING',
    SHIPPING_ADDRESS_INVALID: 'SHIPPING_ADDRESS_INVALID',
    SHIPPING_FEES_CALCULATING: 'SHIPPING_FEES_CALCULATING',
    DELIVERY_STATE_RESTRICTED: 'DELIVERY_STATE_RESTRICTED',
    PICKUP_LOCATION_MISSING: 'PICKUP_LOCATION_MISSING',
    PICKUP_FEES_MISSING: 'PICKUP_FEES_MISSING',
    HOME_ADDRESS_INVALID: 'HOME_ADDRESS_INVALID',
    TAR_OPTION_INVALID: 'TAR_OPTION_INVALID',
    INVENTORY_UNAVAILABLE: 'INVENTORY_UNAVAILABLE',
    CONTACT_NAME_INVALID: 'CONTACT_NAME_INVALID',
    CONTACT_EMAIL_INVALID: 'CONTACT_EMAIL_INVALID',
    CONTACT_PHONE_INVALID: 'CONTACT_PHONE_INVALID',
    CONTACT_FIELD_INVALID: 'CONTACT_FIELD_INVALID',
};
/** Maps a contact form field to its validation error code. */
const CONTACT_FIELD_ERROR_CODES = {
    fullName: CHECKOUT_VALIDATION_ERROR_CODES.CONTACT_NAME_INVALID,
    emailAddress: CHECKOUT_VALIDATION_ERROR_CODES.CONTACT_EMAIL_INVALID,
    phoneNumber: CHECKOUT_VALIDATION_ERROR_CODES.CONTACT_PHONE_INVALID,
};
/** How many blocked-order attempts one visit reports before the counter stops. */
const ORDER_VALIDATION_ATTEMPT_CAP = 10;
// Crypto checkout price limits
const CRYPTO_CHECKOUT_MIN = 0.5;
const CRYPTO_CHECKOUT_MAX = 50000;
// Clerq (ACH bank) checkout price limits. The bank option is withheld, and the
// server-owned Express bank charge refuses, at or above the max.
const CLERQ_CHECKOUT_MIN = 0;
const CLERQ_CHECKOUT_MAX = 25000;
// Payment choice titles for UI display
const PAYMENT_CHOICE_TITLES = {
    [PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT]: 'Card',
    [PAYMENT_TYPES.ACH_CHECKOUT_FULL_PAYMENT]: 'Bank',
    [PAYMENT_TYPES.LOAN_DOWNPAYMENT]: 'Finance with Ekho',
    [PAYMENT_TYPES.STANDARD_RESERVATION]: 'Reserve with card',
    [PAYMENT_TYPES.PREORDER_RESERVATION]: 'Reserve',
    [PAYMENT_TYPES.PREORDER_VIP_RESERVATION]: 'Reserve (VIP)',
    [PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT]: 'Finance with Klarna',
    [PAYMENT_TYPES.CRYPTO_CHECKOUT_FULL_PAYMENT]: 'Pay with Crypto',
    [PAYMENT_TYPES.IN_PERSON_PAYMENT]: 'Buy in person at a dealership',
};
// The 3 different umbrella descriptions of all payment intent types
const PAYMENT_DESCRIPTION_TYPES = {
    PREORDER_PAYMENT: {
        description: 'Preorder Payment',
        paymentTypes: [PAYMENT_TYPES.PREORDER_RESERVATION, PAYMENT_TYPES.PREORDER_VIP_RESERVATION],
    },
    RESERVATION_PAYMENT: {
        description: 'Reservation Payment',
        paymentTypes: [PAYMENT_TYPES.STANDARD_RESERVATION, PAYMENT_TYPES.LOAN_DOWNPAYMENT],
    },
    REMAINING_BALANCE_PAYMENT: {
        description: 'Remaining Balance Payment',
        paymentTypes: [
            PAYMENT_TYPES.EARLY_REMAINING_BALANCE,
            PAYMENT_TYPES.LATE_REMAINING_BALANCE,
            PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT,
            PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT,
            PAYMENT_TYPES.CRYPTO_CHECKOUT_FULL_PAYMENT,
            PAYMENT_TYPES.LENDER_FULL_PAYMENT,
            PAYMENT_TYPES.ACH_CHECKOUT_FULL_PAYMENT,
        ],
    },
    LOAN_ADDITIONAL_DOWN: {
        description: 'Loan Additional Down Payment',
        paymentTypes: [PAYMENT_TYPES.LOAN_ADDITIONAL_DOWN],
    },
    IN_PERSON_PAYMENT: {
        description: 'In-Person Purchase',
        paymentTypes: [PAYMENT_TYPES.IN_PERSON_PAYMENT],
    },
};
const PAYMENT_RECIPIENTS = {
    DEALER: 'DEALER',
    EKHO: 'EKHO',
    OEM: 'OEM',
};
// This is equivalent to 2 days (in milliseconds)
const NUDGE_INACTIVE_BUYER = 172800000;
// This is equivalent to 1 week (in milliseconds)
const NUDGE_BUYER_AGAIN = 604800000;
// The following are estimated due dates for BUYER_ACTION_ITEMS defined in getBuyerActionItems()
// 86400000 is equivalent to 1 day in milliseconds, so simply edit by multiplying by # of days
const BUYER_DUE_DATES = {
    // Added to datePurchased
    SIGN_OFF_BY: 86400000 * 1,
    // Added to datePurchased
    FINANCE_BY: 86400000 * 3,
    // This is days since lender decision is given
    LOAN_DECISION_BY: 86400000 * 2,
    // Added to datePurchased
    REGISTRATION_BY: 86400000 * 5,
    // Added to datePurchased
    INSURANCE_BY: 86400000 * 10,
    // This is subtracted from estimatedDeliveryDate
    PAYMENT_BY: 86400000 * 10,
    // Added to datePurchased
    PAPERWORK_BY: 86400000 * 15,
};
const BUYER_BLOCKED_ENUM = {
    VIN_NOT_ASSIGNED: 'VinNotAssigned',
    TAR_MANUAL_INTERVENTION_REQUIRED: 'TarManualInterventionRequired',
    ODOMETER_READING_NOT_ASSIGNED: 'OdometerReadingNotAssigned',
    NO_VALID_INSURANCE: 'NoValidInsurance',
    NO_FULFILLMENT_DETAILS: 'NoFulfillmentDetails',
    NO_FINANCING_DECISION: 'NoFinancingDecision',
    PAYMENT_PROCESSING: 'PaymentProcessing',
    NO_PAPERWORK_GENERATED: 'NoPaperworkGenerated',
    // Dealer BoS review (OPSENG-863): the BoS doc set is created but pending
    // counter-signer review, so the buyer can't yet sign at the paperwork step.
    REVIEW_PENDING_BOS: 'ReviewPendingBos',
    // Dealer BoS review (OPSENG-863): PA doc set is created but pending
    // counter-signer review, so the buyer can't yet sign at SIGN_OFF.
    REVIEW_PENDING_PA: 'ReviewPendingPa',
};
const STARK_HPS = {
    SIXTY_HPS: 60,
    EIGHTY_HPS: 80,
};
const OEM_REPORT_CATEGORY_ENUM = {
    SALES: 'Sales',
    FEES: 'Fees',
};
const OEM_REPORT_KEY_ENUM = {
    SALES_BY_CUSTOMER_NAME: 'SalesByCustomerName',
    TAXES_AND_FEES_BY_VEHICLE: 'TaxesAndFeesByVehicle',
    OUTGOING_PAYMENTS: 'OutgoingPayments',
    FEES_BY_VEHICLE: 'FeesByVehicle',
};
const ALL_REPORTS = [
    {
        key: OEM_REPORT_KEY_ENUM.SALES_BY_CUSTOMER_NAME,
        name: 'Sales by Customer Name',
        categories: [OEM_REPORT_CATEGORY_ENUM.SALES],
    },
    {
        key: OEM_REPORT_KEY_ENUM.FEES_BY_VEHICLE,
        name: 'Fees by Vehicle',
        categories: [OEM_REPORT_CATEGORY_ENUM.FEES],
    },
    {
        key: OEM_REPORT_KEY_ENUM.OUTGOING_PAYMENTS,
        name: 'Outgoing Payments',
        categories: [OEM_REPORT_CATEGORY_ENUM.FEES],
    },
    // Add more report definitions here in the future
];
const TWILIO_TEST_NUMBER = '+15005550006';
const TWILIO_PROD_NUMBER = '+18447530817';
const TWILIO_SMS_MESSAGES = {
    ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
    PREORDER_CONFIRMATION: 'PREORDER_CONFIRMATION',
    PREORDER_CONVERSION: 'PREORDER_CONVERSION',
    LENDER_DECISION: 'LENDER_DECISION',
    CONDITIONAL_OFFER: 'CONDITIONAL_OFFER',
    RIC_SIGNATURE: 'RIC_SIGNATURE',
    ACH_FAILED: 'ACH_FAILED',
    CREDIT_APPLICATION_NOT_COMPLETED: 'CREDIT_APPLICATION_NOT_COMPLETED',
    STIPS_NOT_VALIDATED_AND_EVIDENCE_NEEDED: 'STIPS_NOT_VALIDATED_AND_EVIDENCE_NEEDED',
    FINANCING_DECISION_NOT_ACCEPTED: 'FINANCING_DECISION_NOT_ACCEPTED',
    IDENTITY_VERIFICATION_NOT_COMPLETED: 'IDENTITY_VERIFICATION_NOT_COMPLETED',
    BOS_NOT_SIGNED: 'BOS_NOT_SIGNED',
    DAILY_SALES_SUMMARY: 'DAILY_SALES_SUMMARY',
    CREDIT_REAPPLICATION_TRIGGERED: 'CREDIT_REAPPLICATION_TRIGGERED',
};
const CREDIT_AGENCIES = {
    TRANSUNION: 'TransUnion',
    EXPERIAN: 'Experian',
    EQUIFAX: 'Equifax',
};
const GOOGLE_AUTOCOMPLETE_LIBRARIES = ['places'];
const GOOGLE_AUTOCOMPLETE_AND_MAPS_LIBRARIES = ['places', 'geometry'];
const SENSITIVE_DATA_FIELDS = ['ssn', 'dob', 'dlNumber'];
const STRIPE_CREDIT_CARD_FEE_PERCENT = 1 / (1 - 0.029) - 1;
const STRIPE_TRANSACTION_FEE_AMOUNT = 0.3;
const STRIPE_PAYOUT_FEE_PERCENT = 0.0025;
const additionalFieldsMap = GOOGLE_AUTOCOMPLETE_LIBRARIES;
const LOAD_TESTING_PAYMENT_INTENT_ID = 'pi_3PJFLMI47LxGASce1SbTqWow';
/* DEVELOPMENT/STAGING OEM CONSTS */
const BP_OEM_KEY = 'bp-test-oem';
const BP_OEM_ID = 'bp-test-oem-id';
const BACKEND_BP_OEM_KEY = 'backend-bp-test-oem';
const BACKEND_BP_OEM_ID = 'backend-bp-test-oem-id';
const CHECKOUT_OEM_KEY = 'checkout-test-oem';
const CHECKOUT_OEM_ID = 'checkout-test-oem-id';
const DEV_OEM_KEY = 'dev-project-key';
const DEV_BRAND_KEY = 'dev-brand-key';
const DEV_OEM_ID = 'dev-oem-id';
const DEMO_BRAND_KEY = 'demo-brand-key';
const DEMO_OEM_ID = 'demo-oem-id';
/* END DEVELOPMENT/STAGING OEM CONSTS */
/* PROD OEM CONSTS */
const JANUS_OEM_KEY = 'janus';
const JANUS_OEM_ID = 'QczG5nHitwkBiiQBFiLW';
const MOKE_OEM_KEY = 'moke';
const MOKE_OEM_ID = '4FhrbkWLHYkGnLjsxh7S';
const LAND_OEM_KEY = 'land';
const LAND_OEM_ID = 'Dw11Hij5QzzTenm6Odbf';
const PICKMAN_OEM_KEY = 'pickman';
const PICKMAN_OEM_ID = 'GJBxwpJIcckYRUj2FRBE';
const MAEVING_OEM_KEY = 'maeving';
const MAEVING_OEM_ID = 'QZzao3tGSmDzt94SfAWG';
const STARK_OEM_KEY = 'stark';
const STARK_OEM_ID = 'Ju81l5hQ84wFV9M4qz5b';
const POWERPLUS_OEM_KEY = 'powerplus';
const POWERPLUS_OEM_ID = 'AACt7ZVbJOj72VLIImVp';
const INFINITE_MACHINE_OEM_KEY = 'infinitemachine';
const INFINITE_MACHINE_OEM_ID = 'Vmh8UEJmHNSp3y8V6Iah';
const NAXEON_OEM_KEY = 'naxeon';
const NAXEON_OEM_ID = 'PopnkzSwozYYHEVTgYji';
const PINNED_OEM_KEY = 'pinnedelectric';
const BAKCOU_OEM_KEY = 'bakcou';
const BAKCOU_OEM_ID = 'VKECfSSBPRfgAhCf1Xtx';
const NIU_OEM_KEY = 'niu';
const NIU_OEM_ID = 'vRDPTlx0iYpapCrcVzYH';
const ZERO_OEM_KEY = 'zero';
const ZERO_OEM_ID = 'HtkZJuOQNvJcce1n7zJo';
const DUST_OEM_KEY = 'dust';
const DUST_OEM_ID = '18gXllTJbLOJwdffMOsb';
const PAVE_OEM_KEY = 'pave';
const PAVE_OEM_ID = 'zJ5qYxnHWHyreIV2nSI1';
const LIVEWIRE_OEM_KEY = 'livewire';
const LIVEWIRE_OEM_ID = 'x81l2N5CvgQjINb2MCbU';
const MASSIMO_OEM_KEY = 'massimo';
const MASSIMO_OEM_ID = 'SrwoTk9EU1H0KAaPFJBJ';
const BONNELL_OEM_KEY = 'bonnell';
const BONNELL_OEM_ID = 'Jw8udgBsAXMjrjLML49Y';
const CCW_OEM_KEY = 'ccw';
const CCW_OEM_ID = 'raCp4HgGXVEAOEfL1bDu';
const MUNROE_MOTORS_OEM_KEY = 'munroemotors';
const MUNROE_MOTORS_OEM_ID = 'munroemotors';
const RENA_OEM_KEY = 'rena';
const RENA_OEM_ID = 'wmqi57D0VejCIfg6QGEA';
// BRANDS
const ARCTIC_LEOPARD_BRAND_KEY = 'arcticleopard';
const ARCTIC_LEOPARD_OEM_ID = 'VMkxU71XsTQEuNZrEppm';
const VENTUS_BRAND_KEY = 'ventus';
const VENTUS_OEM_ID = 'Drso8RcbqUuG6vHBbCUT';
const BAKCOU_BRAND_KEY = 'bakcou';
const NIU_BRAND_KEY = 'niu';
const ZERO_BRAND_KEY = 'zero';
const DUST_BRAND_KEY = 'dust';
const PAVE_BRAND_KEY = 'pave';
const LIVEWIRE_BRAND_KEY = 'livewire';
const MASSIMO_BRAND_KEY = 'massimo';
const BONNELL_BRAND_KEY = 'bonnell';
const CCW_BRAND_KEY = 'ccw';
const MUNROE_MOTORS_BRAND_KEY = 'munroemotors';
const RENA_BRAND_KEY = 'rena';
const STAREV_OEM_KEY = 'starev';
const STAREV_OEM_ID = 'pV4eAX96zsIT5Mqv5AcE';
const STAREV_BRAND_KEY = 'starev';
/* END PROD OEM CONSTS */
const INPUT_TYPES = {
    TEXT_INPUT: 'INPUT',
    SELECT: 'SELECT',
    CHECK: 'CHECK',
    CHECK_SELECT: 'CHECK_SELECT',
    DATE: 'DATE',
    ADDRESS: 'ADDRESS',
    TITLE_DIVIDER: 'TITLE_DIVIDER',
    TEXT_AREA: 'TEXT_AREA',
};
// Map from oemKey to firebase database project id
const OEM_KEY_TO_PROJECT_MAP = {
    e2etestoem: 'e2etestoem-prod',
    janus: 'janus-prod-a3c47',
    moke: 'moke-3b4f5',
    land: 'land-prod-ddbc9',
    pickman: 'pickman-prod',
    maeving: 'maeving-prod',
    stark: 'stark-prod-631be',
    powerplus: 'powerplus-prod',
    naxeon: 'naxeon-prod',
    infinitemachine: 'infinitemachine-prod',
    [DEV_OEM_KEY]: 'airdealer-67669',
    pinnedelectric: 'pinned-prod',
    bakcou: 'bakcou-prod',
    niu: 'niu-prod-2e9d3',
    zero: 'zero-prod-8f2dc',
    dust: 'dust-prod-cfcf6',
    pave: 'pave-prod',
    livewire: 'livewire-prod',
    massimo: 'massimo-prod',
    bonnell: 'bonnell-prod',
    ccw: 'ccw-prod-04222025',
    munroemotors: 'munroemotors-prod',
    rena: 'rena-prod',
    starev: 'starev-prod-07152025',
};
const oemMap = {
    [CHECKOUT_OEM_KEY]: CHECKOUT_OEM_ID,
    [BP_OEM_KEY]: BP_OEM_ID,
    // e2etestoem: 'Ju81l5hQ84wFV9M4qz5b',
    [JANUS_OEM_KEY]: JANUS_OEM_ID,
    [MOKE_OEM_KEY]: MOKE_OEM_ID,
    [LAND_OEM_KEY]: LAND_OEM_ID,
    [PICKMAN_OEM_KEY]: PICKMAN_OEM_ID,
    [MAEVING_OEM_KEY]: MAEVING_OEM_ID,
    [STARK_OEM_KEY]: STARK_OEM_ID,
    [POWERPLUS_OEM_KEY]: POWERPLUS_OEM_ID,
    [INFINITE_MACHINE_OEM_KEY]: INFINITE_MACHINE_OEM_ID,
    [NAXEON_OEM_KEY]: NAXEON_OEM_ID,
    [PINNED_OEM_KEY]: {
        [ARCTIC_LEOPARD_BRAND_KEY]: ARCTIC_LEOPARD_OEM_ID,
        [VENTUS_BRAND_KEY]: VENTUS_OEM_ID,
    },
    [BAKCOU_OEM_KEY]: {
        [BAKCOU_BRAND_KEY]: BAKCOU_OEM_ID,
    },
    [NIU_OEM_KEY]: {
        [NIU_BRAND_KEY]: NIU_OEM_ID,
    },
    [ZERO_OEM_KEY]: {
        [ZERO_BRAND_KEY]: ZERO_OEM_ID,
    },
    [DUST_OEM_KEY]: {
        [DUST_BRAND_KEY]: DUST_OEM_ID,
    },
    [PAVE_OEM_KEY]: {
        [PAVE_BRAND_KEY]: PAVE_OEM_ID,
    },
    [LIVEWIRE_OEM_KEY]: {
        [LIVEWIRE_BRAND_KEY]: LIVEWIRE_OEM_ID,
    },
    [MASSIMO_OEM_KEY]: {
        [MASSIMO_BRAND_KEY]: MASSIMO_OEM_ID,
    },
    [BONNELL_OEM_KEY]: {
        [BONNELL_BRAND_KEY]: BONNELL_OEM_ID,
    },
    [CCW_OEM_KEY]: {
        [CCW_BRAND_KEY]: CCW_OEM_ID,
    },
    [MUNROE_MOTORS_OEM_KEY]: {
        [MUNROE_MOTORS_BRAND_KEY]: MUNROE_MOTORS_OEM_ID,
    },
    [RENA_OEM_KEY]: {
        [RENA_BRAND_KEY]: RENA_OEM_ID,
    },
    // DEV and DEMO
    [DEV_OEM_KEY]: {
        [DEV_BRAND_KEY]: DEV_OEM_ID,
        [DEMO_BRAND_KEY]: DEMO_OEM_ID,
    },
    [STAREV_OEM_KEY]: {
        [STAREV_BRAND_KEY]: STAREV_OEM_ID,
    },
};
const MIN_FIELDS_TO_COLLECT = {
    CARRIER_NAME: 'carrierName',
    POLICY_ID: 'policyId',
    EFFECTIVE_DATE: 'effectiveDate',
    EXPIRY_DATE: 'expiryDate',
    POLICY_NUMBER: 'carrierPolicyNumber',
    AGENT_OR_BROKER_NAME: 'agentBrokerName',
    POLICY_NAME: 'name',
    ISSUING_STATE: 'issuingState',
    POLICY_TYPE: 'policyType',
};
// map to stripe id document types
const ID_DOCUMENT_TYPE_ENUM = {
    DRIVERS_LICENSE: 'driving_license',
    ID_CARD: 'id_card',
    PASSPORT: 'passport',
};
const PROMOTION_TYPES = {
    FINANCING: 'FINANCING',
};
const FinancingActionItemOptions = {
    WAIT_FOR_SUBMISSION_WINDOW: 'WAIT_FOR_SUBMISSION_WINDOW',
    SUBMIT_CREDIT_APP_AND_REPORT_DECISION: 'SUBMIT_CREDIT_APP_AND_REPORT_DECISION',
    GATHER_ADDITIONAL_INFO: 'GATHER_ADDITIONAL_INFO',
    PERFORM_PREAUDIT: 'PERFORM_PREAUDIT',
    SIGN_DOCS: 'SIGN_DOCS',
    SUBMIT_FUNDING_PACKAGE: 'SUBMIT_FUNDING_PACKAGE',
    WAIT_FOR_FUNDED_NOTICE: 'WAIT_FOR_FUNDED_NOTICE',
    BLOCKED: 'BLOCKED',
    COMPLETE: 'COMPLETE',
};
const abbrevStateNamesArr = [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];
// FOR BELOW FIELDS MAP:
// If type is INPUT_TYPES.CHECK
// - needs fields:
//   - checkLabel
//   - type: INPUT_TYPES.CHECK
//   - label
//   - yup
// 	 - title
// If type is INPUT_TYPES.INPUT
// - needs fields:
//   - inputType (text, date, tel)
//   - type: INPUT_TYPES.INPUT
//   - label
//   - yup
//   - title
// If type is INPUT_TYPES.SELECT
// - needs fields:
//   - list: [
//			{ value: <val_1>, text: <display_text_1> },
//  		{ value: <val_2,  text: <display_text_2> },
//  		...
// 		]
//   - type: INPUT_TYPES.INPUT
//   - label
//   - yup
//   - title
const ADDITIONAL_FIELDS_MAP = {
    isOwnerResident: {
        type: INPUT_TYPES.CHECK_SELECT,
        checkLabel: 'Are you a resident of the registration state?',
        label: 'Are you a resident of the registration state?',
        yup: Yup.boolean().required('Required'),
        title: 'Residency status',
        defaultValue: true,
    },
    residedInForMoreThan6Months: {
        type: INPUT_TYPES.CHECK_SELECT,
        checkLabel: 'Have you lived here for over 6 months?',
        label: 'Have you lived here for over 6 months?',
        yup: Yup.boolean().required('Required'),
        title: 'Length of residency',
        defaultValue: true,
    },
    addressIsInUnincorporatedArea: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Is your address in an unincorporated area?',
        label: 'Is your address in an unincorporated area?',
        yup: Yup.boolean().required('Required'),
        title: 'Unincorporated area',
        defaultValue: true,
    },
    ssn: {
        type: INPUT_TYPES.TEXT_INPUT,
        inputType: 'text',
        label: 'Social Security Number',
        yup: Yup.string()
            .required('SSN is required')
            .matches(/^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/, 'Please ensure your SSN is in the correct format'),
        title: 'Social Security Number',
        mask: '999-99-9999',
    },
    isOwnerSpouseOfMilitary: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Are you the spouse of a member of the military?',
        label: 'Spouse to military member',
        // Only relevant when the owner is active-duty military. When they are not,
        // the field is hidden and its value must not block submission.
        yup: Yup.boolean().when('isOwnerMilitary', {
            is: true,
            then: Yup.boolean().required('Required'),
            otherwise: Yup.boolean().nullable(),
        }),
        title: 'Owner is spouse to military member',
        defaultValue: true,
    },
    recreationalPassportFee: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Do you want to include the Recreational Passport with registration?',
        label: 'Recreational Passport',
        yup: Yup.boolean().required('Required'),
        title: 'Recreational Passport',
        // Opt-in add-on: default excluded so the fee estimate matches the
        // registration submission, which includes the pass only when the buyer
        // selects it on the registration-details form.
        defaultValue: false,
    },
    keepColoradoWildPass: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Do you want to include the Keep Colorado Wild Pass with registration?',
        label: 'Keep Colorado Wild Pass',
        yup: Yup.boolean().required('Required'),
        title: 'Keep Colorado Wild Pass',
        defaultValue: true,
    },
    temporarilyLivingOutOfState: {
        type: INPUT_TYPES.CHECK_SELECT,
        checkLabel: 'Are you temporarily living out of state?',
        label: 'Temporarily out of state',
        yup: Yup.boolean().required('Required'),
        title: 'Temporarily out of state',
        defaultValue: true,
    },
    inOreGo: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Do you want to Enroll in OreGO with registration?',
        label: 'OreGO enrollment',
        yup: Yup.boolean().required('Required'),
        title: 'OreGO enrollment',
        defaultValue: true,
    },
    registrationRenewalReminder: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Do you want to receive registration renewal reminders by email?',
        label: 'Registration renewal reminder',
        yup: Yup.boolean().required('Required'),
        title: 'Registration renewal reminder',
        defaultValue: true,
    },
    applyingForWildlifeParksPermit: {
        type: INPUT_TYPES.CHECK,
        checkLabel: 'Do you want to apply for a wildlife park permit?',
        label: 'Wildlife park permit',
        yup: Yup.boolean().required('Required'),
        title: 'Wildlife park permit',
        defaultValue: true,
    },
    stateStationed: {
        type: INPUT_TYPES.TEXT_INPUT,
        inputType: 'text',
        label: 'State Stationed for Military',
        // Only relevant when the owner is active-duty military. When they are not,
        // the field is hidden and a null/empty value must not block submission.
        yup: Yup.string().when('isOwnerMilitary', {
            is: true,
            then: Yup.string()
                .oneOf(abbrevStateNamesArr, 'Please enter a valid US state abbreviation. E.g. enter CA for California.')
                .required('Required'),
            otherwise: Yup.string().nullable(),
        }),
        title: 'State Stationed for Military',
        defaultValue: '',
    },
    // vehicleStorageAddress: {
    // 	type: INPUT_TYPES.ADDRESS,
    // 	inputType: 'text',
    // 	label: 'Vehicle storage address',
    // 	yup: Yup.string(),
    // 	title: 'Vehicle storage address',
    // },
    eyeColor: {
        type: INPUT_TYPES.TEXT_INPUT,
        inputType: 'text',
        label: 'Eye Color',
        yup: Yup.string().nullable().required('Required'),
        title: 'Eye Color as in Drivers License',
        defaultValue: 'Brown',
    },
};
const usStatesForSelect = [
    { value: 'AL', text: 'Alabama' },
    { value: 'AK', text: 'Alaska' },
    { value: 'AZ', text: 'Arizona' },
    { value: 'AR', text: 'Arkansas' },
    { value: 'CA', text: 'California' },
    { value: 'CO', text: 'Colorado' },
    { value: 'CT', text: 'Connecticut' },
    { value: 'DC', text: 'Washington, D.C.' },
    { value: 'DE', text: 'Delaware' },
    { value: 'FL', text: 'Florida' },
    { value: 'GA', text: 'Georgia' },
    { value: 'HI', text: 'Hawaii' },
    { value: 'ID', text: 'Idaho' },
    { value: 'IL', text: 'Illinois' },
    { value: 'IN', text: 'Indiana' },
    { value: 'IA', text: 'Iowa' },
    { value: 'KS', text: 'Kansas' },
    { value: 'KY', text: 'Kentucky' },
    { value: 'LA', text: 'Louisiana' },
    { value: 'ME', text: 'Maine' },
    { value: 'MD', text: 'Maryland' },
    { value: 'MA', text: 'Massachusetts' },
    { value: 'MI', text: 'Michigan' },
    { value: 'MN', text: 'Minnesota' },
    { value: 'MS', text: 'Mississippi' },
    { value: 'MO', text: 'Missouri' },
    { value: 'MT', text: 'Montana' },
    { value: 'NE', text: 'Nebraska' },
    { value: 'NV', text: 'Nevada' },
    { value: 'NH', text: 'New Hampshire' },
    { value: 'NJ', text: 'New Jersey' },
    { value: 'NM', text: 'New Mexico' },
    { value: 'NY', text: 'New York' },
    { value: 'NC', text: 'North Carolina' },
    { value: 'ND', text: 'North Dakota' },
    { value: 'OH', text: 'Ohio' },
    { value: 'OK', text: 'Oklahoma' },
    { value: 'OR', text: 'Oregon' },
    { value: 'PA', text: 'Pennsylvania' },
    { value: 'RI', text: 'Rhode Island' },
    { value: 'SC', text: 'South Carolina' },
    { value: 'SD', text: 'South Dakota' },
    { value: 'TN', text: 'Tennessee' },
    { value: 'TX', text: 'Texas' },
    { value: 'UT', text: 'Utah' },
    { value: 'VT', text: 'Vermont' },
    { value: 'VA', text: 'Virginia' },
    { value: 'WA', text: 'Washington' },
    { value: 'WV', text: 'West Virginia' },
    { value: 'WI', text: 'Wisconsin' },
    { value: 'WY', text: 'Wyoming' },
];
const usStatesArray = [
    'Alabama',
    'Alaska',
    'American Samoa',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District of Columbia',
    'Federated States of Micronesia',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Marshall Islands',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Northern Mariana Islands',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Palau',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virgin Island',
    'Virginia',
    'Washington',
    'Washington, D.C.',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
];
const CREDIT_APP_FIELD_IDS = {
    DOWN_PAYMENT_AMT: 'downpaymentAmt',
    LOAN_TERM: 'loanTerm',
    PHONE_NUMBER: 'phoneNumber',
    DOB: 'dob',
    SSN: 'ssn',
    MARITAL_STATUS: 'maritalStatus',
    US_CITIZEN: 'isUsCitizen',
    HOME_ADDRESS_SAME_AS_ID_ADDRESS: 'homeAddressSameAsIdAddress',
    HOUSING_OWNERSHIP: 'housingOwnership',
    HOME_MOVE_IN_DATE: 'homeMoveInDate',
    MONTHLY_AMT: 'monthlyAmt',
    EMPLOYMENT_STATUS: 'employmentStatus',
    MONTHLY_GROSS_INCOME: 'monthlyGrossIncome',
    EMPLOYER_NAME: 'employerName',
    EMPLOYER_PHONE_NUMBER: 'employerPhoneNumber',
    OCCUPATION: 'occupation',
    JOB_START_DATE: 'jobStartDate',
    NOTE_TO_LENDER: 'noteToLender',
};
const FINANCING_BANK_NAME_ENUM = {
    FRF: 'FRF',
    IRONHORSE: 'IRONHORSE',
    OCTANE: 'OCTANE',
    DEALER_DIRECT: 'DEALER-DIRECT',
};
const COLORS = {
    PRIMARY: {
        name: 'primary',
        code: getEnvVar('PRIMARY_COLOR'),
    },
    SECONDARY: {
        name: 'secondary',
        code: getEnvVar('SECONDARY_COLOR'),
    },
    SUCCESS: {
        name: 'success',
        code: getEnvVar('SUCCESS_COLOR'),
    },
    INFO: {
        name: 'info',
        code: getEnvVar('INFO_COLOR'),
    },
    WARNING: {
        name: 'warning',
        code: getEnvVar('WARNING_COLOR'),
    },
    DANGER: {
        name: 'danger',
        code: getEnvVar('DANGER_COLOR'),
    },
    DARK: {
        name: 'dark',
        code: getEnvVar('DARK_COLOR'),
    },
    LIGHT: {
        name: 'light',
        code: getEnvVar('LIGHT_COLOR'),
    },
    // Color Hex codes
    BACKGROUND_GRAY: {
        name: 'backgroundGray',
        code: '#f8f9fa',
    },
    BORDER_GRAY: {
        name: 'borderGray',
        code: 'var(--bs-card-border-color)',
    },
};
// Used for FRF credit app. Don't change!
const STATE_ABBREV_TO_STATE_NAME = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
};
const TITLING_AGENT_ENUM = {
    LENDER: 'LENDER',
    EKHO: 'EKHO',
    NONE: 'NONE',
};
const EKHO_LOAN_TERM_OPTIONS = [24, 36, 48, 60, 72, 84];
const VI_PROCESSING_FEE = 165;
const CG_PROCESSING_FEE = 30;
const PAPERWORK_FEE = 20; // shipping of documents etc.
// Used in checkout to produce registration options, and in backend
const TAR_PROCESS_ENUM = {
    ASSISTED: 'ASSISTED',
    AUTOMATED: 'AUTOMATED',
    ASSISTED_TITLING: 'ASSISTED_TITLING',
    AUTOMATED_TITLING: 'AUTOMATED_TITLING',
    NONE: 'NONE',
};
const TAR_AGENT_ENUM = {
    BUYER: 'BUYER',
    EKHO: 'EKHO', // deprecated
    VI: 'VI',
    CG: 'CG',
    NONE: 'NONE',
};
const STATE_DATA_TAR_PROCESS_KEYS = {
    automatedTARSupported: 'automatedTARSupported',
    assistedTARNotSupported: 'assistedTARNotSupported',
    automatedTitlingSupported: 'automatedTitlingSupported',
    assistedTitlingNotSupported: 'assistedTitlingNotSupported',
    noneSupported: 'noneSupported',
};
const TAR_PROCESS_TO_STATE_PROCESS_MAP_KEY = {
    [TAR_PROCESS_ENUM.ASSISTED]: STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported,
    [TAR_PROCESS_ENUM.AUTOMATED]: STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported,
    [TAR_PROCESS_ENUM.ASSISTED_TITLING]: STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported,
    [TAR_PROCESS_ENUM.AUTOMATED_TITLING]: STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported,
    [TAR_PROCESS_ENUM.NONE]: STATE_DATA_TAR_PROCESS_KEYS.noneSupported,
};
const INSURANCE_SELECTION_TYPES = {
    skipInsurance: 'skipInsurance',
    purchaseInsurance: 'purchaseInsurance',
    useExistingInsurance: 'useExistingInsurance',
    provideBasicDetails: 'provideBasicDetails',
};
const CG_VEHICLE_TYPE_ENUM = {
    // Keys should match our internal vehicle type enum values
    [VehicleType.ATV]: 'ATV',
    [VehicleType.ORV]: 'OHV', // Intentionally send vehicle type OHV for ORVs to CG. They calculate fees based on vehicle type and use OHV for all off road vehicles. Currently have to manually edit the account data to get correct fees when we send ORV.
    [VehicleType.LOW_SPEED]: 'LOW_SPEED',
    [VehicleType.OHV]: 'OHV',
    [VehicleType.MOTORCYCLE]: 'MOTORCYCLE',
};
const INTERNAL_FUEL_TYPE_ENUM = {
    GASOLINE: 'Gasoline',
    DIESEL: 'Diesel',
    HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
    ELECTRIC: 'Electric',
    NATURAL_GAS_POWERED: 'NaturalGasPowered',
    FLEX_FUEL: 'FlexFuel',
    HYBRID_DIESEL_ELECTRIC: 'HybridDieselElectric',
    HYBRID_GASOLINE_ELECTRIC: 'HybridGasolineElectric',
};
// Simplified minimum financed amount thresholds for requiring insurance per lender
// Insurance is only required for street-legal vehicles (not off-road vehicles)
// If financed amount >= minimum, insurance is required for street-legal vehicles
const BANK_INSURANCE_MIN_AMOUNTS = {
    [FINANCING_BANK_NAME_ENUM.FRF]: 5000,
    [FINANCING_BANK_NAME_ENUM.IRONHORSE]: 0,
};
// used in buyer portal and other places to determine if insurance is required
const insuranceReqTypes = {
    validationRequired: 'validationRequired',
    basicInformationRequired: 'basicInformationRequired',
    insuranceNotRequired: 'insuranceNotRequired',
};
const OEMS_THAT_CAN_OVERRIDE_VEHICLE_IMG_URL = ['stark'];
const ORDER_CREATION_TYPES = {
    ANTE_PREORDER: 'ANTE_PREORDER',
    ORGANIC: 'ORGANIC',
    PREORDER: 'PREORDER',
    EXISTINGORDER: 'EXISTINGORDER',
    OEMORIGINATED: 'OEMORIGINATED',
    ABANDONEDCART: 'ABANDONEDCART',
    ABANDONED_ANTE_PREORDER: 'ABANDONED_ANTE_PREORDER',
    DEALER_LEAD: 'DEALER_LEAD',
};
const LEAD_TYPE_ENUM = {
    IN_PERSON_PURCHASE: 'IN_PERSON_PURCHASE',
};
const HOW_IT_WORKS_SECTIONS_ENUM = {
    PREORDER: 'PREORDER',
    PREORDER_CONVERSION: 'PREORDER_CONVERSION',
    ORDER: 'ORDER',
    FINANCING: 'FINANCING',
    INSURANCE: 'INSURANCE',
    TAR_PROCESS_AUTOMATED: 'TAR_PROCESS_AUTOMATED',
    TAR_PROCESS_ASSISTED: 'TAR_PROCESS_ASSISTED',
    TAR_PROCESS_AUTOMATED_TITLING: 'TAR_PROCESS_AUTOMATED_TITLING',
    TAR_PROCESS_ASSISTED_TITLING: 'TAR_PROCESS_ASSISTED_TITLING',
    PAPERWORK: 'PAPERWORK',
    HOME_DELIVERY: 'HOME_DELIVERY',
    PICK_UP: 'PICK_UP',
};
const HOW_IT_WORKS_SECTIONS = {
    [HOW_IT_WORKS_SECTIONS_ENUM.PREORDER]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.PREORDER,
        order: 0,
        activeStep: true,
        // or false depending on the context or data
        completed: false,
        // Assuming this step has not been completed yet
        optional: false,
        iconName: 'LockClock',
        title: 'Secure your build slot',
        description: `Place a deposit to secure your vehicle build slot. You'll receive an email once you've placed your preorder.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.PREORDER_CONVERSION]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.PREORDER_CONVERSION,
        order: 1,
        activeStep: false,
        // or false depending on the context or data
        completed: false,
        // Assuming this step has not been completed yet
        optional: false,
        iconName: 'ShoppingCart',
        title: 'Finalize your order',
        description: `Select your remaining payment, delivery, and registration choices to finalize your order. You'll be invited to complete this step once your preorder has been prioritized.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.ORDER]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.ORDER,
        order: 1,
        activeStep: true, // or false depending on the context or data
        completed: false, // Assuming this step has not been completed yet
        optional: false,
        iconName: 'ShoppingCart',
        title: 'Provide basic order and contact info',
        description: `Make your payment, delivery, and registration choices here on this Ekho Checkout page. You'll receive an email once you've placed your order.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.FINANCING]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.FINANCING,
        order: 2,
        activeStep: false,
        completed: false,
        optional: true,
        iconName: 'AccountBalance',
        title: 'Apply for financing',
        description: `If you're financing your purchase, you'll also complete a short financing application in the Ekho Checkout page! We'll let you know if you're approved within minutes.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.INSURANCE]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.INSURANCE,
        order: 3,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'Security',
        title: 'Protect your vehicle',
        description: `If necessary, purchase new or validate existing insurance from within Ekho's platform.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED,
        order: 4,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'VerifiedUser',
        title: 'Automated registration',
        description: `The registration process will be handled for you (meaning no trip to the DMV).`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED,
        order: 5,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'VerifiedUser',
        title: 'Assisted registration',
        description: `Let Ekho help you complete the state registration process.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED_TITLING]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED_TITLING,
        order: 5,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'VerifiedUser',
        title: 'Automated titling',
        description: `The titling process will be handled for you (meaning no trip to the DMV).`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED_TITLING]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED_TITLING,
        order: 6,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'VerifiedUser',
        title: 'Assisted titling',
        description: `Let Ekho help you complete the state titling process.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.PAPERWORK]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.PAPERWORK,
        order: 7,
        activeStep: false,
        completed: false,
        iconName: 'Task',
        optional: false,
        title: 'Complete your paperwork',
        description: `Sign your sales contracts and any other necessary state documents. We'll provide instructions that'll make this part easy.`,
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.HOME_DELIVERY]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.HOME_DELIVERY,
        order: 8,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'BikeScooter',
        title: 'Take delivery or pickup your vehicle',
        description: 'Take delivery or pickup your vehicle from your chosen pickup location.',
    },
    [HOW_IT_WORKS_SECTIONS_ENUM.PICK_UP]: {
        id: HOW_IT_WORKS_SECTIONS_ENUM.PICK_UP,
        order: 9,
        activeStep: false,
        completed: false,
        optional: false,
        iconName: 'BikeScooter',
        title: 'Take delivery or pickup your vehicle',
        description: 'Take delivery or pickup your vehicle from your chosen pickup location.',
    },
};
const EKHO_APPS_ENUM = {
    BUYER_PORTAL: 'buyerPortal',
    AFFILIATE_PORTAL: 'affiliatePortal',
    ADMIN_PORTAL: 'adminPortal',
    CHECKOUT: 'checkout',
    INFO_MODAL: 'modal',
    SHOP: 'shop',
    GRADER: 'grader',
};
// Defines when we do web vs mobile rendering in BP and Checkout
const STACKING_BREAKPOINT = 1150; // in px
const CHECKOUT_INFO_MAX_WIDTH = 650; // in px
const WEB_INNER_SIDE_PADDING = 5; // in rem
const WEB_OUTER_SIDE_PADDING = 2; // in rem
const WEB_VERTICAL_PADDING = 3; // in rem
const MOBILE_SIDE_PADDING = 2; // in rem
const SUPPORT_MODAL_STATE = {
    SUPPORT_HUB: 'SUPPORT_HUB',
    MESSAGE_NON_EKHO_SUPPORT: 'MESSAGE_NON_EKHO_SUPPORT',
    MESSAGE_SENT: 'MESSAGE_SENT',
};
const PICK_UP_LOCATION_TYPE_ENUM = {
    DEALER: 'DEALER',
    EKHO: 'EKHO',
    OEM: 'OEM',
};
const FeeEstimateFidelity = {
    FINAL: 'final',
    INITIAL: 'initial',
    API_ESTIMATE: 'apiEstimate',
    ACTUAL: 'actual',
};
const GOOGLE_MAP_STYLES = [
    // {
    // 	featureType: 'all',
    // 	elementType: 'labels',
    // 	stylers: [{ visibility: 'off' }],
    // },
    {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
    },
    // {
    // 	featureType: 'road',
    // 	elementType: 'geometry',
    // 	stylers: [{ visibility: 'simplified' }],
    // },
    // {
    // 	featureType: 'road.arterial',
    // 	elementType: 'labels',
    // 	stylers: [{ visibility: 'off' }],
    // },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
    },
    // {
    // 	featureType: 'water',
    // 	elementType: 'labels',
    // 	stylers: [{ visibility: 'off' }],
    // },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
    },
];
const FORMIK_DATE_FIELDS = [
    'dob',
    'dlExpDate',
    'homeMoveInDate',
    'jobStartDate',
    'effectiveDate',
    'expiryDate',
];
// FINANCING APPLICATION CONSTANTS
const EKHO_FINANCING_APPLICATION_CONSTANTS = {
    MARITAL_STATUS_OPTIONS: {
        SINGLE: 'Single',
        MARRIED: 'Married',
        WIDOWED: 'Widowed',
        DIVORCED: 'Divorced',
        SEPARATED: 'Separated',
    },
    HOUSING_OWNERSHIP_OPTIONS: {
        OWNED: 'Owned',
        RENTED: 'Rented',
        FAMILY: 'Family',
        LIVES_WITH_RELATIVES: 'LivesWithRelatives',
    },
    EMPLOYMENT_STATUS_OPTIONS: {
        EMPLOYED: 'Employed',
        SELF_EMPLOYED: 'SelfEmployed',
        RETIRED: 'Retired',
    },
    INCOME_TYPE_OPTIONS: {
        SPOUSAL_INCOME: 'SpousalIncome',
        CHILD_SUPPORT: 'childSupport',
        DISABILITY: 'disability',
        INVESTMENT: 'investment',
        PENSION: 'pension',
        RENTAL: 'rental',
        RETIREMENT_INCOME: 'retirementIncome',
        SOCIAL_SECURITY: 'socialSecurity',
        ALIMONY: 'alimony',
        UNEMPLOYMENT: 'unemployment',
        OTHER: 'other',
    },
    INCOME_TYPE_DESCRIPTIONS: {
        SPOUSAL_INCOME: 'The income that your partner earns.',
        CHILD_SUPPORT: 'The income that you receive from child support payments.',
        DISABILITY: 'The income that you receive from disability payments.',
        INVESTMENT: 'The income that you receive from investments (e.g. dividends, interest, etc.).',
        PENSION: 'The income that you receive from a pension.',
        RENTAL: 'The income that you receive from rental properties.',
        RETIREMENT_INCOME: 'The income that you receive from retirement accounts.',
        SOCIAL_SECURITY: 'The income that you receive from social security payments.',
        ALIMONY: 'The income that you receive from alimony payments.',
        UNEMPLOYMENT: 'The income that you receive from unemployment benefits.',
        OTHER: 'Any other income that you receive that is not listed above.',
    },
    REFERENCE_RELATIONSHIP_OPTIONS: {
        EMPLOYER: 'Employer',
        FRIEND: 'Friend',
        OTHER: 'Other',
        PARENT: 'Parent',
        RELATIVE: 'Relative',
        SPOUSE: 'Spouse',
    },
};
const EKHO_FINANCING_STIPULATIONS_KEYS = {
    CALL_FRF_TO_VERIFY_IDENTITY_STIP: 'CALL_FRF_TO_VERIFY_IDENTITY_STIP',
    PAYOFF_OUTSTANDING_LOAN_STIP: 'PAYOFF_OUTSTANDING_LOAN_STIP',
    NOTARIZED_CONTRACT_STIP: 'NOTARIZED_CONTRACT_STIP',
    PERSONAL_REFERENCES_STIP: 'PERSONAL_REFERENCES_STIP',
    PROOF_OF_INCOME_STIP: 'PROOF_OF_INCOME_STIP',
    ADDITIONAL_INCOME_STIP: 'ADDITIONAL_INCOME_STIP',
    PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP: 'PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP',
    FIVE_PERSONAL_REFERENCES_STIP: 'FIVE_PERSONAL_REFERENCES_STIP',
    MAX_FINANCED_STIP: 'MAX_FINANCED_STIP',
    PROOF_OF_RESIDENCE_STIP: 'PROOF_OF_RESIDENCE_STIP',
    PROOF_OF_SSN_STIP: 'PROOF_OF_SSN_STIP',
    PROOF_OF_EMPLOYMENT_STIP: 'PROOF_OF_EMPLOYMENT_STIP',
    DOWN_PAYMENT_STIP: 'DOWN_PAYMENT_STIP',
    VALID_DRIVERS_LICENSE_STIP: 'VALID_DRIVERS_LICENSE_STIP',
    FIRST_TIME_BUYER_STIP: 'FIRST_TIME_BUYER_STIP',
    FULL_INSURANCE_COVERAGE_REQUIRED_STIP: 'FULL_INSURANCE_COVERAGE_REQUIRED_STIP',
    ITEMIZED_ACCESSORY_LIST_STIP: 'ITEMIZED_ACCESSORY_LIST_STIP',
    TWO_YEARS_OF_TAX_RETURNS_STIP: 'TWO_YEARS_OF_TAX_RETURNS_STIP',
    THREE_MONTHS_OF_BANK_STATEMENTS_STIP: 'THREE_MONTHS_OF_BANK_STATEMENTS_STIP',
};
/** Short human-readable labels for each stipulation key, for compact summary display. */
const EKHO_FINANCING_STIPULATION_LABELS = {
    CALL_FRF_TO_VERIFY_IDENTITY_STIP: 'Verify identity via phone call',
    PAYOFF_OUTSTANDING_LOAN_STIP: 'Pay off outstanding loan',
    NOTARIZED_CONTRACT_STIP: 'Notarized contract',
    PERSONAL_REFERENCES_STIP: 'Personal references',
    PROOF_OF_INCOME_STIP: 'Proof of income',
    ADDITIONAL_INCOME_STIP: 'Additional income',
    PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP: 'Current work phone number',
    FIVE_PERSONAL_REFERENCES_STIP: 'Five personal references',
    MAX_FINANCED_STIP: 'Max financed',
    PROOF_OF_RESIDENCE_STIP: 'Proof of residence',
    PROOF_OF_SSN_STIP: 'Proof of Social Security number',
    PROOF_OF_EMPLOYMENT_STIP: 'Proof of employment',
    DOWN_PAYMENT_STIP: 'Down payment',
    VALID_DRIVERS_LICENSE_STIP: 'Valid drivers license',
    FIRST_TIME_BUYER_STIP: 'First time buyer',
    FULL_INSURANCE_COVERAGE_REQUIRED_STIP: 'Full insurance coverage required',
    ITEMIZED_ACCESSORY_LIST_STIP: 'Itemized accessory list',
    TWO_YEARS_OF_TAX_RETURNS_STIP: 'Two years of tax returns',
    THREE_MONTHS_OF_BANK_STATEMENTS_STIP: 'Three months of bank statements',
};
const CREDIT_APP_DISCLAIMER = `By clicking the button below, I agree to have my credit application submitted to Ekho Inc. and its subsidiaries (collectively "Ekho").  I authorize Ekho, its affiliates, and any bank or lender, or other institution (collectively "Creditor") to whom my application is submitted to investigate my credit and employment history, verify my employment and income, obtain credit reports, and to the extent permitted by law, release information about my credit experience now or in the future. My application may be submitted to more than one Creditor, one after another, over a period of hours or days, for this same purchase. I acknowledge and agree that each Creditor may monitor and record telephone calls regarding my account for quality assurance or other similar purposes. Each Creditor may contact me by written, electronic or verbal means, to the extent permitted by law. I expressly agree to being contacted by prerecorded or artificial voice messages, text messages, emails and/or automatic telephone dialing systems at any e-mail address or any telephone number I provide, now or in the future, including a number for a mobile device, regardless of whether I incur charges as a result. NOTE that, if your vehicle isn't shipped within 30 days of your application date, we must re-submit it for lender re-approval, which may change terms and trigger a second hard credit inquiry.`;
/* FINANCING DEFAULT CONSTS */
const INITIAL_TERM = 84;
const INITIAL_DOWN_PAYMENT_SUBTRACTION = 1500;
const DEFAULT_MIN_LOAN_AMOUNT = 2500;
const EKHO_FINANCING_APPLICATION_SECTIONS = {
    PREFERRED_TERMS: 'Preferred terms',
    PERSONAL_DETAILS: 'Personal details',
    EMPLOYMENT_INFO: 'Employment information',
    OTHER_SOURCES_OF_INCOME: 'Other sources of income',
    ADDITIONAL_INFO: 'Additional information',
};
// Maps each financing-application section to the DOM anchor id rendered on its
// heading and the scroll priority used to pick the topmost failing section.
// Lower priority wins. Keyed by section label so validation (which reports
// labels) and the heading render share one source of truth.
const EKHO_FINANCING_APPLICATION_SECTION_ANCHORS = {
    [EKHO_FINANCING_APPLICATION_SECTIONS.PREFERRED_TERMS]: {
        id: 'financingPreferredTermsSection',
        priority: 10,
    },
    [EKHO_FINANCING_APPLICATION_SECTIONS.PERSONAL_DETAILS]: {
        id: 'financingPersonalDetailsSection',
        priority: 11,
    },
    [EKHO_FINANCING_APPLICATION_SECTIONS.EMPLOYMENT_INFO]: {
        id: 'financingEmploymentInfoSection',
        priority: 12,
    },
    [EKHO_FINANCING_APPLICATION_SECTIONS.OTHER_SOURCES_OF_INCOME]: {
        id: 'financingOtherIncomeSection',
        priority: 13,
    },
    [EKHO_FINANCING_APPLICATION_SECTIONS.ADDITIONAL_INFO]: {
        id: 'financingAdditionalInfoSection',
        priority: 14,
    },
};
const EKHO_FINANCING_APPLICATION_CATEGORIZATIONS = {
    [EKHO_FINANCING_APPLICATION_SECTIONS.PREFERRED_TERMS]: [
        CREDIT_APP_FIELD_IDS.LOAN_TERM,
        CREDIT_APP_FIELD_IDS.DOWN_PAYMENT_AMT,
    ],
    [EKHO_FINANCING_APPLICATION_SECTIONS.PERSONAL_DETAILS]: [
        CREDIT_APP_FIELD_IDS.DOB,
        CREDIT_APP_FIELD_IDS.PHONE_NUMBER,
        CREDIT_APP_FIELD_IDS.SSN,
        CREDIT_APP_FIELD_IDS.MARITAL_STATUS,
        CREDIT_APP_FIELD_IDS.US_CITIZEN,
        CREDIT_APP_FIELD_IDS.HOME_ADDRESS_SAME_AS_ID_ADDRESS,
        CREDIT_APP_FIELD_IDS.HOUSING_OWNERSHIP,
        CREDIT_APP_FIELD_IDS.HOME_MOVE_IN_DATE,
        CREDIT_APP_FIELD_IDS.MONTHLY_AMT,
        // Validators nest address errors under the top-level `address` key.
        'address',
        'addressString',
        'addressLineOne',
        'addressLineTwo',
        'city',
        'county',
        'state',
        'zip',
    ],
    [EKHO_FINANCING_APPLICATION_SECTIONS.EMPLOYMENT_INFO]: [
        CREDIT_APP_FIELD_IDS.EMPLOYMENT_STATUS,
        CREDIT_APP_FIELD_IDS.MONTHLY_GROSS_INCOME,
        CREDIT_APP_FIELD_IDS.EMPLOYER_NAME,
        CREDIT_APP_FIELD_IDS.EMPLOYER_PHONE_NUMBER,
        CREDIT_APP_FIELD_IDS.OCCUPATION,
        CREDIT_APP_FIELD_IDS.JOB_START_DATE,
        // Validators nest address errors under the top-level `address` key.
        'address',
        'addressString',
        'addressLineOne',
        'addressLineTwo',
        'city',
        'county',
        'state',
        'zip',
    ],
    [EKHO_FINANCING_APPLICATION_SECTIONS.OTHER_SOURCES_OF_INCOME]: ['otherIncomes'],
    [EKHO_FINANCING_APPLICATION_SECTIONS.ADDITIONAL_INFO]: [CREDIT_APP_FIELD_IDS.NOTE_TO_LENDER],
};
// Hotjar map
const OEM_KEY_TO_HOTJAR_SITE_ID = {
    BUYER_PORTAL: {
        janus: 3720403,
        moke: 3720410,
        e2etestoem: 3715982,
    },
    CHECKOUT: {
        stark: 5101827,
    },
};
// Stripe payment status enum
const PAYMENT_STATUS_ENUM = {
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
    REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
    REQUIRES_ACTION: 'requires_action',
    CANCELED: 'canceled',
    REQUIRES_CONFIRMATION: 'requires_confirmation',
    REQUIRES_CAPTURE: 'requires_capture',
};
const CANCELATION_AGENT_ENUM = {
    BUYER_CANCELED: 'BUYER_CANCELED',
    EKHO_CANCELED: 'EKHO_CANCELED',
    FINANCING_REJECTION_AUTO_CANCELED: 'FINANCING_REJECTION_AUTO_CANCELED',
    SOFT_LOCK_EXPIRATION_AUTO_CANCELED: 'SOFT_LOCK_EXPIRATION_AUTO_CANCELED',
};
const LENDER_DECISION_OPTIONS = {
    accepted: 'accepted',
    rejected: 'rejected',
    needMoreInfo: 'needMoreInfo',
    counterOffer: 'counterOffer',
};
// The different types of decisions a buyer can make on a finance offer from the lender. This will grow with time.
const FinanceOfferBuyerDecision = {
    ACCEPTED: 'accepted',
    DECLINED: 'declined',
};
const RELOCATION_FLOWS = {
    SELECT_DELIVERY_PREF: 'SELECT_DELIVERY_PREF',
    SEE_FINANCING_DECISIONS: 'SEE_FINANCING_DECISIONS',
    RETRY_INSURANCE_VALIDATION: 'RETRY_INSURANCE_VALIDATION',
    FAILED_ACH_PAYMENT: 'FAILED_ACH_PAYMENT',
    SIGN_RIC: 'SIGN_RIC',
    FINANCING_STIPULATIONS: 'FINANCING_STIPULATIONS',
    SIGN_FINANCING_DOCS: 'SIGN_FINANCING_DOCS',
    SIGN_COVERAGE_DOCS: 'SIGN_COVERAGE_DOCS',
    ROBOTIC_SIGNING_START_SIGNING: 'ROBOTIC_SIGNING_START_SIGNING',
    ROBOTIC_SIGNING_APPROVED: 'ROBOTIC_SIGNING_APPROVED',
    ROBOTIC_SIGNING_MISSED_SESSION: 'ROBOTIC_SIGNING_MISSED_SESSION',
    ROBOTIC_SIGNING_CANCEL_SIGNING: 'ROBOTIC_SIGNING_CANCEL_SIGNING',
    ROBOTIC_SIGNING_RESCHEDULE_SIGNING: 'ROBOTIC_SIGNING_RESCHEDULE_SIGNING',
    ROBOTIC_SIGNING_REDO_SIGNING: 'ROBOTIC_SIGNING_REDO_SIGNING',
    MODEL_YEAR_CHANGE: 'MODEL_YEAR_CHANGE',
    PRE_CREDIT_APP_DATA: 'PRE_CREDIT_APP_DATA',
    // Add other relocation flows here...
    // Note: must also add to buyer portal
};
const FULFILLMENT_STATUS_ENUM = {
    UNFULFILLED: 'UNFULFILLED',
    ON_HOLD: 'ON_HOLD',
    CANCELED: 'CANCELED',
    READY_TO_FULFILL: 'READY_TO_FULFILL',
    READY_TO_DISPATCH: 'READY_TO_DISPATCH',
    FULFILLED: 'FULFILLED',
    IN_TRANSIT_TO_BUYER: 'IN_TRANSIT_TO_BUYER',
    IN_TRANSIT_TO_FULFILLMENT_CENTER: 'IN_TRANSIT_TO_FULFILLMENT_CENTER',
    PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
    DELIVERY_FULFILLMENT_IN_PROGRESS: 'DELIVERY_FULFILLMENT_IN_PROGRESS',
    RECEIVED_AT_FULFILLMENT_CENTER: 'RECEIVED_AT_FULFILLMENT_CENTER',
};
const RELOC_MODAL_NAMES = {
    FAILED_ACH_MODAL: 'failedACHPaymentModal',
    SIGN_RIC_MODAL: 'signRICModal',
    SIGN_FINANCING_DOCS_MODAL: 'signFinancingDocsModal',
    SIGN_COVERAGE_MODAL: 'signCoverageModal',
    SURVEY_MODAL: 'surveyModal',
    FINANCING_STIPULATIONS_MODAL: 'financingStipulationsModal',
    FAILED_KLARNA_PAYMENT_MODAL: 'failedKlarnaPaymentModal',
    FAILED_CRYPTO_PAYMENT_MODAL: 'failedCryptoPaymentModal',
    RETRY_INSURANCE_VALIDATION_MODAL: 'retryInsuranceValidationModal',
    SEE_FINANCING_DECISIONS_MODAL: 'seeFinancingDecisionsModal',
    FINALIZE_FINANCING_SELECTION_MODAL: 'finalizeFinancingSelectionModal',
    ROBOTIC_SIGNING_START_SIGNING: 'roboticSigningStartSigningModal',
    ROBOTIC_SIGNING_APPROVED: 'roboticSigningApprovedModal',
    ROBOTIC_SIGNING_MISSED_SESSION: 'roboticSigningMissedSessionModal',
    ROBOTIC_SIGNING_CANCEL_SIGNING: 'roboticSigningCancelSigningModal',
    ROBOTIC_SIGNING_RESCHEDULE_SIGNING: 'roboticSigningRescheduleSigningModal',
    ROBOTIC_SIGNING_REDO_SIGNING: 'roboticSigningRedoSigningModal',
    MODEL_YEAR_UPDATE_MODAL: 'modelYearUpdateModal',
    DEALER_HANDOFF_MODAL: 'dealerHandoffModal',
    PRE_CREDIT_APP_DATA_MODAL: 'preCreditAppDataModal',
};
const AllModalPageNames = {
    loadingPage: 'loadingPage',
    getStartedPage: 'getStartedPage',
    // beginVerificationPage: 'beginVerificationPage',
    // verificationInProgressPage: 'verificationInProgressPage',
    // verificationSucceededPage: 'verificationSucceededPage',
    // verificationRetryPage: 'verificationRetryPage',
    signOffPage: 'signOffPage',
    somethingWrongPage: 'somethingWrongPage',
    deliverySelectionPage: 'deliverySelectionPage',
    registrationAddressSelectionPage: 'registrationAddressSelectionPage',
    verificationMaxAttemptsPage: 'verificationMaxAttemptsPage',
    selectDeliveryPrefPage: 'selectDeliveryPrefPage',
    simpleAlertModal: 'simpleAlertModal',
    ekhoMustTARAlertModal: 'ekhoMustTARAlertModal',
    orderCancellationModal: 'orderCancellationModal',
    seeFinancingDecisionsModal: 'seeFinancingDecisionsModal',
    retryInsuranceValidationModal: 'retryInsuranceValidationModal',
    failedACHPaymentModal: 'failedACHPaymentModal',
    signRICModal: 'signRICModal',
    signCoverageModal: 'signCoverageModal',
    surveyModal: 'surveyModal',
    financingStipulationsModal: 'financingStipulationsModal',
    roboticSigningStartSigningModal: 'roboticSigningStartSigningModal',
    roboticSigningApprovedModal: 'roboticSigningApprovedModal',
    roboticSigningMissedSessionModal: 'roboticSigningMissedSessionModal',
    roboticSigningCancelSigningModal: 'roboticSigningCancelSigningModal',
    roboticSigningRescheduleSigningModal: 'roboticSigningRescheduleSigningModal',
    roboticSigningRedoSigningModal: 'roboticSigningRedoSigningModal',
    failedKlarnaPaymentModal: 'failedKlarnaPaymentModal',
    failedCryptoPaymentModal: 'failedCryptoPaymentModal',
    authSessionExpiredModal: 'authSessionExpiredModal',
    confirmDeclineFinancingModal: 'confirmDeclineFinancingModal',
    signFinancingDocsModal: 'signFinancingDocsModal',
    modelYearUpdateModal: 'modelYearUpdateModal',
    dealerHandoffModal: 'dealerHandoffModal',
    preCreditAppDataModal: 'preCreditAppDataModal',
};
const EKHO_SERVICES_PROVIDER_ID = 'svp_ekho';
/**
 * Metadata key on `SUBMIT_STIPULATION_EVIDENCE` recording whether the buyer
 * actually submitted evidence for the current stipulation round.
 *
 * Shared between the generator that writes it and the notification guard that
 * reads it: a mismatch would silently suppress every completion notification,
 * including the legitimate ones.
 */
const BUYER_PROVIDED_EVIDENCE_METADATA_KEY = 'buyerProvidedEvidence';
const SVP_ID_TO_OEM_KEY_MAP = {
    dust: 'dust',
    moke: 'moke',
    land: 'land',
    zero: 'zero',
    stark: 'stark',
    bonnell: 'bonnell',
    naxeon: 'naxeon',
    maeving: 'maeving',
    janus: 'janus',
    '0Cu8OddB7p5wtgH2FX1d': 'massimo',
    bakcou: 'bakcou',
    infinitemachine: 'infinitemachine',
    starev: 'starev',
    niu: 'niu',
    rena: 'rena',
    QpQLy4w6z8VHdtX2Pnt6: 'livewire',
    pave: 'pave',
};
const ROBOTIC_SIGNING_STATUS = {
    scheduled: 'scheduled',
    in_session: 'in_session',
    self_review: 'self_review',
    under_review: 'under_review',
    approved: 'approved',
};
// Valid session types for robotic signing
const ROBOTIC_SESSION_TYPES = {
    BUYER: 'buyer',
    COUNTER_SIGNING: 'counterSigning',
};
// RON (Remote Online Notarization) signing session statuses
const RON_SIGNING_STATUS = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FAILED: 'failed',
    SKIPPED: 'skipped',
};
// Valid session types for RON signing
const RON_SESSION_TYPES = {
    BUYER: 'buyer',
    SELLER: 'seller',
};
// Single-winner claim for generating a purchased vehicle's coverage (F&I)
// contracts through the provider. The provider registration is not idempotent,
// so the status is claimed compare-and-set before the call: IN_PROGRESS holds
// the claim, COMPLETED is terminal (contracts exist), FAILED is retryable.
const COVERAGE_CONTRACT_GENERATION_STATUS = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FAILED: 'failed',
};
const LINE_ITEM_CATEGORIES = {
    VEHICLES: 'vehicles',
    LOOSE_ACCESSORIES: 'looseAccessories',
};
// values that are not taxable and injected via service config pricing
const NON_TAXABLE_LINE_ITEM_CODES = {
    TEMP_TAG_FEE: 'TEMP_TAG_FEE',
    STATE_FEE: 'STATE_FEE',
    REGISTRATION_FEE: 'REGISTRATION_FEE',
    BATTERY_FEE: 'BATTERY_FEE',
    TIRE_FEE: 'TIRE_FEE',
    // TITLING_FEE: 'TITLING_FEE', // uncomment once decoupled from our digital servicing fee
};
// One line per selected F&I product, named by product type (the itemized
// replacement for the three vendor/platform/fulfillment bucket lines). These are
// the codes sent to Vertex for per-product taxability review. The vendor/
// platform/fulfillment payout splits are carried per product in the line's
// `metadata.coverageBreakdown` and summed at payout-read time. They carry no
// `_FEE` suffix, so coverage classification keys on this set rather than the
// `_FEE` substring.
const COVERAGE_PRODUCT_LINE_ITEM_FEES = {
    COVERAGE_GAP: 'COVERAGE_GAP',
    COVERAGE_TIRE: 'COVERAGE_TIRE',
    COVERAGE_VSC: 'COVERAGE_VSC',
    COVERAGE_BATTERY: 'COVERAGE_BATTERY',
};
const COVERAGE_LINE_ITEM_FEES = {
    COVERAGE_FULFILLMENT_FEE: 'COVERAGE_FULFILLMENT_FEE',
    COVERAGE_VENDOR_FEE: 'COVERAGE_VENDOR_FEE',
    COVERAGE_PLATFORM_FEE: 'COVERAGE_PLATFORM_FEE',
    ...COVERAGE_PRODUCT_LINE_ITEM_FEES,
};
const COVERAGE_LINE_ITEM_TAXES = {
    COVERAGE_TAX: 'COVERAGE_TAX',
};
const COVERAGE_LINE_ITEM_CODES = {
    ...COVERAGE_LINE_ITEM_FEES,
    ...COVERAGE_LINE_ITEM_TAXES,
};
// values injected via service config pricing (includes non-taxable codes)
const INJECTED_FEE_CODES_BASE = {
    VENDOR_FEE: 'VENDOR_FEE',
    TITLING_FEE: 'TITLING_FEE',
    INSPECTION_FEE: 'INSPECTION_FEE',
    ASSEMBLY_FEE: 'ASSEMBLY_FEE',
    FREIGHT_FEE: 'FREIGHT_FEE',
    // Import tariff the OEM passes through to the buyer. Taxable, like freight.
    TARIFF_FEE: 'TARIFF_FEE',
    DOCUMENT_FEE: 'DOCUMENT_FEE',
    BATTERY_FEE: 'BATTERY_FEE',
    TIRE_FEE: 'TIRE_FEE',
    TEMP_TAG_FEE: 'TEMP_TAG_FEE',
    FINANCING_BROKERAGE_FEE: 'FINANCING_BROKERAGE_FEE',
    FINANCING_BROKERAGE_PLATFORM_FEE: 'FINANCING_BROKERAGE_PLATFORM_FEE',
};
const INJECTED_TAX_CODES = {
    ...COVERAGE_LINE_ITEM_TAXES,
};
const INJECTED_FEE_CODES = {
    ...INJECTED_FEE_CODES_BASE,
    ...COVERAGE_LINE_ITEM_FEES,
};
// base line item codes (not injected via service config)
const BASE_LINE_ITEM_CODES = {
    MSRP: 'MSRP', // pricing configs with this code will reduce inventory payout by calculated amount (does not inject new fees into Checkout)
    ACCESSORY: 'ACCESSORY',
    SPEC: 'SPEC',
    BOLT_ON_ACCESSORY: 'BOLT_ON_ACCESSORY',
    LOOSE_ACCESSORY: 'LOOSE_ACCESSORY',
    SHIPPING_FEE: 'SHIPPING_FEE',
    PICKUP_FEE: 'PICKUP_FEE',
    VEHICLE_ORDER_FEE: 'VEHICLE_ORDER_FEE',
    VIP_RESERVATION_FEE: 'VIP_RESERVATION_FEE',
    LOOSE_ACCESSORY_TAX: 'LOOSE_ACCESSORY_TAX',
    VEHICLE_SALES_TAX: 'VEHICLE_SALES_TAX',
    REGISTRATION_FEE: 'REGISTRATION_FEE',
    DISCOUNT: 'DISCOUNT',
    FULL_PAYMENT_DISCOUNT: 'FULL_PAYMENT_DISCOUNT',
    ACH_FULL_PAYMENT_DISCOUNT: 'ACH_FULL_PAYMENT_DISCOUNT',
    KLARNA_DISCOUNT: 'KLARNA_DISCOUNT',
    CRYPTO_FULL_PAYMENT_DISCOUNT: 'CRYPTO_FULL_PAYMENT_DISCOUNT',
    FINANCING_DOWNPAYMENT: 'FINANCING_DOWNPAYMENT',
    PREV_PAID: 'PREV_PAID',
    STATE_TAX: 'STATE_TAX',
    COVERAGE_TAX: 'COVERAGE_TAX',
    STATE_FEE: 'STATE_FEE',
    EXEMPTION: 'EXEMPTION',
    SKIP_SYNC: 'SKIP_SYNC', // skips checkout fee injection and payout creation for priced-but-not-buyer-facing configs (e.g. affiliate commission)
    REBATE: 'REBATE',
};
// dictionary of all line item codes
const LINE_ITEM_CODES = {
    ...BASE_LINE_ITEM_CODES,
    ...INJECTED_FEE_CODES,
    ...INJECTED_TAX_CODES,
};
const SARDINE_SESSION_KEY = 'sardineSession';
const InventoryLocation = {
    WAREHOUSE: 'WAREHOUSE',
    SSP_LOT: 'SSP_LOT',
};
// DEVELOPMENT ALGOLIA CONFIGURATION (used for staging and development environments)
const developmentAlgoliaConfig = {
    appId: 'IR5NE7TKQX',
    readApiKey: '7949b377c7dfe8e5ae53601d633ee951',
};
const stagingAlgoliaConfig = {
    appId: 'KJXL6I7UFH',
    readApiKey: '891d292d1d903a3570569ac2adf242ea',
};
const demoAlgoliaConfig = {
    appId: 'IB15VHWBN4',
    readApiKey: 'd1a7bc1e42e99ad889a7c2e6bc0a2332',
};
const productionAlgoliaConfig = {
    appId: '91ZV9PGX3N',
    readApiKey: 'd66540dae3e2f319aed12e2a04a77c0f',
};
const localAlgoliaConfigMap = {
    nadim: {
        appId: 'EW7THQ9D7K',
        readApiKey: 'de6656ef456000f90456b1718c78bb6d',
    },
    // Devin's named Firestore DB mirrors nadim's, so reusing nadim's read key
    // surfaces consistent data for QA test runs. Read-only key — no write risk.
    devin: {
        appId: 'EW7THQ9D7K',
        readApiKey: 'de6656ef456000f90456b1718c78bb6d',
    },
    bongi: {
        appId: 'RL79JZZM1J',
        readApiKey: '6dc8fd847597573a8d2098053131351d',
    },
    victor: {
        appId: '2AQVK65T74',
        readApiKey: 'e880a6767fff79031c942531825b00d8',
    },
    tristen: {
        appId: 'KK8BIQ8VWY',
        readApiKey: '3d1b3a5503f682f43817dd0ec65826c2',
    },
    rohan: {
        appId: '5HDDKXWGIP',
        readApiKey: '1d35b63c3a14f29945d7c9791f7a241b',
    },
    rodrigo: {
        appId: 'DSNM6FXP7Q',
        readApiKey: 'eea80fb239023657df94ada697787f83',
    },
    jonathan: {
        appId: 'DSNM6FXP7Q',
        readApiKey: 'eea80fb239023657df94ada697787f83',
    },
    rowan: {
        appId: '2FFN3RGR6E',
        readApiKey: 'a3e2d4ef67a24fa454f02f2dd39d754d',
    },
    david: {
        appId: 'NS7QRZPSZX',
        readApiKey: 'c5944d7c3bde363f61a08ed37b0df20d',
    },
    chris: {
        appId: 'NZPGROB2CH',
        readApiKey: '8acbd6b117447765c73be0ea04e04703',
    },
    alexis: {
        appId: 'W3FUEJQDQ7',
        readApiKey: '4d304f74751a6e537770a6ff8c2c9c91',
    },
    mahmoud: {
        appId: '0DH20KIT09',
        readApiKey: 'db6affce7a02f560631836774fbc577f',
    },
    nisarg: {
        appId: 'DSNM6FXP7Q',
        readApiKey: 'eea80fb239023657df94ada697787f83',
    },
};
const OLD_PRODUCT_ID_TO_CANON_VEHICLE_ID_MAP = {
    'moke-international-gen-1-ev': 'GEN1EV2025',
    Gen1EV: 'GEN1EV2025',
    '7354877050914': 'HIGHTAIL2025',
    olto: 'OLTO2025',
    p1: 'P12026',
    '9806924415257': 'OLTO2025',
    '8527772549401': 'P12026',
    LW1: 'LIVEWIREONE2022',
    S2AP: 'S2ALPINISTA2025',
    S2DM: 'S2DELMAR2024',
    S2MH: 'S2MULHOLLAND2024',
    '7759622373531': 'RM12025',
    '8135661125787': 'RM1S2025',
    '8135670661275': 'RM1S2025',
    '8263930871963': 'RM1S2025',
    '8450684092571': 'RM1S2025',
    '8655060086683': 'RM1S2025',
    '8742312654363': 'RM1S2025',
    '8474611318939': 'RM1S2025',
    BUCK250: 'BUCK2502025',
    BUCK250X: 'BUCK250X2025',
    BUCK450: 'BUCK4502025',
    BUCK450X: 'BUCK450X2025',
    BUCK5506: 'BUCK55062025',
    CARGOMAXETRIKE: 'CARGOMAXETRIKE2025',
    GKA200: 'GKA2002025',
    GKD125: 'GKD1252025',
    GKD200S: 'GKD200S2025',
    GKD350: 'GKD3502025',
    GKM200: 'GKM2002025',
    MB100: 'MB1002025',
    MGCCARGOMAX: 'MGCCARGOMAX2025',
    MGCETRIKE: 'MGCETRIKE2025',
    MGCETRIKEMINI: 'MGCETRIKEMINI2025',
    MINI125: 'MINI1252025',
    MINIBIKE200: 'MINIBIKE2002025',
    MINIBIKE200S: 'MINIBIKE200S2025',
    MINITRACTOR: 'MINITRACTOR2025',
    MSA210: 'MSA2102025',
    MSA450F: 'MSA450F2025',
    MSA550: 'MSA5502025',
    MSA560: 'MSA5602025',
    MSA760: 'MSA7602025',
    MSU850: 'MSU8502025',
    MSU8505: 'MSU85052025',
    MVR2X: 'MVR2X2025',
    MVRCARGOMAX: 'MVRCARGOMAX2025',
    MVRHVAC: 'MVRHVAC2025',
    TBOSS1000: 'TBOSS10002025',
    TBOSS410: 'TBOSS4102025',
    TBOSS410X: 'TBOSS410X2025',
    TBOSS560: 'TBOSS5602025',
    TBOSS560BASE: 'TBOSS560BASE2025',
    TBOSS560L: 'TBOSS560L2025',
    TBOSS560X: 'TBOSS560X2025',
    TBOSS760: 'TBOSS7602025',
    TBOSS760BASE: 'TBOSS760BASE2025',
    TBOSS760L: 'TBOSS760L2025',
    TIRO400: 'TIRO4002025',
    TIRO480: 'TIRO4802025',
    TIRO800: 'TIRO8002025',
    WARRIOR1000MXD: 'WARRIOR1000MXD2025',
    WARRIOR1000MXDCREW: 'WARRIOR1000MXDCREW2025',
    iam: 'IAM2025',
    'iam-lite': 'IAM2026',
    'iam-pro': 'IAMPRO2025',
    'iam-pro-2024': 'IAMPRO2024',
    '7830857318460': 'XQI3STREET2025',
    '7329554890812': 'XQI3WILD2025',
    bk: 'BK2025',
    bku: 'BKU2025',
    JMODEL2P: 'JMODEL22026',
    JMODEL2x2: 'JMODEL2x22026',
    JMODEL2x2LIFTED: 'JMODEL2x2LIFTED2026',
    JMODEL4P: 'JMODEL42026',
    JMODEL4PLIFTED: 'JMODEL4LIFTED2026',
    JMODEL4x2: 'JMODEL4x22026',
    JMODEL4x2LIFTED: 'JMODEL4x2LIFTED2026',
    SIRIUS2P: 'SIRIUS22026',
    SIRIUS2x2: 'SIRIUS2x22026',
    SIRIUS2x2LIFTED: 'SIRIUS2x2LIFTED2026',
    SIRIUS4P: 'SIRIUS42026',
    SIRIUS4x2: 'SIRIUS4x22026',
    SIRIUS4x2LIFTED: 'SIRIUS4x2LIFTED2026',
    '45dac47d-6cf5-4d96-9dc8-43328cc7712a': 'stark',
    '37dac47d-6cf5-4d96-9dc8-43328cc7717c': 'stark',
    '13dac47d-6cf5-4d96-9dc8-43328cc77136': 'stark',
    'zero-xb': 'XB2026',
    'zero-xe': 'XE2026',
    zeroDs: 'DS2025',
    zeroDs2024: 'DS2024',
    zeroDsr: 'DSR2025',
    zeroDsr2024: 'DSR2024',
    zeroDsrX: 'DSRX2025',
    zeroDsrX2024: 'DSRX2024',
    zeroFx: 'FX2025',
    zeroFx2024: 'FX2024',
    zeroFxe2024: 'FXE2024',
    zeroS: 'S2025',
    zeroS2024: 'S2024',
    zeroSrF: 'SRF2025',
    zeroSrS: 'SRS2025',
    zeroXb: 'XB2026',
    zeroXe: 'XE2026',
    zeroFxe: 'FXE2025',
    '45050268385435': 'RM1S2025',
    '45050268418203': 'RM1S2025',
    '45050268450971': 'RM1S2025',
    '45050268483739': 'RM1S2025',
    '45050268516507': 'RM1S2025',
    '45050268549275': 'RM1S2025',
    '45050268582043': 'RM1S2025',
    '45050268614811': 'RM1S2025',
    '45050268647579': 'RM1S2025',
    '45050268680347': 'RM1S2025',
    '45050268713115': 'RM1S2025',
    '45050268745883': 'RM1S2025',
    '45050268778651': 'RM1S2025',
    '45050268811419': 'RM1S2025',
    '45050268844187': 'RM1S2025',
    '45050268876955': 'RM1S2025',
    '45050268909723': 'RM1S2025',
    '45050268942491': 'RM1S2025',
    '45050268975259': 'RM1S2025',
    '45050269008027': 'RM1S2025',
    '45050269040795': 'RM1S2025',
    '45050269073563': 'RM1S2025',
    '45050269106331': 'RM1S2025',
    '45050269139099': 'RM1S2025',
    '45050269171867': 'RM1S2025',
    '45050269204635': 'RM1S2025',
    '45050269237403': 'RM1S2025',
    '45050269270171': 'RM1S2025',
    '45050269302939': 'RM1S2025',
    '45050269335707': 'RM1S2025',
    '45050269368475': 'RM1S2025',
    '45050269401243': 'RM1S2025',
    '45050269434011': 'RM1S2025',
    '45050269532315': 'RM1S2025',
    '45050269630619': 'RM1S2025',
    '45050269696155': 'RM1S2025',
    '45050269728923': 'RM1S2025',
    '45050269761691': 'RM1S2025',
    '45050269794459': 'RM1S2025',
    '45050269827227': 'RM1S2025',
    '45050269859995': 'RM1S2025',
    '45050269892763': 'RM1S2025',
    '45050269925531': 'RM1S2025',
    '45050269958299': 'RM1S2025',
    '45050269991067': 'RM1S2025',
    '45050270023835': 'RM1S2025',
    '45050270056603': 'RM1S2025',
    '45050270089371': 'RM1S2025',
    '45050270122139': 'RM1S2025',
    '45050270154907': 'RM1S2025',
    '45050270187675': 'RM1S2025',
    '45050270220443': 'RM1S2025',
    '45050270253211': 'RM1S2025',
    '45050270285979': 'RM1S2025',
    '45050270318747': 'RM1S2025',
    '45050270351515': 'RM1S2025',
    '45050270384283': 'RM1S2025',
    '45050270417051': 'RM1S2025',
    '45050270449819': 'RM1S2025',
    '45050270482587': 'RM1S2025',
    '45050270515355': 'RM1S2025',
    '45050270548123': 'RM1S2025',
    '45050270580891': 'RM1S2025',
    '45050270613659': 'RM1S2025',
    '45050270646427': 'RM1S2025',
    '45050270679195': 'RM1S2025',
    '45050270711963': 'RM1S2025',
    '45050270744731': 'RM1S2025',
    '45050270777499': 'RM1S2025',
    '45050270810267': 'RM1S2025',
    '45050270843035': 'RM1S2025',
    '45050270875803': 'RM1S2025',
    '45050175586459': 'RM1S2025',
    '45050175619227': 'RM1S2025',
    '45050175651995': 'RM1S2025',
    '45050175684763': 'RM1S2025',
    '45050175717531': 'RM1S2025',
    '45050175750299': 'RM1S2025',
    '45050175783067': 'RM1S2025',
    '45050175815835': 'RM1S2025',
    '45050175848603': 'RM1S2025',
    '45050175881371': 'RM1S2025',
    '45050175914139': 'RM1S2025',
    '45050175946907': 'RM1S2025',
    '45050175979675': 'RM1S2025',
    '45050176012443': 'RM1S2025',
    '45050176045211': 'RM1S2025',
    '45050176077979': 'RM1S2025',
    '45050176110747': 'RM1S2025',
    '45050176143515': 'RM1S2025',
    '45050176176283': 'RM1S2025',
    '45050176209051': 'RM1S2025',
    '45050176241819': 'RM1S2025',
    '45050176274587': 'RM1S2025',
    '46327356555419': 'RM1S2025',
    '46226841829531': 'RM1S2025',
    '46226841862299': 'RM1S2025',
    '46226841895067': 'RM1S2025',
    '46226841927835': 'RM1S2025',
    '46226841960603': 'RM1S2025',
    '46226841993371': 'RM1S2025',
    '46226842026139': 'RM1S2025',
    '46226842058907': 'RM1S2025',
    '46226842091675': 'RM1S2025',
    '46226842124443': 'RM1S2025',
    '46226842157211': 'RM1S2025',
    '46226842189979': 'RM1S2025',
    '46226842222747': 'RM1S2025',
    '46226842255515': 'RM1S2025',
    '46226842288283': 'RM1S2025',
    '46226842321051': 'RM1S2025',
    '46226842353819': 'RM1S2025',
    '46226842386587': 'RM1S2025',
    '46226842419355': 'RM1S2025',
    '46226842452123': 'RM1S2025',
    '46226842484891': 'RM1S2025',
    '46226842517659': 'RM1S2025',
    '46226842550427': 'RM1S2025',
    '46226842583195': 'RM1S2025',
    '46226842615963': 'RM1S2025',
    '46226842648731': 'RM1S2025',
    '46226842681499': 'RM1S2025',
    '46226842714267': 'RM1S2025',
    '46226842747035': 'RM1S2025',
    '46226842779803': 'RM1S2025',
    '46226842812571': 'RM1S2025',
    '46226842845339': 'RM1S2025',
    '46226842878107': 'RM1S2025',
    '46226842910875': 'RM1S2025',
    '46226842943643': 'RM1S2025',
    '46226842976411': 'RM1S2025',
    '46226843009179': 'RM1S2025',
    '46226843041947': 'RM1S2025',
    '46226843074715': 'RM1S2025',
    '46226843107483': 'RM1S2025',
    '46226843140251': 'RM1S2025',
    '46226843173019': 'RM1S2025',
    '46226843205787': 'RM1S2025',
    '46226843238555': 'RM1S2025',
    '46226843271323': 'RM1S2025',
    '46226843304091': 'RM1S2025',
    '46226843336859': 'RM1S2025',
    '46226843369627': 'RM1S2025',
    '46226843402395': 'RM1S2025',
    '46226843435163': 'RM1S2025',
    '46226843467931': 'RM1S2025',
    '46226843500699': 'RM1S2025',
    '46226843533467': 'RM1S2025',
    '46226843566235': 'RM1S2025',
    '46226843599003': 'RM1S2025',
    '46226843631771': 'RM1S2025',
    '46226843664539': 'RM1S2025',
    '46226843697307': 'RM1S2025',
    '46226843730075': 'RM1S2025',
    '46226843762843': 'RM1S2025',
    '46226843795611': 'RM1S2025',
    '46226843828379': 'RM1S2025',
    '46226843861147': 'RM1S2025',
    '46226843893915': 'RM1S2025',
    '46226843926683': 'RM1S2025',
    '46226843959451': 'RM1S2025',
    '46226843992219': 'RM1S2025',
    '46226844024987': 'RM1S2025',
    '46226844057755': 'RM1S2025',
    '46226844090523': 'RM1S2025',
    '46226844123291': 'RM1S2025',
    '46226844156059': 'RM1S2025',
};
const OLD_VARIANT_ID_TO_COLOR_MAP = {
    'zero-xe-1': 'WhiteRed',
    'zero-xe-2': 'WhiteRed',
    'zero-xb-1': 'WhiteRed',
    'zero-xb-2': 'WhiteRed',
    gray: 'ForestGray', // this is for stark
    white: 'SnowWhite', // this is for stark
    red: 'StarkRed', // this is for stark
    '45512003125403': 'White',
    '45512003158171': 'White',
    '45512003190939': 'Black',
    '45512003223707': 'Black',
    '45512003256475': 'Sunset',
    '45512003289243': 'Sunset',
    '45512003322011': 'Harlequin',
    '45512003354779': 'Harlequin',
    '45512003387547': 'DarkBlue',
    '45512003420315': 'DarkBlue',
    '45512003453083': 'Black',
    '45512003485851': 'Black',
    '45512003518619': 'Green',
    '45512003551387': 'Green',
    '45512003584155': 'Gray',
    '45512003616923': 'Gray',
    '45512003649691': 'Gray',
    '45512003682459': 'Gray',
    '45512003715227': 'White',
    '45512003747995': 'White',
    '45512003780763': 'SilverAluminum',
    '45512003813531': 'SilverAluminum',
    '45050268385435': 'DarkBlue',
    '45050268418203': 'DarkBlue',
    '45050268450971': 'DarkBlue',
    '45050268483739': 'DarkBlue',
    '45050268516507': 'DarkBlue',
    '45050268549275': 'DarkBlue',
    '45050268582043': 'DarkBlue',
    '45050268614811': 'DarkBlue',
    '45050268647579': 'Black',
    '45050268680347': 'Black',
    '45050268713115': 'Black',
    '45050268745883': 'Black',
    '45050268778651': 'Black',
    '45050268811419': 'Black',
    '45050268844187': 'Black',
    '45050268876955': 'Black',
    '45050268909723': 'Green',
    '45050268942491': 'Green',
    '45050268975259': 'Green',
    '45050269008027': 'Green',
    '45050269040795': 'Green',
    '45050269073563': 'Green',
    '45050269106331': 'Green',
    '45050269139099': 'Green',
    '45050269171867': 'Gray',
    '45050269204635': 'Gray',
    '45050269237403': 'Gray',
    '45050269270171': 'Gray',
    '45050269302939': 'Gray',
    '45050269335707': 'Gray',
    '45050269368475': 'Gray',
    '45050269401243': 'Gray',
    '45050269434011': 'Gray',
    '45050269532315': 'Gray',
    '45050269630619': 'Gray',
    '45050269696155': 'Gray',
    '45050269728923': 'Gray',
    '45050269761691': 'Gray',
    '45050269794459': 'Gray',
    '45050269827227': 'Gray',
    '45050269859995': 'White',
    '45050269892763': 'White',
    '45050269925531': 'White',
    '45050269958299': 'White',
    '45050269991067': 'White',
    '45050270023835': 'White',
    '45050270056603': 'White',
    '45050270089371': 'White',
    '45050270122139': 'SilverAluminum',
    '45050270154907': 'SilverAluminum',
    '45050270187675': 'SilverAluminum',
    '45050270220443': 'SilverAluminum',
    '45050270253211': 'SilverAluminum',
    '45050270285979': 'SilverAluminum',
    '45050270318747': 'SilverAluminum',
    '45050270351515': 'SilverAluminum',
    '45050270384283': 'Black',
    '45050270417051': 'Black',
    '45050270449819': 'Black',
    '45050270482587': 'Black',
    '45050270515355': 'Black',
    '45050270548123': 'Black',
    '45050270580891': 'Black',
    '45050270613659': 'Black',
    '45050270646427': 'White',
    '45050270679195': 'White',
    '45050270711963': 'White',
    '45050270744731': 'White',
    '45050270777499': 'White',
    '45050270810267': 'White',
    '45050270843035': 'White',
    '45050270875803': 'White',
    '45050175586459': 'White',
    '45050175619227': 'White',
    '45050175651995': 'Black',
    '45050175684763': 'Black',
    '45050175717531': 'Red',
    '45050175750299': 'Red',
    '45050175783067': 'Gray',
    '45050175815835': 'Gray',
    '45050175848603': 'DarkBlue',
    '45050175881371': 'DarkBlue',
    '45050175914139': 'Black',
    '45050175946907': 'Black',
    '45050175979675': 'Green',
    '45050176012443': 'Green',
    '45050176045211': 'Gray',
    '45050176077979': 'Gray',
    '45050176110747': 'Gray',
    '45050176143515': 'Gray',
    '45050176176283': 'White',
    '45050176209051': 'White',
    '45050176241819': 'SilverAluminum',
    '45050176274587': 'SilverAluminum',
    '46327356555419': 'Black',
    '46226841829531': 'DarkBlue',
    '46226841862299': 'DarkBlue',
    '46226841895067': 'DarkBlue',
    '46226841927835': 'DarkBlue',
    '46226841960603': 'DarkBlue',
    '46226841993371': 'DarkBlue',
    '46226842026139': 'DarkBlue',
    '46226842058907': 'DarkBlue',
    '46226842091675': 'Black',
    '46226842124443': 'Black',
    '46226842157211': 'Black',
    '46226842189979': 'Black',
    '46226842222747': 'Black',
    '46226842255515': 'Black',
    '46226842288283': 'Black',
    '46226842321051': 'Black',
    '46226842353819': 'Green',
    '46226842386587': 'Green',
    '46226842419355': 'Green',
    '46226842452123': 'Green',
    '46226842484891': 'Green',
    '46226842517659': 'Green',
    '46226842550427': 'Green',
    '46226842583195': 'Green',
    '46226842615963': 'Gray',
    '46226842648731': 'Gray',
    '46226842681499': 'Gray',
    '46226842714267': 'Gray',
    '46226842747035': 'Gray',
    '46226842779803': 'Gray',
    '46226842812571': 'Gray',
    '46226842845339': 'Gray',
    '46226842878107': 'Gray',
    '46226842910875': 'Gray',
    '46226842943643': 'Gray',
    '46226842976411': 'Gray',
    '46226843009179': 'Gray',
    '46226843041947': 'Gray',
    '46226843074715': 'Gray',
    '46226843107483': 'Gray',
    '46226843140251': 'White',
    '46226843173019': 'White',
    '46226843205787': 'White',
    '46226843238555': 'White',
    '46226843271323': 'White',
    '46226843304091': 'White',
    '46226843336859': 'White',
    '46226843369627': 'White',
    '46226843402395': 'SilverAluminum',
    '46226843435163': 'SilverAluminum',
    '46226843467931': 'SilverAluminum',
    '46226843500699': 'SilverAluminum',
    '46226843533467': 'SilverAluminum',
    '46226843566235': 'SilverAluminum',
    '46226843599003': 'SilverAluminum',
    '46226843631771': 'SilverAluminum',
    '46226843664539': 'Black',
    '46226843697307': 'Black',
    '46226843730075': 'Black',
    '46226843762843': 'Black',
    '46226843795611': 'Black',
    '46226843828379': 'Black',
    '46226843861147': 'Black',
    '46226843893915': 'Black',
    '46226843926683': 'White',
    '46226843959451': 'White',
    '46226843992219': 'White',
    '46226844024987': 'White',
    '46226844057755': 'White',
    '46226844090523': 'White',
    '46226844123291': 'White',
    '46226844156059': 'White',
    '43825366892699': 'Black',
    '43778010448027': 'Blue',
    '43778010579099': 'Black',
    '43778010710171': 'SilverAluminum',
    '43778010841243': 'White',
    '43778011103387': 'Green',
    '43778011234459': 'Beige',
    '43825363484827': 'Blue',
    '43825363550363': 'Black',
    '43825363615899': 'SilverAluminum',
    '43825363681435': 'White',
    '43825363812507': 'Green',
    '43825363878043': 'Gray',
    '43825366827163': 'Blue',
    '43825366859931': 'Blue',
    '43825366925467': 'Black',
    '43825366958235': 'SilverAluminum',
    '43825366991003': 'SilverAluminum',
    '43825367023771': 'White',
    '43825367056539': 'White',
    '43825367154843': 'Green',
    '43825367187611': 'Green',
    '43825367220379': 'Beige',
    '43825367253147': 'Beige',
    '43825562910875': 'Gray',
    '43825562943643': 'Gray',
    '43825562976411': 'Gray',
    '43825563009179': 'Gray',
    '43913672687771': 'Black',
};
const CLERQ_SUPPORTED_STATES = [
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'GA',
    'HI',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'ME',
    'MD',
    'MA',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NY',
    'NC',
    'ND',
    'OH',
    'PA',
    'SC',
    'SD',
    'TN',
    'TX',
    'VT',
    'VA',
    'WV',
    'WI',
];
// Vehicle types that are considered off-road (not street legal)
// These vehicles typically do not require TAR processing and do not require insurance for financing
const OFF_ROAD_VEHICLE_TYPES = [
    VehicleType.ATV,
    VehicleType.OHV,
    VehicleType.ORV,
    VehicleType.NON_TITLED_VEHICLE,
];
// ── Org Structure (canonical names, aligned with Slack channels) ──
const EKHO_DEPARTMENT = {
    RND: 'rnd',
    GTM: 'gtm',
    OPERATIONS: 'operations',
    BIZOPS: 'business-operations',
};
const EKHO_TEAM = {
    PLATFORM: 'platform',
    PLATFORM_OPS: 'platform-ops',
    CXP: 'cxp',
    BXP: 'bxp',
    PAYMENTS: 'payments',
    OPSENG: 'opseng',
    CLIENT_AND_PRODUCT_SUCCESS: 'client-and-product-success',
    BUYER_SUCCESS: 'buyer-success',
    ADMIN_OPS: 'admin-ops',
    PARTNERSHIPS: 'partnerships',
    MARKETING: 'marketing',
    DESIGN: 'design',
    OTHER: 'other',
};
// ── Multi-vehicle cart ──
/**
 * Program owners whose checkout carts hold more than one vehicle.
 *
 * Every other program owner is single-vehicle: the cart keeps only the first
 * vehicle in the payload and rejects a payload mixing product ids.
 *
 * Cloned tenants belong here alongside the tenant they copy. A clone that is
 * absent takes the single-vehicle branch, so its multi-vehicle E2E specs would
 * exercise a code path the tenant they stand in for never runs.
 */
const MULTI_VEHICLE_PROGRAM_OWNERS = ['stark', 'stark-e2e'];
/** Whether a program owner's cart carries every vehicle in the payload. */
function supportsMultiVehicleCart(programOwnerId) {
    return !!programOwnerId && MULTI_VEHICLE_PROGRAM_OWNERS.includes(programOwnerId);
}

export { ADDITIONAL_FIELDS_MAP, AK_VEHICLE_TYPE_ENUM, ALL_REPORTS, AL_FUEL_TYPE_ENUM, AL_USE_TYPE_ENUM, AL_VEHICLE_TYPE_ENUM, ARBITRATION_FEE, ARCTIC_LEOPARD_BRAND_KEY, ARCTIC_LEOPARD_OEM_ID, AR_CYLINDER_TYPE_ENUM, AR_FUEL_TYPE_ENUM, AR_PLATE_TYPE_ENUM, AR_VEHICLE_TYPE_ENUM, AUTH_CLASSES, AVERAGE_LOAN_TERM, AZ_FUEL_TYPE_ENUM, AZ_VEHICLE_TYPE_ENUM, AllModalPageNames, BACKEND_BP_OEM_ID, BACKEND_BP_OEM_KEY, BAKCOU_BRAND_KEY, BAKCOU_OEM_ID, BAKCOU_OEM_KEY, BANK_INSURANCE_MIN_AMOUNTS, BONNELL_BRAND_KEY, BONNELL_OEM_ID, BONNELL_OEM_KEY, BP_OEM_ID, BP_OEM_KEY, BREX_LLC_ACCOUNT_ID, BREX_TRANSFER_DIRECTION, BUYER_BLOCKED_ENUM, BUYER_DUE_DATES, BUYER_PORTAL_PAYMENT_TYPES, BUYER_PORTAL_SECTIONS, BUYER_PORTAL_SECTION_NAMES, BUYER_PORTAL_STATUSES, BUYER_PROVIDED_EVIDENCE_METADATA_KEY, BUYER_WRITABLE_DOCUMENT_STEPS, CANCELATION_AGENT_ENUM, CA_BODY_TYPE_ENUM, CA_FUEL_TYPE_ENUM, CA_VEHICLE_TYPE_ENUM, CCW_BRAND_KEY, CCW_OEM_ID, CCW_OEM_KEY, CG_BREXVENDOR_DETAILS, CG_PROCESSING_FEE, CG_VEHICLE_TYPE_ENUM, CHECKOUT_CART_LINK_TYPES, CHECKOUT_ERROR_SECTIONS, CHECKOUT_INFO_MAX_WIDTH, CHECKOUT_OEM_ID, CHECKOUT_OEM_KEY, CHECKOUT_PAGES, CHECKOUT_PAYMENT_TYPES, CHECKOUT_SECTIONS, CHECKOUT_SYSTEM_ERROR_SECTIONS, CHECKOUT_VALIDATION_ERROR_CODES, CHRIS_TESTING_EMAIL, CLERQ_AUTHORIZATION_CODES, CLERQ_CHECKOUT_MAX, CLERQ_CHECKOUT_MIN, CLERQ_PAYMENT_STATUS_TYPES, CLERQ_SUPPORTED_STATES, COLORS, CONTACT_FIELD_ERROR_CODES, COVERAGE_CONTRACT_GENERATION_STATUS, COVERAGE_LINE_ITEM_CODES, COVERAGE_LINE_ITEM_FEES, COVERAGE_LINE_ITEM_TAXES, COVERAGE_PRODUCT_LINE_ITEM_FEES, CO_BODY_TYPE_ENUM, CO_BODY_TYPE_ID_ENUM, CO_COLOR_ENUM, CO_FUEL_TYPE_ENUM, CO_PLATE_TYPE_ENUM, CO_USE_TYPE_ENUM, CO_VEHICLE_TYPE_ENUM, CRA, CRAMetadata, CREDIT_AGENCIES, CREDIT_APP_DISCLAIMER, CREDIT_APP_FIELD_IDS, CREDIT_APP_REJECTION_REASONS, CREDIT_APP_REJECTION_REASON_LABELS, CRYPTO_CHECKOUT_MAX, CRYPTO_CHECKOUT_MIN, CT_FUEL_TYPE_ENUM, CT_USE_TYPE_ENUM, CT_VEHICLE_TYPE_ENUM, DC_FUEL_TYPE_ENUM, DC_USE_TYPE_ENUM, DC_VEHICLE_TYPE_ENUM, DEALER_TAR_DOCS_KEY, DECISION_LENDER_CREDIT_APP_SUBMIT_URL, DEFAULT_BODY_TYPE_ID_ENUM, DEFAULT_CYLINDER_TYPE_ENUM, DEFAULT_DAYS_UNTIL_FIRST_PAYMENT, DEFAULT_FUEL_TYPE_ENUM, DEFAULT_MIN_LOAN_AMOUNT, DEFAULT_PREORDER_LINK_NAME, DEFAULT_TRANSFER_ID, DELIVERY_CHOICES, DELIVERY_METHOD_ENUM, DEMO_BRAND_KEY, DEMO_OEM_ID, DEV_BRAND_KEY, DEV_OEM_ID, DEV_OEM_KEY, DE_FUEL_TYPE_ENUM, DE_VEHICLE_TYPE_ENUM, DISQUALIFYING_FICO_SCORE_UNAVAILABLE_REASONS, DOCUMENT_PACKET_NAMES, DOCUMENT_PACKET_TYPES, DOCUMENT_STEPS_ENUM, DUMMY_LENDER_INFO, DUMMY_TAR_INSURANCE_DATA, DUST_BRAND_KEY, DUST_OEM_ID, DUST_OEM_KEY, DocumentTypesToDownload, DocumentTypesToDownloadMap, EKHO_APPS_ENUM, EKHO_DEPARTMENT, EKHO_FINANCING_APPLICATION_CATEGORIZATIONS, EKHO_FINANCING_APPLICATION_CONSTANTS, EKHO_FINANCING_APPLICATION_SECTIONS, EKHO_FINANCING_APPLICATION_SECTION_ANCHORS, EKHO_FINANCING_STIPULATIONS_KEYS, EKHO_FINANCING_STIPULATION_LABELS, EKHO_LOAN_TERM_OPTIONS, EKHO_MCO_SIG, EKHO_SERVICES_PROVIDER_ID, EKHO_SUPPORT_EMAIL, EKHO_SUPPORT_PHONE, EKHO_SUPPORT_SCHEDULE, EKHO_TEAM, EKHO_WET_SIG_TAR_DOCS_KEY, ENV, EquivalentVehicleCoverageCodes, FALLBACK_DELIVERY_TIME, FALLBACK_PRODUCTION_TIME, FCRA_DISCLOSURE_VERSION, FICO_SCORE_UNAVAILABLE_REASONS, FINANCING_BANK_NAME_ENUM, FINANCING_STAGE_MAP, FL_COLOR_ENUM, FL_FUEL_TYPE_ENUM, FL_TITLE_TYPE_ENUM, FL_VEHICLE_TYPE_ENUM, FORMIK_DATE_FIELDS, FORM_THIRD_PARTY_SIGNER_ENUM, FREEDOMROAD_FINANCIAL_MINIMUM_LOAN_AMOUNT, FULFILLMENT_STATUS_ENUM, FUNDING_PACKET_STATUS_ENUM, FeeEstimateFidelity, FinanceOfferBuyerDecision, FinancingActionItemOptions, GA_COLOR_ENUM, GA_CYLINDER_TYPE_ENUM, GA_FUEL_TYPE_ENUM, GA_USE_TYPE_ENUM, GA_VEHICLE_TYPE_ENUM, GOOGLE_AUTOCOMPLETE_AND_MAPS_LIBRARIES, GOOGLE_AUTOCOMPLETE_LIBRARIES, GOOGLE_MAP_STYLES, HOW_IT_WORKS_SECTIONS, HOW_IT_WORKS_SECTIONS_ENUM, HTTP_FIREBASE_ERROR_NAMES, IA_FUEL_TYPE_ENUM, IA_USE_TYPE_ENUM, IA_VEHICLE_TYPE_ENUM, ID_COLOR_ENUM, ID_DOCUMENT_TYPE_ENUM, ID_PLATE_TYPE_ENUM, ID_USE_TYPE_ENUM, ID_VEHICLE_TYPE_ENUM, IL_BODY_TYPE_ID_ENUM, IL_COLOR_ENUM, IL_FUEL_TYPE_ENUM, IL_PLATE_TYPE_ENUM, IL_VEHICLE_TYPE_ENUM, INFINITE_MACHINE_OEM_ID, INFINITE_MACHINE_OEM_KEY, INITIAL_DOWN_PAYMENT_SUBTRACTION, INITIAL_TERM, INJECTED_FEE_CODES, INJECTED_TAX_CODES, INPUT_TYPES, INSPECTION_TYPE_ENUM, INSURANCE_DOCUMENTS, INSURANCE_DOCUMENT_TYPE_ENUM, INSURANCE_EFFECTIVE_DAYS_BUFFER, INSURANCE_SELECTION_TYPES, INSURANCE_VALID_DAYS_BUFFER, INTERNAL_BODY_TYPE_ENUM, INTERNAL_COLOR_ENUM, INTERNAL_CREDIT_FILE_HIT_TYPES, INTERNAL_CYLINDER_TYPE_ENUM, INTERNAL_DOORS_ENUM, INTERNAL_FUEL_TYPE_ENUM, INTERNAL_ID_TYPE_ENUM, INTERNAL_NUMBER_WHEELS_ENUM, INTERNAL_TRANSMISSION_ENUM, INTERNAL_USE_TYPE_ENUM, IN_FUEL_TYPE_ENUM, IN_PLATE_TYPE_ENUM, IN_VEHICLE_TYPE_ENUM, InventoryLocation, JANUS_OEM_ID, JANUS_OEM_KEY, KS_COLOR_ENUM, KS_FUEL_TYPE_ENUM, KS_VEHICLE_TYPE_ENUM, KY_FUEL_TYPE_ENUM, KY_USE_TYPE_ENUM, KY_VEHICLE_TYPE_ENUM, LAND_OEM_ID, LAND_OEM_KEY, LA_COLOR_ENUM, LA_USE_TYPE_ENUM, LA_VEHICLE_TYPE_ENUM, LEAD_TYPE_ENUM, LENDER_DECISION_OPTIONS, LENDER_DECISION_REASONS, LENDER_DECISION_STATUS, LINE_ITEM_CATEGORIES, LINE_ITEM_CODES, LIVEWIRE_BRAND_KEY, LIVEWIRE_OEM_ID, LIVEWIRE_OEM_KEY, LOAD_TESTING_PAYMENT_INTENT_ID, LOG_SEVERITY_ENUM, MAEVING_OEM_ID, MAEVING_OEM_KEY, MAILGUN_API_USERNAME, MASSIMO_BRAND_KEY, MASSIMO_OEM_ID, MASSIMO_OEM_KEY, MAX_INSTANCES, MAX_RETRIES, MAX_VERIFICATION_ATTEMPTS, MAX_WEEKS_BEFORE_READY, MA_COLOR_ENUM, MA_DOORS_ENUM, MA_FUEL_TYPE_ENUM, MA_USE_TYPE_ENUM, MA_VEHICLE_TYPE_ENUM, MD_FUEL_TYPE_ENUM, MD_USE_TYPE_ENUM, MD_VEHICLE_TYPE_ENUM, ME_COLOR_ENUM, ME_FUEL_TYPE_ENUM, ME_PLATE_TYPE_ENUM, ME_USE_TYPE_ENUM, ME_VEHICLE_TYPE_ENUM, MIN_FIELDS_TO_COLLECT, MI_BODY_TYPE_ENUM, MI_BODY_TYPE_ID_ENUM, MI_FUEL_TYPE_ENUM, MI_PLATE_TYPE_ENUM, MI_USE_TYPE_ENUM, MI_VEHICLE_TYPE_ENUM, MN_COLOR_ENUM, MN_FUEL_TYPE_ENUM, MN_USE_TYPE_ENUM, MN_VEHICLE_TYPE_ENUM, MOBILE_SIDE_PADDING, MOKE_OEM_ID, MOKE_OEM_KEY, MO_COLOR_ENUM, MO_FUEL_TYPE_ENUM, MO_NUMBER_WHEELS_ENUM, MO_REG_PERIOD_TYPE_ENUM, MO_VEHICLE_TYPE_ENUM, MS_FUEL_TYPE_ENUM, MS_PLATE_TYPE_ENUM, MS_VEHICLE_TYPE_ENUM, MT_BODY_TYPE_ENUM, MT_BODY_TYPE_ID_ENUM, MT_COLOR_ENUM, MT_FUEL_TYPE_ENUM, MT_REG_PERIOD_TYPE_ENUM, MT_USE_TYPE_ENUM, MT_VEHICLE_TYPE_ENUM, MULTI_VEHICLE_PROGRAM_OWNERS, MUNROE_MOTORS_BRAND_KEY, MUNROE_MOTORS_OEM_ID, MUNROE_MOTORS_OEM_KEY, NAXEON_OEM_ID, NAXEON_OEM_KEY, NC_PLATE_TYPE_ENUM, NC_USE_TYPE_ENUM, NC_VEHICLE_TYPE_ENUM, ND_COLOR_ENUM, ND_FUEL_TYPE_ENUM, ND_VEHICLE_TYPE_ENUM, NE_FUEL_TYPE_ENUM, NE_USE_TYPE_ENUM, NE_VEHICLE_TYPE_ENUM, NH_FUEL_TYPE_ENUM, NH_VEHICLE_TYPE_ENUM, NIU_BRAND_KEY, NIU_OEM_ID, NIU_OEM_KEY, NJ_BODY_TYPE_ENUM, NJ_BODY_TYPE_ID_ENUM, NJ_FUEL_TYPE_ENUM, NJ_REG_PERIOD_TYPE_ENUM, NJ_USE_TYPE_ENUM, NJ_VEHICLE_TYPE_ENUM, NM_COLOR_ENUM, NM_FUEL_TYPE_ENUM, NM_PLATE_TYPE_ENUM, NM_REG_PERIOD_TYPE_ENUM, NM_USE_TYPE_ENUM, NM_VEHICLE_TYPE_ENUM, NON_TAXABLE_LINE_ITEM_CODES, NOTARY_FORM_TYPE, NOTARY_WORKFLOW_TYPE, NUDGE_BUYER_AGAIN, NUDGE_INACTIVE_BUYER, NV_FUEL_TYPE_ENUM, NV_PLATE_TYPE_ENUM, NV_REG_PERIOD_TYPE_ENUM, NV_USE_TYPE_ENUM, NV_VEHICLE_TYPE_ENUM, NY_BODY_TYPE_ENUM, NY_BODY_TYPE_ID_ENUM, NY_COLOR_ENUM, NY_FUEL_TYPE_ENUM, NY_USE_TYPE_ENUM, NY_VEHICLE_TYPE_ENUM, OEMS_THAT_CAN_OVERRIDE_VEHICLE_IMG_URL, OEM_KEY_TO_HOTJAR_SITE_ID, OEM_KEY_TO_PROJECT_MAP, OEM_REPORT_CATEGORY_ENUM, OEM_REPORT_KEY_ENUM, OFF_ROAD_VEHICLE_TYPES, OH_COLOR_ENUM, OH_FUEL_TYPE_ENUM, OH_VEHICLE_TYPE_ENUM, OK_COLOR_ENUM, OK_FUEL_TYPE_ENUM, OK_REG_PERIOD_TYPE_ENUM, OK_USE_TYPE_ENUM, OK_VEHICLE_TYPE_ENUM, OLD_PRODUCT_ID_TO_CANON_VEHICLE_ID_MAP, OLD_VARIANT_ID_TO_COLOR_MAP, OPS_PORTAL_URLS, ORDER_CREATION_TYPES, ORDER_VALIDATION_ATTEMPT_CAP, OR_BODY_TYPE_ENUM, OR_BODY_TYPE_ID_ENUM, OR_FUEL_TYPE_ENUM, OR_REG_PERIOD_TYPE_ENUM, OR_USE_TYPE_ENUM, OR_VEHICLE_TYPE_ENUM, OWNER_TYPES, OdometerValidity, PANDADOC_MAX_RETRIES, PAPERWORK_FEE, PAVE_BRAND_KEY, PAVE_OEM_ID, PAVE_OEM_KEY, PAYMENT_CHOICE_TITLES, PAYMENT_DESCRIPTION_TYPES, PAYMENT_INTENT_STATUS_TYPES, PAYMENT_METHOD_TYPES, PAYMENT_PLATFORM_TYPES, PAYMENT_RECEIPT_DISPUTE_STATUS, PAYMENT_RECEIPT_STATUS_TYPES, PAYMENT_RECIPIENTS, PAYMENT_SCHEDULE_FREQUENCIES, PAYMENT_SOURCES, PAYMENT_STATUS_ENUM, PAYMENT_TYPES, PA_BODY_TYPE_ID_ENUM, PA_FUEL_TYPE_ENUM, PA_REG_PERIOD_TYPE_ENUM, PA_USE_TYPE_ENUM, PA_VEHICLE_TYPE_ENUM, PICKMAN_OEM_ID, PICKMAN_OEM_KEY, PICK_UP_LOCATION_TYPE_ENUM, PINNED_OEM_KEY, PLACED_ORDER_EVENT_CODES, POWERPLUS_OEM_ID, POWERPLUS_OEM_KEY, PRECHECKOUT_PAYMENT_ID, PREORDER_PAYMENT_TYPES, PREQUAL_EXPIRY_MS, PREQUAL_OUTCOMES, PROMOTION_TYPES, QUEUE_OBJECT_ACTION_ENUM, QUEUE_POSITION_ENUM, REENGAGEMENT_MEDIUMS, REFUND_TYPES, RELOCATION_FLOWS, RELOC_MODAL_NAMES, RENA_BRAND_KEY, RENA_OEM_ID, RENA_OEM_KEY, REQUESTED_TITLE_TYPE_ENUM, RIC_NOTIFICATION_EXPIRATION_HOURS, RIC_VALID_LENGTH, RI_FUEL_TYPE_ENUM, RI_USE_TYPE_ENUM, RI_VEHICLE_TYPE_ENUM, ROBOTIC_SESSION_TYPES, ROBOTIC_SIGNING_STATUS, RON_SESSION_TYPES, RON_SIGNING_STATUS, RegistrationConstants, SARDINE_SESSION_KEY, SC_USE_TYPE_ENUM, SC_VEHICLE_TYPE_ENUM, SD_FUEL_TYPE_ENUM, SD_NUMBER_OF_WHEELS_ENUM, SD_USE_TYPE_ENUM, SD_VEHICLE_TYPE_ENUM, SENSITIVE_DATA_FIELDS, SHIPPING_LABEL_DIRECTIONS, SIG_FORM_TYPE_ENUM, SIG_WORKFLOW_TYPE, SMARTY_API_KEY, STACKING_BREAKPOINT, STAREV_BRAND_KEY, STAREV_OEM_ID, STAREV_OEM_KEY, STARK_HPS, STARK_OEM_ID, STARK_OEM_KEY, STATE_ABBREV_TO_STATE_NAME, STATE_DATA_TAR_PROCESS_KEYS, STATE_FORMS_SOURCE_TYPES, STRIPE_CREDIT_CARD_FEE_PERCENT, STRIPE_METADATA_FIELD_TYPES, STRIPE_PAYOUT_FEE_PERCENT, STRIPE_TRANSACTION_FEE_AMOUNT, SUPPORT_MODAL_STATE, SUPPORT_TOPICS, SVP_ID_TO_OEM_KEY_MAP, TAR_AGENT_ENUM, TAR_PREREQ_TO_FULFILL_ENUM, TAR_PROCESS_ENUM, TAR_PROCESS_TO_STATE_PROCESS_MAP_KEY, TAX_CONSTS, TITLING_AGENT_ENUM, TN_COLOR_ENUM, TN_USE_TYPE_ENUM, TN_VEHICLE_TYPE_ENUM, TRADE_IN_OPTIONS, TRANSACTION_STATUSES_AFTER_PREAUDIT_INITIATED, TRANSACTION_STATUS_ENUM, TWILIO_PROD_NUMBER, TWILIO_SMS_MESSAGES, TWILIO_TEST_NUMBER, TX_BODY_TYPE_ID_ENUM, TX_COLOR_ENUM, TX_FUEL_TYPE_ENUM, TX_USE_TYPE_ENUM, TX_VEHICLE_TYPE_ENUM, TYPE_OF_ORDER_ENUM, UT_FUEL_TYPE_ENUM, UT_PLATE_TYPE_ENUM, UT_REG_PERIOD_TYPE_ENUM, UT_USE_TYPE_ENUM, UT_VEHICLE_TYPE_ENUM, VA_BODY_TYPE_ENUM, VA_BODY_TYPE_ID_ENUM, VA_FUEL_TYPE_ENUM, VA_REG_PERIOD_TYPE_ENUM, VA_USE_TYPE_ENUM, VA_VEHICLE_TYPE_ENUM, VENTUS_BRAND_KEY, VENTUS_OEM_ID, VI_PROCESSING_FEE, VT_FUEL_TYPE_ENUM, VT_REG_PERIOD_TYPE_ENUM, VT_USE_TYPE_ENUM, VT_VEHICLE_TYPE_ENUM, ValidInsuranceTypesBasedOnVehicleType, VehicleCoverageCodes, VehicleCoverageFriendlyNames, WA_COLOR_ENUM, WA_FILING_TYPE_ENUM, WA_FUEL_TYPE_ENUM, WA_REG_SERVICE_TYPE_ENUM, WA_USE_TYPE_ENUM, WA_VEHICLE_TYPE_ENUM, WEB_INNER_SIDE_PADDING, WEB_OUTER_SIDE_PADDING, WEB_VERTICAL_PADDING, WI_COLOR_ENUM, WI_FUEL_TYPE_ENUM, WI_USE_TYPE_ENUM, WI_VEHICLE_TYPE_ENUM, WV_FUEL_TYPE_ENUM, WV_USE_TYPE_ENUM, WV_VEHICLE_TYPE_ENUM, WY_FUEL_TYPE_ENUM, WY_USE_TYPE_ENUM, WY_VEHICLE_TYPE_ENUM, ZERO_BRAND_KEY, ZERO_OEM_ID, ZERO_OEM_KEY, abbrevStateNamesArr, additionalFieldsMap, allSignaturePageNames, appConfigMap, appDevConfig, appE2etestoemConfig, appJanusConfig, appStagingConfig, canopyConnectAddressTypes, creditAppRejectionReasonLabel, demoAlgoliaConfig, developmentAlgoliaConfig, inspectionTypesEnum, insuranceMinimumLevelTypesEnum, insuranceMinimumLevels, insuranceReqTypes, isDisqualifyingFicoScoreUnavailableReason, isLenderDecisionStatus, localAlgoliaConfigMap, localWhitelist, oemMap, packetTypeForSigningPage, productionAlgoliaConfig, signaturePageMetadata, stagingAlgoliaConfig, supportsMultiVehicleCart, usStatesArray, usStatesForSelect, whitelistHubSpot, whitelistOEMSites, whitelistRetool, whitelistZapier };
//# sourceMappingURL=constants.js.map
